import { createTheme as createTheme$1, createComponent, markAsVisageComponent, useDesignSystem, resolveStyleSheets, useBreakpointManager, DesignSystem as DesignSystem$1 } from '@byteclaw/visage-core';
export { IsBreakpoint, createComponent, isVisageComponent, markAsVisageComponent, useBreakpoint, useDesignSystem } from '@byteclaw/visage-core';
import { useEventEmitter, useEventEmitterInstance, EventEmitterContext } from '@byteclaw/use-event-emitter';
import { useUniqueId as useUniqueId$1, UniqueIdContextProvider } from '@byteclaw/use-unique-id';
import React, { useEffect, useRef, useCallback, useMemo, Children, useState, cloneElement, useReducer, forwardRef, useContext, createContext, isValidElement, Fragment, memo, createElement } from 'react';
import { useStaticCallbackCreator } from '@byteclaw/use-static-callback';
import { disableBodyScroll as disableBodyScroll$1, enableBodyScroll } from 'body-scroll-lock';
import { getResponsiveValue, getScaleValue } from '@byteclaw/visage-utils';
import { createPortal } from 'react-dom';
import { keyframes, Global } from '@emotion/core';
import { getTrackBackground, Range } from 'react-range';
import { Direction } from 'react-range/lib/types';
import { css } from 'emotion';

var createTheme = createTheme$1;

function findMatchingSiblingElement(currentElement, condition,
/**
 * Look in previous siblings
 */
reverse) {
  if (reverse === void 0) {
    reverse = false;
  }

  var currentItem = currentElement;
  var found = false;

  do {
    currentItem = currentItem ? currentItem[reverse ? 'previousElementSibling' : 'nextElementSibling'] : null;
    found = currentItem ? condition(currentItem) : false;
  } while (!found && currentItem);

  return currentItem;
}
function findPreviousMatchingSiblingElement(currentElement, condition) {
  return findMatchingSiblingElement(currentElement, condition, true);
}
function findNextMatchingSiblingElement(currentElement, condition) {
  return findMatchingSiblingElement(currentElement, condition);
}

function getNextIndexFromCycle(currentIndex, offset, lastIndex) {
  if (currentIndex < -1 || currentIndex > lastIndex) {
    // eslint-disable-next-line no-param-reassign
    currentIndex = offset > 0 ? -1 : lastIndex + 1;
  }

  var newIndex = currentIndex + offset;

  if (newIndex < 0) {
    return lastIndex;
  }

  if (newIndex > lastIndex) {
    return 0;
  }

  return newIndex;
}

function normalizeKeyboardEventKey(event) {
  var key = event.key,
      keyCode = event.keyCode;

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  if (key === 'Esc') {
    return 'Escape';
  }

  return key;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded = ["anchor", "placementAndOrigin"];
function getOffsetTop(element, vertical, transformY) {
  if (vertical === void 0) {
    vertical = 'top';
  }

  if (transformY === void 0) {
    transformY = 0;
  }

  var offset = 0;
  var height = element instanceof HTMLElement ? element.offsetHeight : element.height;

  if (vertical === 'center') {
    offset = height / 2;
  } else if (vertical === 'bottom') {
    offset = height;
  }

  return offset + transformY;
}
function getOffsetLeft(element, horizontal, transformX) {
  if (horizontal === void 0) {
    horizontal = 'left';
  }

  if (transformX === void 0) {
    transformX = 0;
  }

  var offset = 0;
  var width = element instanceof HTMLElement ? element.offsetWidth : element.width;

  if (horizontal === 'center') {
    offset = width / 2;
  } else if (horizontal === 'right') {
    offset = width;
  }

  return offset + transformX;
}
function applyAnchorOrigin(anchor, anchorOrigin) {
  return {
    left: anchor.left + getOffsetLeft(anchor, anchorOrigin.horizontal, anchorOrigin.transformX),
    top: anchor.top + getOffsetTop(anchor, anchorOrigin.vertical, anchorOrigin.transformY)
  };
}
/**
 * Returns anchor position relative to viewport
 */

function getAnchorPositionAndDimensions(anchor) {
  if (anchor instanceof HTMLElement) {
    var anchorRect = anchor.getBoundingClientRect();
    return {
      top: anchorRect.top,
      left: anchorRect.left,
      height: anchorRect.height,
      width: anchorRect.width
    };
  }

  return _extends({}, anchor, {
    height: 0,
    width: 0
  });
}
/**
 * Placement says where in the Element anchor element is positioned, first word is vertical origin and second is horizontal
 */

var Placement;

(function (Placement) {
  Placement["topCenter"] = "top-center";
  Placement["topLeft"] = "top-left";
  Placement["topRight"] = "top-right";
  Placement["bottomCenter"] = "bottom-center";
  Placement["bottomLeft"] = "bottom-left";
  Placement["bottomRight"] = "bottom-right";
  Placement["centerLeft"] = "center-left";
  Placement["centerRight"] = "center-right";
  Placement["centerCenter"] = "center-center";
})(Placement || (Placement = {}));

function computePositionAndDimensions(viewport,
/**
 * Anchor position with anchor origin already applied
 *
 * Position is relative to viewport
 */
anchor,
/**
 * Element rect relative to viewport
 */
element, placement, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$marginThreshold = _ref.marginThreshold,
      marginThreshold = _ref$marginThreshold === void 0 ? 0 : _ref$marginThreshold,
      minHeight = _ref.minHeight,
      minWidth = _ref.minWidth;

  var top = anchor.top + viewport.scrollY;
  var left = anchor.left + viewport.scrollX;
  var topMarginThreshold = viewport.scrollY + marginThreshold;
  var leftMarginThreshold = viewport.scrollX + marginThreshold;
  var elementWidth = element.width;
  var elementHeight = element.height; // now based on placement, compute available region based on anchor position and viewport information

  switch (placement) {
    case Placement.topLeft:
      {
        // we want an anchor to be in top left corner of an element
        var height = Math.max(Math.min(viewport.height - marginThreshold - anchor.top, elementHeight), 0);
        var width = Math.max(Math.min(viewport.width - marginThreshold - anchor.left, elementWidth), 0);
        var mHeight = Math.min(minHeight != null ? minHeight : 0, elementHeight);
        var mWidth = Math.min(minWidth != null ? minWidth : 0, elementWidth);
        return {
          matches: width > 0 && height > 0 && mHeight <= height && mWidth <= width && top >= topMarginThreshold && left >= leftMarginThreshold,
          height: height,
          width: width,
          left: left,
          top: top,
          minHeight: Math.max(minHeight != null ? minHeight : height, height),
          minWidth: Math.max(minWidth != null ? minWidth : width, width)
        };
      }

    case Placement.topRight:
      {
        // we want an anchor to be in top right corner of an element
        var _height = Math.max(Math.min(viewport.height - marginThreshold - anchor.top, elementHeight), 0);

        var _width = Math.max(Math.min(anchor.left - marginThreshold, elementWidth), 0);

        var _mHeight = Math.min(minHeight != null ? minHeight : 0, elementHeight);

        var _mWidth = Math.min(minWidth != null ? minWidth : 0, elementWidth);

        var x = left - _width;
        return {
          matches: _width > 0 && _height > 0 && _mHeight <= _height && _mWidth <= _width && top >= topMarginThreshold && x >= leftMarginThreshold,
          height: _height,
          width: _width,
          top: top,
          left: x,
          minHeight: Math.max(minHeight != null ? minHeight : _height, _height),
          minWidth: Math.max(minWidth != null ? minWidth : _width, _width)
        };
      }

    case Placement.topCenter:
      {
        // we want an anchor to be in the center of the top edge of an element
        var _height2 = Math.max(Math.min(viewport.height - marginThreshold - anchor.top, elementHeight), 0);

        var halfEdge = elementWidth / 2;

        var _width2 = Math.max(Math.min(anchor.left - marginThreshold, viewport.width - marginThreshold - anchor.left, halfEdge) * 2, 0);

        var _mHeight2 = Math.min(minHeight != null ? minHeight : 0, elementHeight);

        var _mWidth2 = Math.min(minWidth != null ? minWidth : 0, elementWidth);

        var _x = left - _width2 / 2;

        return {
          matches: _height2 > 0 && _width2 > 0 && _mHeight2 <= _height2 && _mWidth2 <= _width2 && top >= topMarginThreshold && _x >= leftMarginThreshold,
          height: _height2,
          width: _width2,
          left: _x,
          top: top,
          minHeight: Math.max(minHeight != null ? minHeight : _height2, _height2),
          minWidth: Math.max(minWidth != null ? minWidth : _width2, _width2)
        };
      }

    case Placement.bottomLeft:
      {
        // we want an anchor to be in the bottom left corner of an element
        var _height3 = Math.max(Math.min(anchor.top - marginThreshold, elementHeight), 0);

        var _width3 = Math.max(Math.min(viewport.width - marginThreshold - anchor.left, elementWidth), 0);

        var _mHeight3 = Math.min(minHeight != null ? minHeight : 0, elementHeight);

        var _mWidth3 = Math.min(minWidth != null ? minWidth : 0, elementWidth);

        var y = top - _height3;
        return {
          matches: _height3 > 0 && _width3 > 0 && _mHeight3 <= _height3 && _mWidth3 <= _width3 && y >= topMarginThreshold && left >= leftMarginThreshold,
          left: left,
          top: y,
          height: _height3,
          width: _width3,
          minHeight: Math.max(minHeight != null ? minHeight : _height3, _height3),
          minWidth: Math.max(minWidth != null ? minWidth : _width3, _width3)
        };
      }

    case Placement.bottomRight:
      {
        // we want an anchor to be in the bottom right corner of an element
        var _width4 = Math.max(Math.min(anchor.left - marginThreshold, elementWidth), 0);

        var _height4 = Math.max(Math.min(anchor.top - marginThreshold, elementHeight), 0);

        var _mHeight4 = Math.min(minHeight != null ? minHeight : 0, elementHeight);

        var _mWidth4 = Math.min(minWidth != null ? minWidth : 0, elementWidth);

        var _x2 = left - _width4;

        var _y = top - _height4;

        return {
          matches: _height4 > 0 && _width4 > 0 && _mHeight4 <= _height4 && _mWidth4 <= _width4 && _x2 >= leftMarginThreshold && _y >= topMarginThreshold,
          top: _y,
          left: _x2,
          height: _height4,
          width: _width4,
          minWidth: Math.max(minWidth != null ? minWidth : _width4, _width4),
          minHeight: Math.max(minHeight != null ? minHeight : _height4, _height4)
        };
      }

    case Placement.bottomCenter:
      {
        // we want an anchor to be in the center of the bottom edge of an element
        var _halfEdge = elementWidth / 2;

        var _width5 = Math.max(Math.min(anchor.left - marginThreshold, viewport.width - marginThreshold - anchor.left, _halfEdge) * 2, 0);

        var _height5 = Math.max(Math.min(anchor.top - marginThreshold, elementHeight), 0);

        var _mHeight5 = Math.min(minHeight != null ? minHeight : 0, elementHeight);

        var _mWidth5 = Math.min(minWidth != null ? minWidth : 0, elementWidth);

        var _x3 = left - _width5 / 2;

        var _y2 = top - _height5;

        return {
          matches: _height5 > 0 && _width5 > 0 && _mWidth5 <= _width5 && _mHeight5 <= _height5 && _x3 >= leftMarginThreshold && _y2 >= topMarginThreshold,
          left: _x3,
          top: _y2,
          height: _height5,
          width: _width5,
          minHeight: Math.max(minHeight != null ? minHeight : _height5, _height5),
          minWidth: Math.max(minWidth != null ? minWidth : _width5, _width5)
        };
      }

    case Placement.centerCenter:
      {
        // we want an anchor to be in the vertical and horizontal center of an element
        var halfHeight = elementHeight / 2;
        var halfWidth = elementWidth / 2;

        var _height6 = Math.max(Math.min(anchor.top - marginThreshold, viewport.height - marginThreshold - anchor.top, halfHeight) * 2, 0);

        var _width6 = Math.max(Math.min(anchor.left - marginThreshold, viewport.width - marginThreshold - anchor.left, halfWidth) * 2, 0);

        var _mHeight6 = Math.min(minHeight != null ? minHeight : 0, elementHeight);

        var _mWidth6 = Math.min(minWidth != null ? minWidth : 0, elementWidth);

        var _x4 = left - _width6 / 2;

        var _y3 = top - _height6 / 2;

        return {
          matches: _height6 > 0 && _width6 > 0 && _mWidth6 <= _width6 && _mHeight6 <= _height6 && _x4 >= leftMarginThreshold && _y3 >= topMarginThreshold,
          left: _x4,
          top: _y3,
          height: _height6,
          width: _width6,
          minHeight: Math.max(minHeight != null ? minHeight : _height6, _height6),
          minWidth: Math.max(minWidth != null ? minWidth : _width6, _width6)
        };
      }

    case Placement.centerLeft:
      {
        // we want an anchor to be in the vertical center of the left edge of an element
        var _halfHeight = elementHeight / 2;

        var _width7 = Math.max(Math.min(viewport.width - marginThreshold - anchor.left, elementWidth), 0);

        var _height7 = Math.max(Math.min(anchor.top - marginThreshold, viewport.height - marginThreshold - anchor.top, _halfHeight) * 2, 0);

        var _mHeight7 = Math.min(minHeight != null ? minHeight : 0, elementHeight);

        var _mWidth7 = Math.min(minWidth != null ? minWidth : 0, elementWidth);

        var _y4 = top - _height7 / 2;

        return {
          matches: _height7 > 0 && _width7 > 0 && _mHeight7 <= _height7 && _mWidth7 <= _width7 && _y4 >= topMarginThreshold && left >= leftMarginThreshold,
          top: _y4,
          left: left,
          height: _height7,
          width: _width7,
          minWidth: Math.max(minWidth != null ? minWidth : _width7, _width7),
          minHeight: Math.max(minHeight != null ? minHeight : _height7, _height7)
        };
      }

    case Placement.centerRight:
      {
        // we want an anchor to be in the vertical center of the right edge of an element
        var _halfHeight2 = elementHeight / 2;

        var _width8 = Math.max(Math.min(anchor.left - marginThreshold, elementWidth), 0);

        var _height8 = Math.max(Math.min(anchor.top - marginThreshold, viewport.height - marginThreshold - anchor.top, _halfHeight2) * 2, 0);

        var _mHeight8 = Math.min(minHeight != null ? minHeight : 0, elementHeight);

        var _mWidth8 = Math.min(minWidth != null ? minWidth : 0, elementWidth);

        var _y5 = top - _height8 / 2;

        var _x5 = left - _width8;

        return {
          matches: _height8 > 0 && _width8 > 0 && _mHeight8 <= _height8 && _mWidth8 <= _width8 && _y5 >= topMarginThreshold && _x5 >= leftMarginThreshold,
          top: _y5,
          left: _x5,
          height: _height8,
          width: _width8,
          minWidth: Math.max(minWidth != null ? minWidth : _width8, _width8),
          minHeight: Math.max(minHeight != null ? minHeight : _height8, _height8)
        };
      }

    default:
      {
        throw new TypeError("Invalid Placement type: " + placement);
      }
  }
}
/**
 * Computes positioning styles for an element
 *
 * Algorithm tries to match placements and their respective origins in the order
 * they were specified.
 *
 * If placement matches constraints (minHeight, minWidth) then it is used.
 *
 * Constraints don't have anything to do with styles, they're just required minimum dimensions
 * that needs to be available in a given placement region to consider it as matched.
 *
 * Min height constraint is used only if height of an element is higher or equal to it, othwerise
 * it uses the element height. Same rules apply to min width constraints too.
 *
 * Computed width and height should be considered as maxWidth and maxHeight in css. So it is possible
 * for a developer to limit them in CSS.
 */

function computePositioningStyles(viewport, element, _ref2) {
  var anchor = _ref2.anchor,
      placementAndOrigin = _ref2.placementAndOrigin,
      constraints = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var view = {
    height: viewport.height,
    width: viewport.width,
    scrollX: viewport.offsetLeft,
    scrollY: viewport.offsetTop,
    maxHeight: viewport.maxHeight,
    maxWidth: viewport.maxWidth
  };
  var anchorPositionAndDimensions = getAnchorPositionAndDimensions(anchor);
  var clientRect = element.getBoundingClientRect();
  var rect = {
    height: Math.ceil(clientRect.height),
    width: Math.ceil(clientRect.width),
    scrollHeight: element.scrollHeight,
    scrollWidth: element.scrollWidth
  };
  var intermediateValue; // try to compute positions based on placementAndOrigin

  for (var _iterator = _createForOfIteratorHelperLoose(placementAndOrigin), _step; !(_step = _iterator()).done;) {
    var placementSettings = _step.value;
    var anchorPosition = applyAnchorOrigin(anchorPositionAndDimensions, placementSettings);
    var newValue = computePositionAndDimensions(view, anchorPosition, rect, placementSettings.placement, constraints); // detect if region matches contstraints and return immediately if it so

    if (newValue.matches) {
      intermediateValue = _extends({
        placement: placementSettings.placement
      }, newValue);
      break;
    } // othwerwise use this value only if is better than previous


    if (intermediateValue == null || intermediateValue.height < newValue.height || intermediateValue.width < newValue.width) {
      intermediateValue = _extends({
        placement: placementSettings.placement
      }, newValue);
    }
  }

  if (intermediateValue == null) {
    throw new Error('Positioning styles are not resolved. Probably placement array is empty');
  }

  return _extends({}, intermediateValue, {
    height: Math.ceil(intermediateValue.height),
    width: Math.ceil(intermediateValue.width),
    minHeight: Math.ceil(intermediateValue.minHeight),
    minWidth: Math.ceil(intermediateValue.minWidth)
  });
}

/**
 * Creates boolean variant settings for component
 */
function booleanVariant(name,
/** Strip the prop from HTML element? */
stripProp,
/** Default value, if undefined, false will be used */
defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }

  return {
    prop: name,
    name: name.toLowerCase(),
    stripProp: stripProp,
    defaultValue: defaultValue
  };
}
/**
 * Creates a number prop for component
 */

function numberProp(name,
/** Strip the prop from HTML element? */
stripProp, defaultValue) {
  return {
    prop: name,
    name: name.toLowerCase(),
    stripProp: stripProp,
    defaultValue: defaultValue
  };
}
/**
 * Creates variant settings for component
 */

function variant(name,
/** Strip the prop from HTML element? */
stripProp, // eslint-disable-next-line
variants,
/**
 * Default value, if omitted "default" is used
 */
defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = 'default';
  }

  return {
    prop: name,
    name: name.toLowerCase(),
    stripProp: stripProp,
    defaultValue: defaultValue
  };
}
/**
 * Creats boolean variant styles for face/component styles
 */

function booleanVariantStyles(name, styles) {
  var attrName = name.toLowerCase();
  var styleSheet = {};

  if (styles.on) {
    styleSheet["&[data-" + attrName + "=\"true\"]"] = styles.on;
  }

  if (styles.off) {
    styleSheet["&[data-" + attrName + "=\"false\"]"] = styles.off;
  }

  return styleSheet;
}
/**
 * Creats variants for face/component styles
 */

function variantStyles(name, styles) {
  var attrName = name.toLowerCase();
  return Object.keys(styles).reduce(function (styleSheet, key) {
    var _extends2;

    return _extends({}, styleSheet, (_extends2 = {}, _extends2["&[data-" + attrName + "=\"" + key + "\"]"] = styles[key], _extends2));
  }, {});
}

/**
 * Control focus shadow that is used to compose actual focus shadow (needs a color at the end)
 *
 * The white color works as some sort of opacity
 */

var controlFocusShadow = '0 0 0 4px rgba(255, 255, 255, 0.4), 0 0 0 4px';
var controlHoverShadow = 'inset 0 0 200px rgba(68, 68, 68, 0.1)';
var controlActiveShadow = 'inset 0 0 200px rgba(68, 68, 68, 0.2), inset 0 0 2px rgba(0, 0, 0, 0.2)';
var createSurfaceFocusShadow = function createSurfaceFocusShadow(color, withHoverShadow) {
  if (color === void 0) {
    color = 'accent';
  }

  if (withHoverShadow === void 0) {
    withHoverShadow = true;
  }

  return withHoverShadow ? controlFocusShadow + " " + color + ", " + controlHoverShadow : controlFocusShadow + " " + color;
};
var createControlFocusShadow = function createControlFocusShadow(color) {
  if (color === void 0) {
    color = 'accent';
  }

  return controlFocusShadow + " " + color;
};
var createControlHoverShadow = function createControlHoverShadow() {
  return controlHoverShadow;
};
var createControlActiveShadow = function createControlActiveShadow(color) {
  if (color === void 0) {
    color = 'accent';
  }

  return controlFocusShadow + " " + color + " , " + controlActiveShadow;
};
var visuallyHiddenStyles = {
  border: '0',
  clip: 'rect(0, 0, 0, 0)',
  height: '1px',
  overflow: 'hidden',
  margin: '-1px',
  padding: '0px',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
};
var disabledControlStyles = {
  cursor: 'default',
  pointerEvents: 'none',
  // applicable to textarea
  resize: 'none',
  opacity: 0.5
};
var invalidControlStyles = {
  borderColor: 'danger',
  borderWidth: '2px',
  // data-focused is used by text input on base
  '&:focus, &[data-focused="true"]': {
    boxShadow: /*#__PURE__*/createControlFocusShadow('danger')
  },
  // checkbox and radio
  '&::before': {
    borderColor: 'danger',
    borderWidth: '2px'
  }
};
/**
 * Uses hidden prop to visually hide element
 * hidden prop is then stripped from underlying component
 */

var visuallyHiddenBooleanVariant = /*#__PURE__*/booleanVariant('hidden', true);
/**
 * Used to mark form control as disabled and keeps disabled prop
 */

var disabledControlBooleanVariant = /*#__PURE__*/booleanVariant('disabled', false);
/**
 * Used to mark form control as invalid and strips the prop
 */

var invalidControlBooleanVariant = /*#__PURE__*/booleanVariant('invalid', true);

/**
 * Creates a static effect that is called with provided args
 */

function useStaticEffect(effectFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  useEffect(function () {
    return effectFn.apply(void 0, args); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effectFn].concat(args));
}

function focusElementOnMount(elementToFocusRef,
/** Should we focus element? */
focus) {
  if (focus && elementToFocusRef && elementToFocusRef.current) {
    elementToFocusRef.current.focus();
  }
}
/**
 * Autofocuses element on mount
 */


function useAutofocusOnMount(ref,
/** Should we focus element? */
focus) {
  if (focus === void 0) {
    focus = true;
  }

  useStaticEffect(focusElementOnMount, ref, focus);
}

/**
 * Sets up breakpoint detection using window.matchMedia API
 */

function useBreakpointDetection(enabled, breakpoints, setBreakpoint) {
  return useEffect(function () {
    if (!enabled) {
      return;
    }

    var mediaQueryList = [];

    if (typeof window !== 'undefined' && window.matchMedia) {
      var matches = breakpoints.map(function (mediaQuery, mqIndex) {
        var mqList = window.matchMedia(mediaQuery);

        var listener = function listener(e) {
          setBreakpoint(mqIndex, e.matches);
        }; // register media query listener


        mqList.addListener(listener); // push listener to mediaQueryList

        mediaQueryList.push({
          list: mqList,
          listener: listener
        });
        return mqList.matches;
      }); // set initial matches

      matches.forEach(function (match, index) {
        return setBreakpoint(index, match);
      });
      return function () {
        mediaQueryList.forEach(function (_ref) {
          var list = _ref.list,
              listener = _ref.listener;
          return list.removeListener(listener);
        });
      };
    }
  }, [enabled, breakpoints, setBreakpoint]);
}

/**
 * Reflects local ref to outside one
 */
function useCombinedRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (element) {
    for (var _iterator = _createForOfIteratorHelperLoose(refs), _step; !(_step = _iterator()).done;) {
      var ref = _step.value;

      if (typeof ref === 'function') {
        ref(element);
      } else if (ref && typeof ref === 'object') {
        ref.current = element;
      }
    }
  };
}

function composeHandler() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    handlers.forEach(function (handler) {
      if (handler) {
        handler.apply(void 0, args);
      }
    });
  };
}

function useComposedCallbackCreator() {
  for (var _len3 = arguments.length, callbacks = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    callbacks[_key3] = arguments[_key3];
  }

  return useStaticCallbackCreator(composeHandler, callbacks);
}

function useDebouncedCallback(callback, delay, deps) {
  var callbackRef = useRef(null);
  var currentTimeout = useRef();
  var cancel = useCallback(function () {
    clearTimeout(currentTimeout.current);
  }, []);
  callbackRef.current = callback; // cancel timeout if unmounted

  useEffect(function () {
    return function () {
      clearTimeout(currentTimeout.current);
    };
  }, []);
  var debouncedCallback = useCallback(function () {
    clearTimeout(currentTimeout.current);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    currentTimeout.current = setTimeout.apply(void 0, [function () {
      if (callbackRef.current) {
        callbackRef.current.apply(callbackRef, arguments);
      }
    }, delay].concat(args));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [delay].concat(deps));
  return [debouncedCallback, cancel];
}

function focusTrap(contentRef, toFocusElementRef) {
  return function (e) {
    if (contentRef.current && contentRef.current.contains(e.target) === false) {
      e.preventDefault(); // return focus back to element

      if (toFocusElementRef && toFocusElementRef.current) {
        toFocusElementRef.current.focus();
      }
    }
  };
}

function registerFocusTrap(focusTrapHandler) {
  if (typeof document === 'undefined') {
    return;
  }

  document.addEventListener('focus', focusTrapHandler, true);
  return function () {
    document.removeEventListener('focus', focusTrapHandler, true);
  };
}
/**
 * Creates a focus trap callback that can be used as an event handler for focus events
 */


function useFocusTrapCallback(
/**
 * The ref object to content inside which we should trap the focus
 */
contentRef,
/**
 * Element to focus inside if we lose focus
 */
toFocusElementRef) {
  return useStaticCallbackCreator(focusTrap, [contentRef, toFocusElementRef]);
}
/**
 * Registers a focus trap
 */

function useFocusTrap(
/**
 * The ref object to content inside which we should trap the focus
 */
contentRef,
/**
 * Element to focus inside if we lose focus
 */
toFocusElementRef) {
  var focusTrapListener = useFocusTrapCallback(contentRef, toFocusElementRef);
  useStaticEffect(registerFocusTrap, focusTrapListener);
}

/**
 * Creates an immutable handler that delegates a call to callback
 */

function useHandlerRef(cb) {
  var cbRef = useRef(cb);
  cbRef.current = cb; // eslint-disable-next-line react-hooks/exhaustive-deps

  return useCallback(function () {
    return cbRef.current.apply(cbRef, arguments);
  }, []);
}

/**
 * Works similarly as useEffect except it runs effect before children are rendered
 * And then cleans them up in same order as useEffect works
 *
 * So basically mount works from parent to child and unmount in opposite order
 *
 * Effect is not invalidated on function change
 */

function useOnRenderEffect(effect, dependencies) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var unregister = useMemo(effect, dependencies);
  useEffect(function () {
    return unregister;
  }, [unregister]);
}
/**
 * Works similarly as useEffect except it runs effect before children are rendered
 * And then cleans them up in same order as useEffect works
 *
 * So basically mount works from parent to child and unmount in opposite order
 */

function useStaticOnRenderEffect(effect) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var unregister = useMemo(function () {
    return effect.apply(void 0, args);
  }, [effect].concat(args));
  useEffect(function () {
    return unregister;
  }, [unregister]);
}

/**
 * Generates unique prefixed id if id is not provided
 */

function useUniqueId(id, prefix) {
  var generatedId = useUniqueId$1();
  var idRef = useRef(id || prefix + "-" + generatedId);
  return idRef.current.toString();
}

var AccordionTrigger = /*#__PURE__*/createComponent('div', {
  displayName: 'AccordionTrigger',
  styles: {
    borderColor: 'transparent',
    borderWidth: 0,
    backgroundColor: 'transparent',
    borderBottomColor: 'neutral',
    borderBottomWidth: 1,
    borderStyle: 'solid',
    cursor: 'pointer',
    display: 'flex',
    fontSize: 1,
    fontFamily: 'heading',
    fontWeight: 'bolder',
    lineHeight: 1,
    outline: 'none',
    m: 0,
    p: 0,
    py: 1,
    width: '100%',
    '&:focus': {
      boxShadow: /*#__PURE__*/createControlFocusShadow(),
      zIndex: 1
    },
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow()
    }
  },
  defaultProps: {
    role: 'button'
  }
});
var AccordionRegion = /*#__PURE__*/createComponent('div', {
  displayName: 'AccordionRegion',
  styles: function styles(props) {
    return {
      height: props.open ? 'auto' : 0,
      opacity: props.open ? 1 : 0,
      m: 0,
      p: 0,
      py: props.open ? 1 : 0,
      visibility: props.open ? 'visible' : 'hidden',
      transition: 'height cubic-bezier(0.2, 0, 0.38, 0.9) 110ms, padding cubic-bezier(0.2, 0, 0.38, 0.9) 110ms'
    };
  },
  defaultProps: {
    role: 'region'
  },
  variants: [/*#__PURE__*/booleanVariant('open', true)]
});
function AccordionItem(_ref) {
  var children = _ref.children,
      onTriggerClick = _ref.onTriggerClick,
      onTriggerKeyDown = _ref.onTriggerKeyDown,
      open = _ref.open,
      regionId = _ref.regionId,
      regionProps = _ref.regionProps,
      title = _ref.title,
      triggerId = _ref.triggerId,
      triggerProps = _ref.triggerProps;
  return React.createElement(React.Fragment, null, React.createElement(AccordionTrigger, Object.assign({}, regionProps, {
    "aria-controls": regionId,
    "aria-expanded": open,
    id: triggerId,
    onClick: onTriggerClick,
    onKeyDown: onTriggerKeyDown,
    tabIndex: 0
  }), title), React.createElement(AccordionRegion, Object.assign({}, triggerProps, {
    "aria-labelledby": triggerId,
    id: regionId,
    open: open
  }), typeof children === 'function' ? children() : children));
}
function Accordion(_ref2) {
  var children = _ref2.children,
      id = _ref2.id;
  var accordionId = useUniqueId(id, 'accordion');
  var items = Children.toArray(children);
  var controlledIndex = useMemo(function () {
    return items.findIndex(function (item) {
      return item.props.open;
    }); // items depends on children, so we need just children
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children]);

  var _useState = useState(controlledIndex !== -1 ? controlledIndex : 0),
      openItem = _useState[0],
      setOpenItem = _useState[1]; // if out of bounds or is different than currently set


  if (openItem >= items.length || openItem < 0) {
    setOpenItem(0);
  } else if (controlledIndex !== -1 && controlledIndex !== openItem) {
    setOpenItem(controlledIndex);
  }

  return React.createElement(React.Fragment, null, items.map(function (item, i) {
    return cloneElement(item, {
      regionId: accordionId + "-" + i + "-region",
      triggerId: accordionId + "-" + i + "-trigger",
      open: openItem === i,
      onTriggerClick: function onTriggerClick(e) {
        setOpenItem(i);

        if (item.props.onTriggerClick) {
          item.props.onTriggerClick(e);
        }

        if (item.props.onOpen) {
          item.props.onOpen(i);
        }
      },
      onTriggerKeyDown: function onTriggerKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setOpenItem(i);

          if (item.props.onOpen) {
            item.props.onOpen(i);
          }
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          e.preventDefault();
          var itemToFocus = document.getElementById(accordionId + "-" + getNextIndexFromCycle(i, e.key === 'ArrowUp' ? -1 : 1, items.length - 1) + "-trigger");

          if (itemToFocus) {
            itemToFocus.focus();
          }
        } else if (e.key === 'Home' || e.key === 'End') {
          e.preventDefault();

          var _itemToFocus = document.getElementById(accordionId + "-" + (e.key === 'Home' ? 0 : items.length - 1) + "-trigger");

          if (_itemToFocus) {
            _itemToFocus.focus();
          }
        }

        if (item.props.onTriggerKeyDown) {
          item.props.onTriggerKeyDown(e);
        }
      }
    });
  }));
}

function initSelectorReducer(_ref) {
  var _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      optionToString = _ref.optionToString,
      valueToString = _ref.valueToString,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value;
  var val = value || defaultValue;

  var optToString = optionToString || function (option) {
    return "" + option;
  };

  return {
    defaultValue: defaultValue,
    focusedIndex: -1,
    inputValue: val == null ? '' : optToString(val),
    isBusy: false,
    isFocused: false,
    isOpen: false,
    options: [],
    optionToString: optToString,
    valueToString: valueToString || optToString,
    value: val,
    invokedBy: {
      type: 'Unknown'
    }
  };
}

function selectorReducer(state, action) {
  var changes = {
    invokedBy: action
  }; // following are possible only if menu is open

  if (state.isOpen) {
    switch (action.type) {
      case 'SetOptionFocusByIndex':
        {
          var optionsSize = state.options.length;

          if (optionsSize > 0 && action.index < optionsSize && action.index >= 0) {
            changes = _extends({}, changes, {
              focusedIndex: action.index
            });
          }

          break;
        }

      case 'SetOptionFocusByOffset':
        {
          var lastIndex = state.options.length - 1;
          changes = _extends({}, changes, {
            focusedIndex: getNextIndexFromCycle(state.focusedIndex, action.offset, lastIndex)
          });
          break;
        }

      case 'SetOptionFocusToFirstOption':
        {
          if (state.options.length > 0) {
            changes = _extends({}, changes, {
              focusedIndex: 0
            });
          }

          break;
        }

      case 'SetOptionFocusToLastOption':
        {
          if (state.options.length > 0) {
            changes = _extends({}, changes, {
              focusedIndex: state.options.length - 1
            });
          }

          break;
        }
    }
  }

  switch (action.type) {
    case 'Blur':
    case 'Focus':
      {
        changes = _extends({}, changes, {
          isFocused: action.type !== 'Blur'
        });
        break;
      }

    case 'InputChange':
      {
        changes = _extends({}, changes, {
          inputValue: action.value
        });
        break;
      }

    case 'MenuToggle':
    case 'MenuClose':
    case 'MenuOpen':
      {
        changes = _extends({}, changes, {
          isOpen: action.type === 'MenuToggle' ? !state.isOpen : action.type === 'MenuOpen',
          focusedIndex: -1
        });
        break;
      }

    case 'Reset':
      {
        changes = _extends({}, changes, {
          isBusy: false,
          isOpen: false,
          focusedIndex: -1,
          options: [],
          inputValue: state.defaultValue ? state.valueToString(state.defaultValue) : '',
          value: state.defaultValue
        });
        break;
      }

    case 'SetBusy':
      {
        // turn off busy state only if input matches
        if (action.isBusy || action.forInputValue === state.inputValue) {
          changes = _extends({}, changes, {
            isBusy: action.isBusy
          });
        }

        break;
      }

    case 'SetOptions':
      {
        // set options only if input value matches
        if (action.forInputValue === state.inputValue) {
          changes = _extends({}, changes, {
            focusedIndex: -1,
            options: action.options
          });
        }

        break;
      }

    case 'SetCurrentFocusedOption':
      {
        if (state.focusedIndex > -1 && state.options.length > state.focusedIndex) {
          var value = state.options[state.focusedIndex];
          changes = _extends({}, changes, {
            inputValue: state.valueToString(value),
            value: value
          });
        }

        break;
      }

    case 'SetValueByIndex':
      {
        if (action.index >= 0 && state.options.length > action.index) {
          var _value = state.options[action.index];
          changes = _extends({}, changes, {
            inputValue: state.valueToString(_value),
            value: _value
          });
        }

        break;
      }

    case 'SetValue':
      {
        changes = _extends({}, changes, {
          inputValue: action.value == null ? '' : state.valueToString(action.value),
          value: action.value
        });
        break;
      }
  }

  return _extends({}, state, changes);
}

function useSelector(_ref2) {
  var defaultValue = _ref2.defaultValue,
      enhanceReducer = _ref2.enhanceReducer,
      onInputValueChange = _ref2.onInputValueChange,
      onChange = _ref2.onChange,
      onStateChange = _ref2.onStateChange,
      optionToString = _ref2.optionToString,
      value = _ref2.value,
      valueToString = _ref2.valueToString;
  var reducer = useCallback(function (state, action) {
    var nextState = selectorReducer(state, action);
    return enhanceReducer ? enhanceReducer(state, nextState) : nextState;
  }, [enhanceReducer]);

  var _useReducer = useReducer(reducer, {
    defaultValue: defaultValue,
    optionToString: optionToString,
    value: value,
    valueToString: valueToString
  }, initSelectorReducer),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var previousState = useRef(state);
  var previousOuterValue = useRef(value);

  if (previousState.current !== state) {
    // call on state change if state has changed
    if (onStateChange) {
      onStateChange(previousState.current, state, dispatch);
    } // call onInputValueChange if inputValue changed


    if (previousState.current.inputValue !== state.inputValue) {
      if (onInputValueChange) {
        onInputValueChange(state.inputValue);
      }
    } // call onChange if value changed


    if (previousState.current.value !== state.value && state.value !== value && onChange) {
      onChange(state.value);
    }

    previousState.current = state;
  } else if (previousOuterValue.current !== value) {
    // if outer value changed (controlled component), set the value to this value
    dispatch({
      type: 'SetValue',
      value: value
    });
  }

  return [state, dispatch];
}

/** Scrolls aria-selected="true" child of container identified by ref into view */

function scrollAriaSelectedElementToView(containerRef, // we don't use this but we need this for effect to be invoked
// eslint-disable-next-line
index) {
  var current = containerRef.current;

  if (!current) {
    return;
  }

  var selectedItem = current.querySelector('[aria-selected="true"]');

  if (selectedItem) {
    var containerScrollTop = current.scrollTop;
    var containerHeight = current.offsetHeight;
    var isVisible = selectedItem.offsetTop >= containerScrollTop && selectedItem.offsetTop <= containerScrollTop + containerHeight;

    if (!isVisible) {
      current.scrollTop = selectedItem.offsetTop;
    }
  }
}
/**
 * Disables body scroll if disabled is true
 */

function disableBodyScroll(_ref, disabled) {
  var current = _ref.current;

  if (!disabled || !current) {
    return;
  }

  disableBodyScroll$1(current, {
    allowTouchMove: function allowTouchMove(el) {
      // allow to scroll children on iOS
      if (current.contains(el)) {
        return true;
      }

      return false;
    }
  });
  return function () {
    return enableBodyScroll(current);
  };
}
/**
 * Detects if radio is checked or unchecked if radio is not controlled
 */

function detectRadioCheckedState(radioRef, isControlled, isReadOnly, setChecked) {
  // if input is controlled, we don't want to use internal state
  if (isControlled || isReadOnly || typeof document === 'undefined') {
    return;
  }

  var onChangeListener = function onChangeListener(_ref2) {
    var target = _ref2.target;
    // if target is input with radio type, check if the name is the same as with radioRef
    // and if the form is same
    var current = radioRef.current;

    if (!current) {
      return;
    }

    if (target instanceof HTMLInputElement && target.type === 'radio') {
      // if target is the same as ref, then we checked the radio
      if (target === current) {
        setChecked(true);
      } else if (target.name === current.name && target.form === current.form) {
        // if name and form are the same, then they belong to one form so we can uncheck this one
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement#Properties
        setChecked(false);
      }
    }
  }; // mount document on change


  document.addEventListener('change', onChangeListener);
  return function () {
    document.removeEventListener('change', onChangeListener);
  };
}

var _excluded$1 = ["styles"],
    _excluded2 = ["gutters", "children"],
    _excluded3 = ["children", "heading", "itemsContainer"],
    _excluded4 = ["collapsed", "children", "renderContainer", "renderHeading", "renderItemsContainer", "renderToggler"];
var ListDepthContext = /*#__PURE__*/createContext(0);
ListDepthContext.displayName = 'ListDepthContext';
var ListContainer = /*#__PURE__*/createComponent('section', {
  displayName: 'ListContainer',
  styles: {
    display: 'flex',
    flexDirection: 'column',
    m: 0,
    p: 0,
    width: '100%'
  }
});
var ListItemsContainer = /*#__PURE__*/createComponent('ul', {
  displayName: 'ListItemsContainer',
  styles: /*#__PURE__*/_extends({
    display: 'block',
    listStyle: 'none',
    flexGrow: 1,
    flexShrink: 1,
    m: 0,
    p: 0,
    py: 1,
    width: 'auto'
  }, /*#__PURE__*/booleanVariantStyles('collapsed', {
    on: {
      maxHeight: 0,
      visibility: 'hidden',
      p: 0,
      m: 0
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('collapsed', true)]
});
var BaseListItem = /*#__PURE__*/createComponent('li', {
  displayName: 'ListItem',
  styles: /*#__PURE__*/_extends({
    display: 'flex',
    border: 0,
    height: 'auto',
    m: 0,
    overflow: 'hidden',
    width: 'auto',
    '&[role="button"]:hover, &[role="button"]:focus': {
      outline: 'none',
      backgroundColor: 'accent',
      color: 'accentText',
      cursor: 'pointer',
      userSelect: 'none'
    }
  }, /*#__PURE__*/booleanVariantStyles('gutters', {
    on: {
      px: 2,
      py: 1
    }
  }), /*#__PURE__*/booleanVariantStyles('active', {
    on: {
      color: 'primary',
      fontWeight: 'bolder'
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('active', true), /*#__PURE__*/booleanVariant('button', true), /*#__PURE__*/booleanVariant('gutters', true)]
});
var ListItemLinkBase = /*#__PURE__*/createComponent('a', {
  displayName: 'ListItemLink',
  styles: /*#__PURE__*/_extends({
    color: 'shadesText',
    cursor: 'pointer',
    display: 'flex',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    m: 0,
    px: 2,
    py: 1,
    textDecoration: 'none',
    width: '100%',
    '&:hover, &:focus': {
      outline: 'none',
      userSelect: 'none'
    },
    '&:hover': {
      backgroundColor: 'accent',
      color: 'accentText',
      textDecoration: 'none'
    },
    '&:focus': {
      backgroundColor: 'accent',
      color: 'accentText'
    }
  }, /*#__PURE__*/booleanVariantStyles('active', {
    on: {
      color: 'primary',
      fontWeight: 'bolder'
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('active', true)]
});
var ListItemLink = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var styles = _ref.styles,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var depth = useContext(ListDepthContext);
  return React.createElement(ListItemLinkBase, Object.assign({}, props, {
    styles: _extends({
      pl: (depth > 1 ? 2 : 3) * depth
    }, styles),
    ref: ref
  }));
}));
var ListHeader = /*#__PURE__*/createComponent('h1', {
  displayName: 'ListHeader',
  styles: {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    m: 0,
    p: 0,
    width: '100%'
  }
});
var ListItem = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var gutters = _ref2.gutters,
      children = _ref2.children,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return React.createElement(BaseListItem, Object.assign({
    gutters: gutters != null ? gutters : typeof children === 'string',
    ref: ref
  }, rest), children);
}));
var defaultItemsContainer = /*#__PURE__*/React.createElement(ListItemsContainer, null);
var List = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      heading = _ref3.heading,
      _ref3$itemsContainer = _ref3.itemsContainer,
      itemsContainer = _ref3$itemsContainer === void 0 ? defaultItemsContainer : _ref3$itemsContainer,
      restProps = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  var depth = useContext(ListDepthContext);
  var listItems = cloneElement(itemsContainer, _extends({
    children: children,
    ref: ref
  }, restProps));
  return React.createElement(React.Fragment, null, heading, React.createElement(ListDepthContext.Provider, {
    value: depth + 1
  }, listItems));
}));

var defaultContainerRenderer = function defaultContainerRenderer(children, props) {
  return React.createElement(ListContainer, Object.assign({}, props), children);
};

var defaultItemsContainerRenderer = function defaultItemsContainerRenderer(collapsed, children) {
  return collapsed ? null : children;
};

function CollapsibleList(_ref4) {
  var _ref4$collapsed = _ref4.collapsed,
      isCollapsed = _ref4$collapsed === void 0 ? true : _ref4$collapsed,
      children = _ref4.children,
      _ref4$renderContainer = _ref4.renderContainer,
      renderContainer = _ref4$renderContainer === void 0 ? defaultContainerRenderer : _ref4$renderContainer,
      renderHeading = _ref4.renderHeading,
      _ref4$renderItemsCont = _ref4.renderItemsContainer,
      renderItemsContainer = _ref4$renderItemsCont === void 0 ? defaultItemsContainerRenderer : _ref4$renderItemsCont,
      renderToggler = _ref4.renderToggler,
      restProps = _objectWithoutPropertiesLoose(_ref4, _excluded4);

  var depth = useContext(ListDepthContext);
  var collapsedRef = useRef(isCollapsed);

  var _useState = useState(isCollapsed),
      collapsed = _useState[0],
      setCollapsed = _useState[1];

  var onToggle = useCallback(function () {
    return setCollapsed(!collapsed);
  }, [collapsed]);
  var onKeyDown = useCallback(function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setCollapsed(!collapsed);
    }
  }, [collapsed]);

  if (collapsedRef.current !== isCollapsed) {
    collapsedRef.current = isCollapsed;
    setCollapsed(isCollapsed);
  }

  return renderContainer(React.createElement(React.Fragment, null, renderHeading ? renderHeading() : null, renderToggler ? renderToggler(collapsed, onToggle, onKeyDown) : null, React.createElement(ListDepthContext.Provider, {
    value: depth + 1
  }, renderItemsContainer(collapsed, children))), restProps);
}

var LayerManagerContext = /*#__PURE__*/createContext({
  level: 0,
  increaseBy: 100,
  zIndex: 0
});
LayerManagerContext.displayName = 'LayerManagerContext';
/**
 * Uses current layer manager state for given LayerProvider
 */

function useLayerManager() {
  return useContext(LayerManagerContext);
}
function LayerManager(_ref) {
  var children = _ref.children,
      increaseBy = _ref.increaseBy;
  var ctx = useLayerManager();
  var valueRef = useRef(); // increase zIndex and level

  if (!valueRef.current) {
    valueRef.current = {
      increaseBy: increaseBy != null ? increaseBy : ctx.increaseBy,
      zIndex: ctx.zIndex + (increaseBy != null ? increaseBy : ctx.increaseBy),
      level: ctx.level + 1
    };
  }

  return React.createElement(LayerManagerContext.Provider, {
    value: valueRef.current
  }, children);
}

function Portal(_ref) {
  var children = _ref.children,
      _ref$containerId = _ref.containerId,
      containerId = _ref$containerId === void 0 ? 'portal-root' : _ref$containerId,
      _ref$removeOnUnmount = _ref.removeOnUnmount,
      removeOnUnmount = _ref$removeOnUnmount === void 0 ? true : _ref$removeOnUnmount;
  var portalContainer = useMemo(function () {
    if (typeof document !== 'undefined') {
      var el = document.getElementById(containerId);

      if (el != null) {
        return el;
      }

      el = document.createElement('div');
      el.id = containerId;
      document.body.appendChild(el);
      return el;
    }

    return null;
  }, [containerId]);
  useEffect(function () {
    return function () {
      if (removeOnUnmount && portalContainer) {
        document.body.removeChild(portalContainer);
      }
    };
  }, [removeOnUnmount, portalContainer]);

  if (portalContainer == null) {
    return null;
  }

  return createPortal(children, portalContainer);
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = /*#__PURE__*/createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var CloseListenerManagerContext = /*#__PURE__*/createContext({
  registerClickAwayListener: function registerClickAwayListener() {
    return function () {};
  },
  registerEscapeKeyUpListener: function registerEscapeKeyUpListener() {
    return function () {};
  }
});
/**
 * Connects to CloseListenerManager
 */

function useCloseListenerManager() {
  return useContext(CloseListenerManagerContext);
}

function onEscapeKeyUpHandlerCreator(escapeStack, resolutionRef) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(e) {
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(normalizeKeyboardEventKey(e) === 'Escape' && escapeStack.current && escapeStack.current.length > 0 && !resolutionRef.current)) {
                _context.next = 8;
                break;
              }

              // set as resolving
              resolutionRef.current = true; // get the last added listener but do not mutate the array
              // the component will unregister it's listener on unmount
              // we don't propagate close any further because using escape you want to close only
              // the top most element (for example Menu in Drawer)

              _context.prev = 2;
              _context.next = 5;
              return escapeStack.current[escapeStack.current.length - 1](e);

            case 5:
              _context.prev = 5;
              resolutionRef.current = false;
              return _context.finish(5);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2,, 5, 8]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function onClickAwayHandlerCreator(clickAwayStack, resolutionRef) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(e) {
      var i, _window$getSelection, _clickAwayStack$curre, isFullscreen, onClose, refs, shouldNotClose;

      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!clickAwayStack.current || clickAwayStack.current.length === 0 || resolutionRef.current)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              // set as resolving
              resolutionRef.current = true;
              i = clickAwayStack.current.length - 1;

            case 4:
              if (!(i >= 0)) {
                _context2.next = 26;
                break;
              }

              _clickAwayStack$curre = clickAwayStack.current[i], isFullscreen = _clickAwayStack$curre.isFullscreen, onClose = _clickAwayStack$curre.onClose, refs = _clickAwayStack$curre.refs;
              shouldNotClose = // if you select something in an input and move cursor outside during the selection
              // this will prevent from closing
              ((_window$getSelection = window.getSelection()) == null ? void 0 : _window$getSelection.toString()) || !!refs.find(function (ref) {
                return ref.current && ref.current.contains(e.target);
              });

              if (shouldNotClose) {
                _context2.next = 21;
                break;
              }

              _context2.prev = 8;
              _context2.next = 11;
              return onClose(e);

            case 11:
              _context2.next = 17;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](8);
              resolutionRef.current = false;
              throw _context2.t0;

            case 17:
              if (!(e.defaultPrevented || isFullscreen)) {
                _context2.next = 19;
                break;
              }

              return _context2.abrupt("break", 26);

            case 19:
              _context2.next = 23;
              break;

            case 21:
              if (!isFullscreen) {
                _context2.next = 23;
                break;
              }

              return _context2.abrupt("break", 26);

            case 23:
              i--;
              _context2.next = 4;
              break;

            case 26:
              resolutionRef.current = false;

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 13]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function bindEventListeners(escapeKeyUpListener, clickAwayListener) {
  if (typeof document === 'undefined') {
    return;
  }

  document.addEventListener('keyup', escapeKeyUpListener, true);
  document.addEventListener('click', clickAwayListener, true);
  return function () {
    document.removeEventListener('click', clickAwayListener, true);
    document.removeEventListener('keyup', escapeKeyUpListener, true);
  };
}

function createRegisterEscapeListener(escapeStack) {
  return function (onClose) {
    escapeStack.current = [].concat(escapeStack.current, [onClose]);
    return function () {
      escapeStack.current = escapeStack.current.filter(function (listener) {
        return listener !== onClose;
      });
    };
  };
}

function createRegisterClickAwayListener(clickAwayStack) {
  return function (
  /**
   * List of refs to elements that should contain a click
   */
  refs, onClose, isFullscreen) {
    if (isFullscreen === void 0) {
      isFullscreen = true;
    }

    if (!clickAwayStack.current) {
      return function () {};
    }

    clickAwayStack.current = [].concat(clickAwayStack.current, [{
      isFullscreen: isFullscreen,
      refs: refs,
      onClose: onClose
    }]);
    return function () {
      clickAwayStack.current = clickAwayStack.current.filter(function (listener) {
        return listener.onClose !== onClose;
      });
    };
  };
}

function CloseListenerManager(_ref3) {
  var children = _ref3.children;

  /** says whether we are in the middle of on close resolution */
  var resolutionRef = useRef(false);
  var escapeStack = useRef([]);
  var clickAwayStack = useRef([]);
  var registerEscapeKeyUpListener = useStaticCallbackCreator(createRegisterEscapeListener, [escapeStack]);
  var registerClickAwayListener = useStaticCallbackCreator(createRegisterClickAwayListener, [clickAwayStack]);
  var context = useRef({
    registerClickAwayListener: registerClickAwayListener,
    registerEscapeKeyUpListener: registerEscapeKeyUpListener
  });
  var onEscapeKeyUp = useStaticCallbackCreator(onEscapeKeyUpHandlerCreator, [escapeStack, resolutionRef]);
  var onClickAway = useStaticCallbackCreator(onClickAwayHandlerCreator, [clickAwayStack, resolutionRef]);
  useStaticEffect(bindEventListeners, onEscapeKeyUp, onClickAway);
  return React.createElement(CloseListenerManagerContext.Provider, {
    value: context.current
  }, children);
}

var _excluded$2 = ["disableOnClickAwayClose", "disableOnEscapeClose", "unlockBodyScroll", "backdrop", "contentRef", "fixed", "children", "id", "onClose", "open", "focusElementRef", "preventCloseRefs", "scrollable"];
var BaseModal = /*#__PURE__*/createComponent('div', {
  displayName: 'Modal',
  styles: function styles(props) {
    return _extends({
      alignItems: 'center',
      display: 'flex',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      position: 'static',
      p: 2,
      height: '100%',
      zIndex: props.zIndex
    }, props.scrollable ? {
      overflowY: 'auto'
    } : {}, props.fixed ? {
      position: 'fixed'
    } : {}, props.backdrop && props.fixed ? {
      backgroundColor: 'hsla(0,0%,9%,.5)'
    } : {});
  },
  variants: [/*#__PURE__*/booleanVariant('fixed', true), /*#__PURE__*/booleanVariant('backdrop', true), /*#__PURE__*/booleanVariant('scrollable', true), /*#__PURE__*/numberProp('zIndex', true)]
});

function bindOnCloseListeners(open, closeListenerManagerContext, preventCloseRefs, modalRef, isFullscreen, onClose, disableOnEscapeClose, disableOnClickAwayClose) {
  if (disableOnEscapeClose === void 0) {
    disableOnEscapeClose = false;
  }

  if (disableOnClickAwayClose === void 0) {
    disableOnClickAwayClose = false;
  }

  if (!onClose || !open) {
    return;
  }

  var unregisterClickAway = disableOnClickAwayClose ? function () {} : closeListenerManagerContext.registerClickAwayListener([modalRef].concat(preventCloseRefs), onClose, isFullscreen);
  var unregisterEscapeKeyUp = disableOnEscapeClose ? function () {} : closeListenerManagerContext.registerEscapeKeyUpListener(onClose);
  return function () {
    unregisterClickAway();
    unregisterEscapeKeyUp();
  };
}

var defaultPreventCloseRefs = [];
/**
 * Modal
 *
 * Works as a focus trap
 */

var Modal = /*#__PURE__*/markAsVisageComponent(function (_ref) {
  var disableOnClickAwayClose = _ref.disableOnClickAwayClose,
      disableOnEscapeClose = _ref.disableOnEscapeClose,
      _ref$unlockBodyScroll = _ref.unlockBodyScroll,
      unlockBodyScroll = _ref$unlockBodyScroll === void 0 ? false : _ref$unlockBodyScroll,
      _ref$backdrop = _ref.backdrop,
      backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop,
      contentRef = _ref.contentRef,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? true : _ref$fixed,
      children = _ref.children,
      outerId = _ref.id,
      onClose = _ref.onClose,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? true : _ref$open,
      focusElementRef = _ref.focusElementRef,
      _ref$preventCloseRefs = _ref.preventCloseRefs,
      preventCloseRefs = _ref$preventCloseRefs === void 0 ? defaultPreventCloseRefs : _ref$preventCloseRefs,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      restModalProps = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var id = useUniqueId(outerId, 'modal-portal');
  var modalRef = useRef(null);
  var closeListenerManagerContext = useContext(CloseListenerManagerContext);

  var _useLayerManager = useLayerManager(),
      zIndex = _useLayerManager.zIndex;

  useFocusTrap(contentRef || modalRef, focusElementRef);
  useAutofocusOnMount(focusElementRef);
  useStaticOnRenderEffect(bindOnCloseListeners, open, closeListenerManagerContext, // this one is not picked up on update so be careful
  preventCloseRefs, contentRef || modalRef, backdrop, onClose, disableOnEscapeClose, disableOnClickAwayClose);
  useStaticEffect(disableBodyScroll, modalRef, !unlockBodyScroll && open);

  if (typeof document === 'undefined' || !open) {
    return null;
  }

  return React.createElement(Portal, {
    containerId: id
  }, React.createElement(LayerManager, null, React.createElement(BaseModal, Object.assign({
    backdrop: backdrop,
    fixed: fixed,
    ref: modalRef,
    scrollable: scrollable,
    zIndex: zIndex + 1
  }, restModalProps), children)));
});

var Device;

(function (Device) {
  Device[Device["ipad"] = 0] = "ipad";
  Device[Device["iphone"] = 1] = "iphone";
  Device[Device["ipod"] = 2] = "ipod";
  Device[Device["other"] = 3] = "other";
})(Device || (Device = {}));

function isPortrait(window) {
  return window.innerWidth < window.innerHeight;
}

function acceptsKeyboardInput(document) {
  var activeElement = document.activeElement;

  if (activeElement == null) {
    return false;
  }

  var isDisabled = activeElement.hasAttribute('disabled') || activeElement.getAttribute('aria-disabled') === 'true';
  var isReadOnly = activeElement.hasAttribute('readonly') || activeElement.getAttribute('aria-readonly') === 'true';

  switch (activeElement.tagName) {
    case 'TEXTAREA':
      {
        return !isDisabled && !isReadOnly;
      }

    case 'INPUT':
      {
        var type = activeElement.getAttribute('type');
        return !isDisabled && !isReadOnly && type !== 'checkbox' && type !== 'radio' && type !== 'file' && type !== 'button';
      }

    default:
      {
        if (activeElement.isContentEditable) {
          return !isDisabled && !isReadOnly;
        }

        return false;
      }
  }
}

function chromeBarHeight(window, device) {
  if (device === Device.other) {
    return 0;
  }

  if (window.scrollY > 0) {
    return 50;
  }

  return 0;
}

function softKeyboardHeight(document, window, device) {
  if (device === Device.other || !acceptsKeyboardInput(document)) {
    return 0;
  }

  var portrait = isPortrait(window);

  if (device !== Device.ipad) {
    return portrait ? 240 : 190;
  }

  return portrait ? 280 : 370;
}

function detectDevice(window) {
  var platform = window.navigator.platform;

  if (/iPad/.test(platform)) {
    return Device.ipad;
  }

  if (/iPhone/.test(platform)) {
    return Device.iphone;
  }

  if (/iPod/.test(platform)) {
    return Device.ipod;
  }

  return Device.other;
}

function computeViewportSize(document, window, device) {
  var _ref, _ref2;

  var _window$document$docu = window.document.documentElement,
      scrollHeight = _window$document$docu.scrollHeight,
      scrollWidth = _window$document$docu.scrollWidth,
      clientHeight = _window$document$docu.clientHeight,
      clientWidth = _window$document$docu.clientWidth,
      scrollX = window.scrollX,
      scrollY = window.scrollY,
      pageXOffset = window.pageXOffset,
      pageYOffset = window.pageYOffset,
      visualViewport = window.visualViewport;
  var offsetLeft = (_ref = scrollX != null ? scrollX : pageXOffset) != null ? _ref : 0;
  var offsetTop = (_ref2 = scrollY != null ? scrollY : pageYOffset) != null ? _ref2 : 0;

  if (visualViewport) {
    return {
      offsetLeft: offsetLeft,
      offsetTop: offsetTop,
      height: visualViewport.height,
      maxHeight: document.documentElement.scrollHeight,
      maxWidth: document.documentElement.scrollWidth,
      width: visualViewport.width
    };
  }

  return {
    offsetLeft: offsetLeft,
    offsetTop: offsetTop,
    height: clientHeight - softKeyboardHeight(document, window, device) - chromeBarHeight(window, device),
    maxHeight: scrollHeight,
    maxWidth: scrollWidth,
    width: clientWidth
  };
}

function listenToVisualViewportChangesEffect(onChange, watchForChanges,
/**
 * Scrollable container of an anchor (if we have an element inside other scrollable container than body)
 */
scrollContainerRef) {
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && watchForChanges) {
    var _scrollContainerRef$c;

    var _window = window,
        visualViewport = _window.visualViewport;
    var device = detectDevice(window);
    var ticking = false;

    var recomputeViewport = function recomputeViewport() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          onChange(computeViewportSize(document, window, device));
        });
      }
    }; // listen to changes


    visualViewport == null ? void 0 : visualViewport.addEventListener('resize', recomputeViewport);
    visualViewport == null ? void 0 : visualViewport.addEventListener('scroll', recomputeViewport);
    window.addEventListener('resize', recomputeViewport);
    window.addEventListener('scroll', recomputeViewport);
    scrollContainerRef == null ? void 0 : (_scrollContainerRef$c = scrollContainerRef.current) == null ? void 0 : _scrollContainerRef$c.addEventListener('scroll', recomputeViewport);
    onChange(computeViewportSize(document, window, device));
    return function () {
      var _scrollContainerRef$c2;

      visualViewport == null ? void 0 : visualViewport.removeEventListener('resize', recomputeViewport);
      visualViewport == null ? void 0 : visualViewport.removeEventListener('scroll', recomputeViewport);
      window.removeEventListener('resize', recomputeViewport);
      window.removeEventListener('scroll', recomputeViewport);
      scrollContainerRef == null ? void 0 : (_scrollContainerRef$c2 = scrollContainerRef.current) == null ? void 0 : _scrollContainerRef$c2.removeEventListener('scroll', recomputeViewport);
    };
  }
}
/**
 * Computes visual viewport and calls listener on every change to it's properties
 */


function useVisualViewport(listener, _ref3) {
  var _ref3$watchForChanges = _ref3.watchForChanges,
      watchForChanges = _ref3$watchForChanges === void 0 ? true : _ref3$watchForChanges,
      scrollContainerRef = _ref3.scrollContainerRef;
  useStaticEffect(listenToVisualViewportChangesEffect, listener, watchForChanges, scrollContainerRef);
}

var _excluded$3 = ["allowScrolling", "autoFocus", "children", "anchor", "backdrop", "disableOnClickAwayClose", "disableOnEscapeClose", "fullscreen", "id", "keepAnchorWidth", "marginThreshold", "minHeight", "minWidth", "open", "onClose", "placement", "popoverRef", "scrollContainerRef"];
var BasePopover = /*#__PURE__*/createComponent('div', {
  displayName: 'Popover',
  styles: {
    position: 'absolute',
    overflow: 'auto',
    outline: 'none',
    opacity: 0
  },
  variants: [/*#__PURE__*/booleanVariant('open', true)]
});

function isAnchorPosition(anchor) {
  return typeof anchor === 'object' && anchor != null && anchor.left != null;
}

function resolveAnchor(anchor) {
  if (anchor == null) {
    return anchor;
  }

  return isAnchorPosition(anchor) ? anchor : anchor.current;
}

var defaultPlacement = [[{
  placement: Placement.topLeft,
  horizontal: 'left',
  vertical: 'top'
}]];
function Popover(_ref) {
  var _ref$allowScrolling = _ref.allowScrolling,
      allowScrolling = _ref$allowScrolling === void 0 ? false : _ref$allowScrolling,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
      children = _ref.children,
      anchor = _ref.anchor,
      _ref$backdrop = _ref.backdrop,
      backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop,
      disableOnClickAwayClose = _ref.disableOnClickAwayClose,
      disableOnEscapeClose = _ref.disableOnEscapeClose,
      _ref$fullscreen = _ref.fullscreen,
      fullscreen = _ref$fullscreen === void 0 ? false : _ref$fullscreen,
      outerId = _ref.id,
      _ref$keepAnchorWidth = _ref.keepAnchorWidth,
      keepAnchorWidth = _ref$keepAnchorWidth === void 0 ? false : _ref$keepAnchorWidth,
      _ref$marginThreshold = _ref.marginThreshold,
      marginThreshold = _ref$marginThreshold === void 0 ? 16 : _ref$marginThreshold,
      minHeight = _ref.minHeight,
      minWidth = _ref.minWidth,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? true : _ref$open,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
      popoverRef = _ref.popoverRef,
      scrollContainerRef = _ref.scrollContainerRef,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var _useDesignSystem = useDesignSystem(),
      breakpoint = _useDesignSystem.breakpoint;

  var id = useUniqueId(outerId, 'popover');
  var isFullscreen = useMemo(function () {
    if (!fullscreen) {
      return false;
    }

    return getResponsiveValue(breakpoint, fullscreen);
  }, [fullscreen, breakpoint]);
  var placementAndOrigin = useMemo(function () {
    return getResponsiveValue(breakpoint, placement);
  }, [breakpoint, placement]);
  var contentRef = useRef(null);
  var contentRefCallback = useCombinedRef(contentRef, popoverRef);
  var preventCloseRefs = useRef(!anchor || isAnchorPosition(anchor) ? [] : [anchor]);

  var _useLayerManager = useLayerManager(),
      zIndex = _useLayerManager.zIndex;

  var setPositioningStyles = useCallback(function (element, viewport) {
    if (isFullscreen) {
      /* eslint-disable no-param-reassign */
      element.style.width = "100vw";
      element.style.height = "100vh";
      element.style.top = viewport.offsetTop + "px";
      element.style.left = viewport.offsetLeft + "px";
      element.style.opacity = '1';
      element.style.visibility = 'visible';
      /* eslint-enable no-param-reassign */

      return;
    }

    var anchorElementOrPosition = resolveAnchor(anchor) || (typeof document !== 'undefined' ? document.body : undefined);

    if (anchorElementOrPosition == null) {
      throw new Error('Could not resolve an anchor');
    }

    var anchorPositionAndDimensions = getAnchorPositionAndDimensions(anchorElementOrPosition); // reset element's width and height so we get correct values in algorithm

    /* eslint-disable no-param-reassign */

    element.style.height = 'auto';
    element.style.width = 'auto';
    /* eslint-enable no-param-reassign */

    var positioning = computePositioningStyles(viewport, element, {
      anchor: anchorElementOrPosition,
      placementAndOrigin: placementAndOrigin,
      marginThreshold: marginThreshold,
      minWidth: keepAnchorWidth ? anchorPositionAndDimensions.width : minWidth,
      minHeight: minHeight
    });
    /* eslint-disable no-param-reassign */

    element.style.width = (keepAnchorWidth ? anchorPositionAndDimensions.width : positioning.width) + "px";
    element.style.height = positioning.height + "px";
    element.style.top = positioning.top + "px";
    element.style.left = positioning.left + "px";
    element.style.opacity = '1';
    element.style.visibility = 'visible';
    /* eslint-enable no-param-reassign */
  }, // we need children to invalidate this callback
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [children, keepAnchorWidth, isFullscreen, anchor, marginThreshold, minWidth, minHeight, placementAndOrigin]);
  useVisualViewport(function (viewport) {
    if (open && contentRef.current) {
      var el = contentRef.current;
      setPositioningStyles(el, viewport);
    }
  }, {
    watchForChanges: open,
    scrollContainerRef: scrollContainerRef
  });
  useAutofocusOnMount(autoFocus && open ? contentRef : undefined);
  return React.createElement(Modal, {
    backdrop: backdrop,
    disableOnEscapeClose: disableOnEscapeClose,
    disableOnClickAwayClose: disableOnClickAwayClose,
    unlockBodyScroll: allowScrolling,
    fixed: false,
    id: id,
    onClose: onClose,
    open: open,
    contentRef: contentRef,
    preventCloseRefs: preventCloseRefs.current
  }, React.createElement(BasePopover, Object.assign({}, restProps, {
    tabIndex: -1,
    open: open,
    ref: contentRefCallback,
    styles: _extends({
      zIndex: zIndex
    }, restProps.styles)
  }), children));
}

var _excluded$4 = ["anchor", "baseRef", "children", "disableAutoFocusItem", "disableEvents", "keepAnchorWidth", "onClose", "open", "placement", "role", "onKeyDown", "popoverProps"],
    _excluded2$1 = ["children", "role"];
var MenuBase = /*#__PURE__*/createComponent(List, {
  displayName: 'Menu',
  styles: {
    backgroundColor: 'shades'
  }
});
var MenuItemBase = /*#__PURE__*/createComponent(ListItem, {
  displayName: 'MenuItem',
  styles: {
    '&:hover, &:focus, &[aria-selected="true"]': {
      outline: 'none',
      backgroundColor: 'color(primary, shade(10%))',
      color: 'color(primary, shade(10%), contrast())',
      cursor: 'pointer',
      userSelect: 'none'
    }
  }
});
var defaultPlacement$1 = [[{
  placement: Placement.topLeft,
  vertical: 'bottom',
  horizontal: 'left'
}, {
  placement: Placement.bottomLeft,
  vertical: 'top',
  horizontal: 'left'
}]];
var popoverStyles = {
  boxShadow: '0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.60)'
};

var isMenuItemElement = function isMenuItemElement(el) {
  return el.getAttribute('role') === 'menuitem';
};

var Menu = /*#__PURE__*/markAsVisageComponent(function Menu(_ref) {
  var anchor = _ref.anchor,
      baseRef = _ref.baseRef,
      children = _ref.children,
      disableAutoFocusItem = _ref.disableAutoFocusItem,
      disableEvents = _ref.disableEvents,
      keepAnchorWidth = _ref.keepAnchorWidth,
      onClose = _ref.onClose,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? defaultPlacement$1 : _ref$placement,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'menu' : _ref$role,
      outerOnKeyDown = _ref.onKeyDown,
      popoverProps = _ref.popoverProps,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  var menuRef = useRef();
  var menuRefCallback = useCombinedRef(menuRef, baseRef);
  var onKeyDown = useCallback(function (e) {
    if (outerOnKeyDown) {
      outerOnKeyDown(e);
    }

    if (disableEvents) {
      return;
    }

    switch (e.key) {
      case 'ArrowUp':
        {
          // prevent so Popover onKeyDown is not called
          e.stopPropagation();
          e.preventDefault(); // find previous focusable element, if none is found, find the last one

          var previousFocusableElement = findPreviousMatchingSiblingElement(e.currentTarget, isMenuItemElement);

          if (previousFocusableElement) {
            previousFocusableElement.focus();
            return;
          }

          if (menuRef.current) {
            var _menuRef$current$quer;

            // focus last
            (_menuRef$current$quer = menuRef.current.querySelector('[role="menuitem"]:last-of-type')) == null ? void 0 : _menuRef$current$quer.focus();
          }

          return;
        }

      case 'ArrowDown':
        {
          // prevent so Popover onKeyDown is not called
          e.stopPropagation();
          e.preventDefault(); // find next focusable element, if none is found, find the first one

          var nextFocusableElement = findNextMatchingSiblingElement(e.currentTarget, isMenuItemElement);

          if (nextFocusableElement) {
            nextFocusableElement.focus();
          } else if (menuRef.current) {
            var _menuRef$current$quer2;

            // focus first
            (_menuRef$current$quer2 = menuRef.current.querySelector('[role="menuitem"]:first-of-type')) == null ? void 0 : _menuRef$current$quer2.focus();
          }
        }
    }
  }, [disableEvents, outerOnKeyDown]);
  var onPopoverKeyDown = useCallback(function (e) {
    if (disableEvents) {
      return;
    }

    switch (e.key) {
      case 'ArrowUp':
        {
          e.preventDefault(); // focus last menu item

          if (menuRef.current) {
            var _menuRef$current$quer3;

            (_menuRef$current$quer3 = menuRef.current.querySelector('[role="menuitem"]:last-of-type')) == null ? void 0 : _menuRef$current$quer3.focus();
          }

          return;
        }

      case 'ArrowDown':
        {
          e.preventDefault(); // focus first menu item

          if (menuRef.current) {
            var _menuRef$current$quer4;

            (_menuRef$current$quer4 = menuRef.current.querySelector('[role="menuitem"]:first-of-type')) == null ? void 0 : _menuRef$current$quer4.focus();
          }
        }
    }
  }, [disableEvents]); // manage autofocus of first item
  // if not managed from outside

  useEffect(function () {
    if (!open || disableAutoFocusItem || disableEvents) {
      return;
    }

    if (menuRef.current) {
      var firstMenuItem = menuRef.current.querySelector('[role="menuitem"]:first-of-type');

      if (firstMenuItem) {
        firstMenuItem.focus();
      }
    }
  }, [open, disableAutoFocusItem, disableEvents]);
  return React.createElement(Popover, Object.assign({
    anchor: anchor,
    autoFocus: !disableEvents && disableAutoFocusItem,
    backdrop: true,
    keepAnchorWidth: keepAnchorWidth,
    onClose: onClose,
    onKeyDown: onPopoverKeyDown,
    open: open,
    placement: placement,
    minHeight: 150
  }, popoverProps, {
    styles: _extends({}, popoverStyles, popoverProps == null ? void 0 : popoverProps.styles)
  }), React.createElement(MenuBase, Object.assign({
    ref: menuRefCallback,
    role: role
  }, restProps, {
    tabIndex: -1
  }), Children.map(children, function (menuItem) {
    return cloneElement(menuItem, {
      onKeyDown: onKeyDown
    });
  })));
});
var MenuItem = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      _ref2$role = _ref2.role,
      role = _ref2$role === void 0 ? 'menuitem' : _ref2$role,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);

  // https://www.w3.org/TR/wai-aria-practices-1.1/#wai-aria-roles-states-and-properties-13
  return React.createElement(MenuItemBase, Object.assign({
    tabIndex: -1,
    role: role,
    ref: ref
  }, restProps), children);
}));
MenuItem.displayName = 'MenuItem';

var _excluded$5 = ["baseProps", "disabled", "invalid", "onBlur", "onFocus", "prefix", "prefixExtra", "prefixProps", "suffix", "suffixExtra", "suffixProps"];
var TextInputBaseStyles = {
  backgroundColor: 'color(shades tint(10%))',
  borderColor: 'color(shades shade(30%))',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: 'controlBorderRadius',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  outline: 'none',
  m: 0,
  p: 0,
  position: 'relative',
  // data-focused is used by text input on base
  '&:focus, &[data-focused="true"]': {
    boxShadow: /*#__PURE__*/createControlFocusShadow('accent')
  }
};
var InputExtraElement = /*#__PURE__*/createComponent('div', {
  displayName: 'TextInputExtraElement',
  styles: {
    color: 'shadesText',
    display: 'flex',
    flexBasis: 'auto',
    flexGrow: 0,
    flexShrink: 0,
    fontSize: 'inherit',
    lineHeight: 'inherit',
    maxWidth: '100%',
    position: 'relative',
    userSelect: 'none',
    px: 1
  }
});
var TextInputControlBase = /*#__PURE__*/createComponent('div', {
  displayName: 'TextInputControlBase',
  styles: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '0%',
    flexWrap: 'wrap',
    width: '100%'
  }
});
var TextInputControl = /*#__PURE__*/createComponent('input', {
  displayName: 'TextInputControl',
  styles: {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: 'shadesText',
    cursor: 'inherit',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '0%',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    outline: 'none',
    m: 0,
    py: 1,
    px: 1,
    width: '100%',
    '&[data-prefix]': {
      pl: 0
    },
    '&[data-suffix]': {
      pr: 0
    },
    '::placeholder': {
      color: 'color(shadesText alpha(0.3))'
    }
  }
});
var InputBase = /*#__PURE__*/createComponent('div', {
  displayName: 'TextInputBase',
  styles: function styles(props) {
    return _extends({}, TextInputBaseStyles, {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap'
    }, props.disabled ? disabledControlStyles : {}, props.invalid ? invalidControlStyles : {});
  },
  variants: [disabledControlBooleanVariant, invalidControlBooleanVariant]
});
var TextInput = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var baseProps = _ref.baseProps,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      outerOnBlur = _ref.onBlur,
      outerOnFocus = _ref.onFocus,
      prefix = _ref.prefix,
      prefixExtra = _ref.prefixExtra,
      prefixProps = _ref.prefixProps,
      suffix = _ref.suffix,
      suffixExtra = _ref.suffixExtra,
      suffixProps = _ref.suffixProps,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var _useState = useState(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var onBlur = useCallback(function (e) {
    setFocused(false);
    if (outerOnBlur) outerOnBlur(e);
  }, [outerOnBlur]);
  var onFocus = useCallback(function (e) {
    setFocused(true);
    if (outerOnFocus) outerOnFocus(e);
  }, [outerOnFocus]);
  return React.createElement(InputBase, Object.assign({}, baseProps, {
    "data-focused": focused,
    disabled: disabled,
    invalid: invalid
  }), prefix ? React.createElement(InputExtraElement, Object.assign({}, prefixProps, {
    "data-prefix": true
  }), prefix) : null, React.createElement(TextInputControlBase, null, prefixExtra, React.createElement(TextInputControl, Object.assign({
    "aria-invalid": invalid,
    "data-prefix": prefix ? true : undefined,
    "data-suffix": suffix ? true : undefined,
    disabled: disabled,
    onBlur: onBlur,
    onFocus: onFocus,
    ref: ref
  }, restProps)), suffixExtra), suffix ? React.createElement(InputExtraElement, Object.assign({}, suffixProps, {
    "data-suffix": true
  }), suffix) : null);
}));

var _excluded$6 = ["minHeight", "menuItem"],
    _excluded2$2 = ["focusedIndex", "id", "inputContainerRef", "listboxId", "menuProps", "open", "options", "optionToString", "onSelect"],
    _excluded3$1 = ["$$variants", "debounceDelay", "defaultValue", "enhanceReducer", "expandOnClick", "id", "onBlur", "onChange", "onFocus", "onInputValueChange", "onKeyDown", "onKeyUp", "onMouseDown", "onStateChange", "options", "optionToString", "menu", "readOnly", "parentStyles", "selectOnBlur", "styles", "value", "valueToString"];

var optionId = function optionId(id, index) {
  return index === -1 ? undefined : id + "-listbox-option-" + index;
};
/**
 * Creates AutocompleteInput menu component that can be used if you are happy
 * with default Menu
 */


function createAutocompleteInputMenu(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 150 : _ref$minHeight,
      _ref$menuItem = _ref.menuItem,
      AutocompleteMenuItem = _ref$menuItem === void 0 ? MenuItem : _ref$menuItem,
      restMenuOptions = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  return createComponent(markAsVisageComponent(function (_ref2) {
    var focusedIndex = _ref2.focusedIndex,
        id = _ref2.id,
        inputContainerRef = _ref2.inputContainerRef,
        listboxId = _ref2.listboxId,
        menuProps = _ref2.menuProps,
        open = _ref2.open,
        options = _ref2.options,
        optionToString = _ref2.optionToString,
        onSelect = _ref2.onSelect,
        styleProps = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);

    var popoverRef = useRef(null);
    var onOptionClick = useHandlerRef(function (e) {
      onSelect(Number(e.currentTarget.dataset.optionIndex));
    });
    var onOptionMouseDown = useHandlerRef(function (e) {
      // prevent changing body activeElement and blur on input
      e.preventDefault();
    }); // scroll focused item into view

    useStaticEffect(scrollAriaSelectedElementToView, popoverRef, focusedIndex);
    return React.createElement(Menu, Object.assign({}, menuProps, {
      anchor: inputContainerRef,
      disableEvents: true,
      keepAnchorWidth: true,
      id: listboxId,
      open: open,
      popoverProps: _extends({
        minHeight: minHeight
      }, menuProps == null ? void 0 : menuProps.popoverProps, {
        popoverRef: popoverRef
      }),
      role: "listbox",
      tabIndex: -1
    }, styleProps), open ? options.map(function (option, index) {
      return React.createElement(AutocompleteMenuItem, {
        "aria-selected": focusedIndex === index,
        "data-option-index": index,
        id: optionId(id, index),
        key: optionId(id, index),
        role: "option",
        onClick: onOptionClick,
        onMouseDown: onOptionMouseDown
      }, optionToString(option));
    }) : null);
  }), _extends({
    displayName: 'AutocompleteInputMenu'
  }, restMenuOptions));
}
var defaultMenu = /*#__PURE__*/createAutocompleteInputMenu();
var AutocompleteInput = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var $$variants = _ref3.$$variants,
      _ref3$debounceDelay = _ref3.debounceDelay,
      debounceDelay = _ref3$debounceDelay === void 0 ? 500 : _ref3$debounceDelay,
      defaultValue = _ref3.defaultValue,
      enhanceReducer = _ref3.enhanceReducer,
      expandOnClick = _ref3.expandOnClick,
      outerId = _ref3.id,
      onBlur = _ref3.onBlur,
      onChange = _ref3.onChange,
      onFocus = _ref3.onFocus,
      onInputValueChange = _ref3.onInputValueChange,
      onKeyDown = _ref3.onKeyDown,
      onKeyUp = _ref3.onKeyUp,
      onMouseDown = _ref3.onMouseDown,
      onStateChange = _ref3.onStateChange,
      options = _ref3.options,
      optionToString = _ref3.optionToString,
      _ref3$menu = _ref3.menu,
      DropdownMenu = _ref3$menu === void 0 ? defaultMenu : _ref3$menu,
      readOnly = _ref3.readOnly,
      parentStyles = _ref3.parentStyles,
      selectOnBlur = _ref3.selectOnBlur,
      styles = _ref3.styles,
      value = _ref3.value,
      valueToString = _ref3.valueToString,
      restProps = _objectWithoutPropertiesLoose(_ref3, _excluded3$1);

  var id = useUniqueId(outerId, 'autocomplete');
  var listboxId = useUniqueId(null, 'listbox'); // last arrow pressed is used to automatically focus an option if automatic mode is turn on
  // and is reset to null when options are loaded

  var lastArrowPressed = useRef(null);
  var loadOptions = useHandlerRef(function (inputValue, dispatch) {
    if (!options) {
      return;
    } // open menu only if is input focused


    dispatch({
      type: 'MenuOpen'
    }); // load options sets the input as busy

    dispatch({
      type: 'SetBusy',
      isBusy: true,
      forInputValue: inputValue
    }); // and then on resolution sets options and not busy

    (Array.isArray(options) ? Promise.resolve(options) : options(inputValue)).then(function (newOptions) {
      return dispatch({
        type: 'SetOptions',
        options: newOptions,
        forInputValue: inputValue
      });
    })["finally"](function () {
      dispatch({
        type: 'SetBusy',
        isBusy: false,
        forInputValue: inputValue
      }); // automatic mode

      if (selectOnBlur) {
        if (lastArrowPressed.current === 'ArrowUp') {
          dispatch({
            type: 'SetOptionFocusToLastOption'
          });
        } else {
          dispatch({
            type: 'SetOptionFocusToFirstOption'
          });
        }
      } // reset last arrow pressed


      lastArrowPressed.current = null;
    });
  });

  var _useDebouncedCallback = useDebouncedCallback(loadOptions, debounceDelay, [loadOptions]),
      debouncedLoadOptions = _useDebouncedCallback[0],
      cancelDebouncedLoadOptions = _useDebouncedCallback[1];

  var enhancedReducer = useHandlerRef(function (currentState, nextState) {
    // allow to open only focused input or expand on click input
    if (nextState.invokedBy.type === 'MenuOpen' && !nextState.isFocused && !expandOnClick) {
      return currentState;
    } // allow only to set value from outside if read only


    if (readOnly && nextState.invokedBy.type !== 'SetValue') {
      return currentState;
    } // if value changed, close the popup


    if (currentState.value !== nextState.value) {
      // eslint-disable-next-line no-param-reassign
      nextState.isOpen = false;
    }

    return enhanceReducer ? enhanceReducer(currentState, nextState) : nextState;
  });
  var enhancedOnStateChange = useHandlerRef(function (previousState, currentState, dispatch) {
    if (onStateChange) {
      onStateChange(previousState, currentState, dispatch);
    } // if input value has changed because of InputChanged action
    // load options debounced


    if (currentState.invokedBy.type === 'InputChange' && previousState.inputValue !== currentState.inputValue) {
      debouncedLoadOptions(currentState.inputValue, dispatch);
    } // if input has opened cancel debounced load options and load options directly
    // only if it was not open by InputChange action


    if (previousState.invokedBy.type !== 'InputChange' && previousState.isOpen !== currentState.isOpen && currentState.isOpen) {
      cancelDebouncedLoadOptions();

      if (currentState.options.length === 0) {
        loadOptions(currentState.inputValue, dispatch);
      }
    }
  });

  var _useSelector = useSelector({
    defaultValue: defaultValue,
    enhanceReducer: enhancedReducer,
    onChange: onChange,
    onInputValueChange: onInputValueChange,
    optionToString: optionToString,
    onStateChange: enhancedOnStateChange,
    value: value,
    valueToString: valueToString
  }),
      state = _useSelector[0],
      dispatch = _useSelector[1];

  var inputContainerRef = useRef(null);
  var onInnerBlur = useHandlerRef(function () {
    if (selectOnBlur) {
      dispatch({
        type: 'SetCurrentFocusedOption'
      });
    }

    dispatch({
      type: 'MenuClose'
    });
    dispatch({
      type: 'Blur'
    });
  });
  var onInnerFocus = useHandlerRef(function () {
    return dispatch({
      type: 'Focus'
    });
  });
  var onInputChange = useHandlerRef(function (e) {
    dispatch({
      type: 'InputChange',
      value: e.currentTarget.value
    });
  });
  var onInnerMouseDown = useHandlerRef(function (e) {
    // react only on primary button
    if (e.button !== 0) {
      return;
    }

    if (expandOnClick && !state.isOpen) {
      dispatch({
        type: 'MenuOpen'
      });
    }
  });
  var onBlurHandler = useComposedCallbackCreator(onBlur, onInnerBlur);
  var onFocusHandler = useComposedCallbackCreator(onFocus, onInnerFocus);
  var onMouseDownHandler = useComposedCallbackCreator(onMouseDown, onInnerMouseDown);
  var onInnerKeyUp = useHandlerRef(function (e) {
    var key = normalizeKeyboardEventKey(e);

    if (key === 'Escape') {
      e.preventDefault(); // close menu if open, or reset the input

      if (state.isOpen) {
        dispatch({
          type: 'MenuClose'
        });
      } else {
        dispatch({
          type: 'Reset'
        });
      }
    }
  });
  var onInnerKeyDown = useHandlerRef(function (e) {
    var key = normalizeKeyboardEventKey(e);

    switch (key) {
      case 'ArrowUp':
        {
          e.preventDefault();
          lastArrowPressed.current = key;

          if (state.isOpen) {
            dispatch({
              type: 'SetOptionFocusByOffset',
              offset: -1
            });
          } else {
            dispatch({
              type: 'MenuOpen'
            });
            dispatch({
              type: 'SetOptionFocusToLastOption'
            });
          }

          break;
        }

      case 'ArrowDown':
        {
          e.preventDefault();
          lastArrowPressed.current = key;

          if (state.isOpen) {
            dispatch({
              type: 'SetOptionFocusByOffset',
              offset: 1
            });
          } else {
            dispatch({
              type: 'MenuOpen'
            });
            dispatch({
              type: 'SetOptionFocusToFirstOption'
            });
          }

          break;
        }

      case 'End':
        {
          e.preventDefault();
          dispatch({
            type: 'SetOptionFocusToLastOption'
          });
          break;
        }

      case 'Enter':
        {
          e.preventDefault();
          dispatch({
            type: 'SetCurrentFocusedOption'
          });
          break;
        }

      case 'Home':
        {
          e.preventDefault();
          dispatch({
            type: 'SetOptionFocusToFirstOption'
          });
          break;
        }
    }
  });
  var onKeyUpHandler = useComposedCallbackCreator(onKeyUp, onInnerKeyUp);
  var onKeyDownHandler = useComposedCallbackCreator(onKeyDown, onInnerKeyDown);
  var onOptionSelect = useHandlerRef(function (optionIndex) {
    dispatch({
      type: 'SetValueByIndex',
      index: optionIndex
    });
  });
  return React.createElement(React.Fragment, null, React.createElement(TextInput, Object.assign({
    autoCorrect: "off",
    autoCapitalize: "none",
    autoComplete: "new-password",
    spellCheck: false
  }, restProps, {
    "aria-activedescendant": state.isOpen ? optionId(id, state.focusedIndex) : undefined,
    "aria-autocomplete": "list",
    "aria-controls": listboxId,
    baseProps: _extends({}, restProps.baseProps, {
      'aria-busy': state.isBusy,
      'aria-expanded': state.isOpen,
      'aria-owns': listboxId,
      role: 'combobox',
      ref: inputContainerRef
    }),
    id: id,
    onBlur: onBlurHandler,
    onChange: onInputChange,
    onFocus: onFocusHandler,
    onMouseDown: onMouseDownHandler,
    onKeyDown: onKeyDownHandler,
    onKeyUp: onKeyUpHandler,
    readOnly: readOnly,
    parentStyles: parentStyles,
    ref: ref,
    styles: styles,
    value: state.inputValue,
    "$$variants": $$variants
  })), React.createElement(DropdownMenu, {
    focusedIndex: state.focusedIndex,
    inputContainerRef: inputContainerRef,
    id: id,
    listboxId: listboxId,
    onSelect: onOptionSelect,
    open: state.isOpen,
    options: state.options,
    optionToString: state.optionToString
  }));
}));

var _excluded$7 = ["anchorOrigin", "children", "content", "styles"];
var BadgeContainer = /*#__PURE__*/createComponent('span', {
  displayName: 'BadgeContainer',
  styles: {
    display: 'inline-flex',
    position: 'relative',
    flexShrink: 0,
    verticalAlign: 'middle'
  }
});

var getPositioningStyle = function getPositioningStyle(anchorOrigin) {
  return {
    top: anchorOrigin.vertical === 'top' ? 0 : undefined,
    bottom: anchorOrigin.vertical === 'bottom' ? 0 : undefined,
    left: anchorOrigin.horizontal === 'left' ? 0 : undefined,
    right: anchorOrigin.horizontal === 'right' ? 0 : undefined,
    transform: "translate(" + (anchorOrigin.horizontal === 'right' ? '50%' : '-50%') + ", " + (anchorOrigin.vertical === 'top' ? '-50%' : '50%') + ")",
    transformOrigin: (anchorOrigin.horizontal === 'right' ? '100%' : '0%') + " " + (anchorOrigin.vertical === 'top' ? '0%' : '100%')
  };
};

var BadgeContent = /*#__PURE__*/createComponent('span', {
  displayName: 'BadgeContent',
  styles: {
    display: 'flex',
    borderRadius: '10px',
    fontFamily: 'heading',
    fontWeight: 600,
    py: 0,
    px: 0.5,
    backgroundColor: 'primary',
    position: 'absolute',
    flexWrap: 'wrap',
    fontSize: -1,
    height: '20px',
    minWidth: '20px',
    transition: 'all 250ms ease-in',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    color: 'primaryText'
  }
});
function Badge(_ref) {
  var _ref$anchorOrigin = _ref.anchorOrigin,
      anchorOrigin = _ref$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'right'
  } : _ref$anchorOrigin,
      children = _ref.children,
      content = _ref.content,
      styles = _ref.styles,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  var contentStyles = useMemo(function () {
    return _extends({}, styles, getPositioningStyle(anchorOrigin));
  }, [anchorOrigin, styles]);
  return React.createElement(BadgeContainer, null, React.createElement(BadgeContent, Object.assign({}, restProps, {
    styles: contentStyles
  }), content), children);
}

var CloseIcon = function CloseIcon(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

var CheckIcon = function CheckIcon(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z",
    fill: "currentColor"
  }));
};

var CollapseUpIcon = function CollapseUpIcon(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("polyline", {
    fill: "none",
    points: "21,8.5 12,17.5 3,8.5 ",
    stroke: "currentColor",
    strokeWidth: "2",
    transform: "scale(1,-1) translate(0,-24)"
  }));
};

var DangerIcon = function DangerIcon(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), React.createElement("path", {
    d: "M4.93 4.93l14.14 14.14"
  }));
};

var ErrorIcon = function ErrorIcon(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-2-2h24v24H-2z"
  }), React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z",
    fill: "currentColor"
  })));
};

var ExpandDownIcon = function ExpandDownIcon(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("polyline", {
    fill: "none",
    points: "21,8.5 12,17.5 3,8.5 ",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
};

var InfoIcon = function InfoIcon(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), React.createElement("path", {
    d: "M12 16v-4M12 8h0"
  }));
};

var NeutralMessageIcon = function NeutralMessageIcon(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), React.createElement("path", {
    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7"
  }));
};

var NextPageIcon = function NextPageIcon(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("polyline", {
    fill: "none",
    points: "21,8.5 12,17.5 3,8.5 ",
    stroke: "currentColor",
    strokeWidth: "2",
    transform: "rotate(-90 12 12)"
  }));
};

var PreviousPageIcon = function PreviousPageIcon(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("polyline", {
    fill: "none",
    points: "21,8.5 12,17.5 3,8.5 ",
    stroke: "currentColor",
    strokeWidth: "2",
    transform: "rotate(90 12 12)"
  }));
};

var SpinnerIcon = function SpinnerIcon(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "25 25 50 50"
  }, props), React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 20,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }));
};

var SuccessIcon = function SuccessIcon(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), React.createElement("path", {
    d: "M22 11.08V12a10 10 0 11-5.93-9.14"
  }), React.createElement("path", {
    d: "M22 4L12 14.01l-3-3"
  }));
};

var UnfoldLessIcon = function UnfoldLessIcon(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
  }));
};

var UnfoldMoreIcon = function UnfoldMoreIcon(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
  }));
};

var WarningIcon = function WarningIcon(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), React.createElement("path", {
    d: "M12 8v4M12 16h0"
  }));
};

var skeletonAnimation = /*#__PURE__*/keyframes({
  '0%': {
    opacity: 0.2
  },
  '100%': {
    opacity: 0.4
  }
});

var _excluded$8 = ["aspectRatio"];
var Box = /*#__PURE__*/createComponent('div', {
  displayName: 'Box'
});
var BoxSkeleton = /*#__PURE__*/createComponent(function (_ref) {
  var _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? 1 : _ref$aspectRatio,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  var height = 100 / aspectRatio;
  return React.createElement("div", Object.assign({}, restProps), React.createElement("div", {
    style: {
      paddingBottom: height + "%"
    }
  }));
}, {
  displayName: 'BoxSkeleton',
  styles: {
    backgroundColor: 'currentColor',
    display: 'block',
    willChange: 'opacity',
    animation: skeletonAnimation + " .8s linear infinite alternate",
    width: '100%'
  }
});

var _excluded$9 = ["icon", "iconProps"];
var SvgIconBase = /*#__PURE__*/createComponent('span', {
  displayName: 'SvgIconBase',
  styles: {
    alignItems: 'center',
    display: 'inline-flex',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    '&::before': {
      // respect line height
      content: '"\\200b"'
    },
    '& svg': {
      height: '1em',
      verticalAlign: 'middle',
      width: 'auto',
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        // this is dumb, but we expect icons to be squares in IE11
        width: '1em'
      }
    }
  }
});
var SvgIcon = /*#__PURE__*/markAsVisageComponent(function SvgIcon(_ref) {
  var Icon = _ref.icon,
      iconProps = _ref.iconProps,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  var svgProps = _extends({
    focusable: false,
    height: null,
    width: null
  }, iconProps);

  return React.createElement(SvgIconBase, Object.assign({}, restProps), isValidElement(Icon) ? cloneElement(Icon, svgProps) : React.createElement(Icon, Object.assign({}, svgProps)));
});

var CloseButton = /*#__PURE__*/createComponent('button', {
  displayName: 'CloseButton',
  defaultProps: {
    children: /*#__PURE__*/React.createElement(SvgIcon, {
      "aria-hidden": true,
      icon: CloseIcon,
      styles: {
        width: '1em',
        height: '1em'
      }
    }),
    type: 'button'
  },
  styles: {
    appearance: 'none',
    border: 'none',
    borderRadius: 'controlBorderRadius',
    backgroundColor: 'transparent',
    color: 'currentColor',
    cursor: 'pointer',
    fontSize: 0,
    lineHeight: '1rem',
    outline: 'none',
    m: 0,
    p: 1,
    '&:focus': {
      backgroundColor: 'color(accent, alpha(0.8))',
      color: 'accentText'
    },
    '&:hover': {
      backgroundColor: 'color(accent, alpha(0.8))',
      color: 'accentText'
    },
    '&:active': {
      backgroundColor: 'color(accent, alpha(0.8))',
      color: 'accentText'
    }
  }
});

var Flex = /*#__PURE__*/createComponent('div', {
  displayName: 'Flex',
  styles: {
    display: 'flex'
  }
});

var _excluded$a = ["letters"];
/**
 * Text component's stylesheet
 */

var TextStyles = {
  display: 'inline',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  p: 0,
  m: 0,
  mb: 0
};
var Text = /*#__PURE__*/createComponent('span', {
  displayName: 'Text',
  styles: TextStyles
});
/**
 * EmphasizedText component's styles
 */

var EmphasizedTextStyles = /*#__PURE__*/_extends({}, TextStyles, {
  fontStyle: 'italic'
});
var EmphasizedText = /*#__PURE__*/createComponent('small', {
  displayName: 'EmphasizedText',
  styles: EmphasizedTextStyles
});
/**
 * SmallText component's styles
 */

var SmallTextStyles = /*#__PURE__*/_extends({}, TextStyles, {
  fontSize: -1,
  lineHeight: -1
});
var SmallText = /*#__PURE__*/createComponent('small', {
  displayName: 'SmallText',
  styles: SmallTextStyles
});
/**
 * StrongText component's styles
 */

var StrongTextStyles = /*#__PURE__*/_extends({}, TextStyles, {
  fontWeight: 'bold'
});
var StrongText = /*#__PURE__*/createComponent('strong', {
  displayName: 'StrongText',
  styles: StrongTextStyles
});
var TextSkeleton = /*#__PURE__*/createComponent(function (_ref) {
  var _ref$letters = _ref.letters,
      letters = _ref$letters === void 0 ? 6 : _ref$letters,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  var mask = 'O'.repeat(letters);
  return React.createElement("div", Object.assign({
    "data-mask": mask
  }, restProps));
}, {
  displayName: 'TextSkeleton',
  styles: /*#__PURE__*/_extends({}, TextStyles, {
    backfaceVisibility: 'hidden',
    display: 'inline-block',
    willChange: 'opacity',
    position: 'relative',
    animation: skeletonAnimation + " .8s linear infinite alternate",
    '&:before': {
      content: 'attr(data-mask)',
      backgroundColor: 'currentColor',
      fontSize: 'inherit',
      lineHeight: '1em'
    }
  })
});

var _excluded$b = ["mask"];
var defaultMask = [6, 2, 7];
var SkeletonSentence = /*#__PURE__*/createComponent(function (_ref) {
  var _ref$mask = _ref.mask,
      mask = _ref$mask === void 0 ? defaultMask : _ref$mask,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$b);

  var words = useMemo(function () {
    var _ref2;

    return (_ref2 = []).concat.apply(_ref2, mask.map(function (letters, i) {
      return i < mask.length ? [letters, 0] : [letters];
    }));
  }, [mask]);
  return React.createElement("div", Object.assign({}, restProps), words.map(function (letters, i) {
    return letters === 0 ? // eslint-disable-next-line react/no-array-index-key
    React.createElement(Fragment, {
      key: i
    }, " ") : // eslint-disable-next-line react/no-array-index-key
    React.createElement(TextSkeleton, {
      key: i,
      letters: letters
    });
  }));
});

var _excluded$c = ["level"],
    _excluded2$3 = ["mask"];
/**
 * Heading component's styles
 */

var HeadingStyles = {
  h1: {
    fontFamily: 'heading',
    fontSize: 7,
    fontWeight: 'normal',
    lineHeight: 7,
    mt: 2,
    mb: 1
  },
  h2: {
    fontFamily: 'heading',
    fontSize: 5,
    lineHeight: 5,
    mt: 1,
    mb: 1,
    fontWeight: 'normal'
  },
  h3: {
    fontFamily: 'heading',
    fontSize: 4,
    lineHeight: 4,
    mt: 1,
    mb: 1,
    fontWeight: 'normal'
  },
  h4: {
    fontFamily: 'heading',
    fontSize: 3,
    lineHeight: 3,
    mt: 1,
    mb: 1,
    fontWeight: 'normal'
  },
  h5: {
    fontFamily: 'heading',
    fontSize: 2,
    lineHeight: 2,
    fontWeight: 'normal',
    mt: 1,
    mb: 1
  },
  h6: {
    fontFamily: 'heading',
    fontSize: 1,
    fontStyle: 'italic',
    fontWeight: 'normal',
    lineHeight: 1,
    mb: 1,
    mt: 1
  }
};
var h1 = /*#__PURE__*/createComponent('h1', {
  displayName: 'h1',
  styles: HeadingStyles.h1
});
var h2 = /*#__PURE__*/createComponent('h2', {
  displayName: 'h2',
  styles: HeadingStyles.h2
});
var h3 = /*#__PURE__*/createComponent('h3', {
  displayName: 'h3',
  styles: HeadingStyles.h3
});
var h4 = /*#__PURE__*/createComponent('h4', {
  displayName: 'h4',
  styles: HeadingStyles.h4
});
var h5 = /*#__PURE__*/createComponent('h5', {
  displayName: 'h5',
  styles: HeadingStyles.h5
});
var h6 = /*#__PURE__*/createComponent('h6', {
  displayName: 'h6',
  styles: HeadingStyles.h6
});
var Heading = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Heading(_ref, ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  var as = h1;

  switch (level) {
    case 2:
      as = h2;
      break;

    case 3:
      as = h3;
      break;

    case 4:
      as = h4;
      break;

    case 5:
      as = h5;
      break;

    case 6:
      as = h6;
  }

  return createElement(as, _extends({
    ref: ref,
    'data-level': level
  }, restProps));
})));
var defaultMask$1 = [6];
var HeadingSkeleton = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function HeadingSkeleton(_ref2, ref) {
  var _ref2$mask = _ref2.mask,
      mask = _ref2$mask === void 0 ? defaultMask$1 : _ref2$mask,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded2$3);

  return React.createElement(Heading, Object.assign({
    as: SkeletonSentence,
    mask: mask,
    ref: ref
  }, restProps));
})));

var _excluded$d = ["children", "closeButtonWrapperProps", "contentProps", "dismissLabel", "icon", "headingProps", "status", "onDismiss", "title", "ribbonProps"];
var statusIcons = {
  "default": NeutralMessageIcon,
  critical: DangerIcon,
  info: InfoIcon,
  success: SuccessIcon,
  warning: WarningIcon
};
var variantStyles$1 = {
  critical: {
    borderColor: 'color(danger, shade(10%))',
    backgroundColor: 'danger',
    color: 'dangerText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createControlFocusShadow('danger')
    }
  },
  info: {
    borderColor: 'color(info, shade(10%))',
    backgroundColor: 'info',
    color: 'infoText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createControlFocusShadow('info')
    }
  },
  success: {
    borderColor: 'color(success, shade(10%))',
    backgroundColor: 'success',
    color: 'successText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createControlFocusShadow('success')
    }
  },
  warning: {
    borderColor: 'color(warning, shade(10%))',
    backgroundColor: 'warning',
    color: 'warningText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createControlFocusShadow('warning')
    }
  },
  "default": {
    borderColor: 'color(neutral, shade(10%))',
    backgroundColor: 'neutral',
    color: 'neutralText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createControlFocusShadow('neutral')
    }
  }
};
var BannerBase = /*#__PURE__*/createComponent(Flex, {
  displayName: 'Banner',
  styles: /*#__PURE__*/_extends({
    borderColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: 1,
    outline: 'none',
    p: 2,
    my: 1,
    transition: 'box-shadow 150ms ease-out'
  }, /*#__PURE__*/booleanVariantStyles('flat', {
    off: {
      boxShadow: '0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.15)'
    }
  }), /*#__PURE__*/variantStyles('status', variantStyles$1)),
  variants: [/*#__PURE__*/booleanVariant('flat', true), /*#__PURE__*/variant('status', true)]
});
var ribbonVariantStyles = {
  // maybe we can remove these names and use color function instead?
  critical: {
    color: 'dangerText'
  },
  info: {
    color: 'infoText'
  },
  success: {
    color: 'successText'
  },
  warning: {
    color: 'warningText'
  },
  "default": {
    color: 'neutralText'
  }
};
var BannerRibbon = /*#__PURE__*/createComponent('div', {
  displayName: 'BannerRibbon',
  styles: /*#__PURE__*/_extends({
    fontSize: 1,
    mr: 2
  }, /*#__PURE__*/variantStyles('status', ribbonVariantStyles)),
  variants: [/*#__PURE__*/variant('status', true)]
});
var BannerContent = /*#__PURE__*/createComponent(Box, {
  displayName: 'BannerContent',
  styles: {
    width: '100%'
  }
});
var BannerHeading = /*#__PURE__*/createComponent(Heading, {
  displayName: 'BannerHeading',
  defaultProps: {
    level: 5
  },
  styles: {
    fontSize: 1,
    fontWeight: 500,
    lineHeight: 1,
    mt: 0,
    mb: 1,
    pt: 0
  }
});
var BannerCloseButtonWrapper = /*#__PURE__*/createComponent(Box, {
  displayName: 'BannerCloseButtonWrapper',
  styles: {
    mr: -1,
    mt: -1
  }
});
var Banner = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      closeButtonWrapperProps = _ref.closeButtonWrapperProps,
      contentProps = _ref.contentProps,
      _ref$dismissLabel = _ref.dismissLabel,
      dismissLabel = _ref$dismissLabel === void 0 ? 'Dismiss notification' : _ref$dismissLabel,
      icon = _ref.icon,
      headingProps = _ref.headingProps,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'default' : _ref$status,
      onDismiss = _ref.onDismiss,
      title = _ref.title,
      ribbonProps = _ref.ribbonProps,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  return React.createElement(BannerBase, Object.assign({
    "aria-live": "polite",
    role: status === 'critical' || status === 'warning' ? 'alert' : 'status',
    tabIndex: 0,
    status: status,
    ref: ref
  }, restProps), icon !== false ? React.createElement(BannerRibbon, Object.assign({}, ribbonProps, {
    "aria-hidden": true,
    status: status
  }), icon != null ? icon : React.createElement(SvgIcon, {
    "aria-hidden": true,
    icon: statusIcons[status] || statusIcons["default"]
  })) : null, React.createElement(BannerContent, Object.assign({}, contentProps), title != null ? React.createElement(BannerHeading, Object.assign({}, headingProps), title) : null, children), onDismiss ? React.createElement(BannerCloseButtonWrapper, Object.assign({}, closeButtonWrapperProps), React.createElement(CloseButton, {
    "aria-label": dismissLabel,
    onClick: onDismiss
  })) : null);
}));

var variantStyles$2 = {
  danger: {
    backgroundColor: 'danger',
    color: 'dangerText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('danger')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('danger')
    }
  },
  info: {
    backgroundColor: 'info',
    color: 'infoText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('info')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('info')
    }
  },
  primary: {
    backgroundColor: 'primary',
    color: 'primaryText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('primary')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('primary')
    }
  },
  success: {
    backgroundColor: 'success',
    color: 'successText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('success')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('success')
    }
  },
  warning: {
    backgroundColor: 'warning',
    color: 'warningText',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('warning')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('warning')
    }
  },
  "default": {
    backgroundColor: 'accent',
    color: 'accentText'
  }
};
var sizeVariantStyles = {
  small: {
    fontSize: -1,
    lineHeight: -1,
    py: 0,
    px: 1
  },
  medium: {
    fontSize: 0,
    lineHeight: 0,
    py: 1,
    px: 2
  },
  large: {
    fontSize: 1,
    lineHeight: 1,
    py: 1.5,
    px: 2.5
  },
  "default": {}
};
var outlinedVariantStyles = {
  danger: {
    backgroundColor: 'transparent',
    borderColor: 'danger',
    borderStyle: 'solid',
    borderWidth: 2,
    color: 'danger',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('danger')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('danger')
    },
    '&:hover': {
      backgroundColor: 'danger',
      color: 'dangerText'
    }
  },
  info: {
    backgroundColor: 'transparent',
    borderColor: 'info',
    borderStyle: 'solid',
    borderWidth: 2,
    color: 'info',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('info')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('info')
    },
    '&:hover': {
      backgroundColor: 'info',
      color: 'infoText'
    }
  },
  primary: {
    backgroundColor: 'transparent',
    borderColor: 'primary',
    borderStyle: 'solid',
    borderWidth: 2,
    color: 'primary',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('primary')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('primary')
    },
    '&:hover': {
      backgroundColor: 'primary',
      color: 'primaryText'
    }
  },
  success: {
    backgroundColor: 'transparent',
    borderColor: 'success',
    borderStyle: 'solid',
    borderWidth: 2,
    color: 'success',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('success')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('success')
    },
    '&:hover': {
      backgroundColor: 'success',
      color: 'successText'
    }
  },
  warning: {
    backgroundColor: 'transparent',
    borderColor: 'warning',
    borderStyle: 'solid',
    borderWidth: 2,
    color: 'warning',
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('warning')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('warning')
    },
    '&:hover': {
      backgroundColor: 'warning',
      color: 'warningText'
    }
  },
  "default": {
    backgroundColor: 'transparent',
    borderColor: 'accent',
    borderStyle: 'solid',
    borderWidth: 2,
    color: 'shadesText'
  }
};
var monochromeButtonVariants = {
  backgroundColor: 'transparent',
  color: 'currentColor',
  borderColor: 'currentColor',
  borderStyle: 'solid',
  borderWidth: 2,
  '&:hover': {
    opacity: 0.5
  },
  '&:focus': {
    boxShadow: /*#__PURE__*/createSurfaceFocusShadow('currentColor')
  },
  // because we need to compose box shadow
  '&:focus:active': {
    boxShadow: /*#__PURE__*/createControlActiveShadow('currentColor')
  }
};
var Button = /*#__PURE__*/createComponent('button', {
  displayName: 'Button',
  styles: /*#__PURE__*/_extends({
    appearance: 'none',
    alignItems: 'center',
    borderRadius: 'controlBorderRadius',
    border: 'none',
    color: 'primary',
    cursor: 'pointer',
    display: 'inline-flex',
    flexShrink: 0,
    fontSize: 'inherit',
    lineHeight: 'inherit',
    fontFamily: 'body',
    fontWeight: 600,
    justifyContent: 'center',
    minHeight: '2rem',
    minWidth: '4rem',
    outline: 'none',
    m: 0,
    py: 1,
    px: 2,
    position: 'relative',
    textAlign: 'center',
    textDecoration: 'none',
    transitionProperty: 'all',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease-out',
    verticalAlign: 'middle',
    '&:hover': {
      boxShadow: /*#__PURE__*/createControlHoverShadow(),
      textDecoration: 'none'
    },
    '&:focus': {
      zIndex: 1,
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow()
    },
    // because we need to compose box shadow
    '&:active:focus': {
      zIndex: 1,
      boxShadow: /*#__PURE__*/createControlActiveShadow()
    }
  }, /*#__PURE__*/booleanVariantStyles('outlined', {
    on: /*#__PURE__*/booleanVariantStyles('monochrome', {
      on: monochromeButtonVariants,
      off: /*#__PURE__*/variantStyles('variant', outlinedVariantStyles)
    }),
    off: /*#__PURE__*/variantStyles('variant', variantStyles$2)
  }), /*#__PURE__*/variantStyles('size', sizeVariantStyles), {
    '&[disabled]': disabledControlStyles
  }),
  variants: [/*#__PURE__*/booleanVariant('outlined', true), /*#__PURE__*/booleanVariant('monochrome', true), /*#__PURE__*/variant('variant', true), /*#__PURE__*/variant('size', true)]
});

var _excluded$e = ["children", "contentProps", "touchable", "touchableProps"];
var CardBase = /*#__PURE__*/createComponent('div', {
  displayName: 'Card',
  styles: function styles(props) {
    return _extends({
      boxShadow: '0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.15)',
      p: 1,
      position: 'relative'
    }, props.touchable ? {
      cursor: 'pointer',
      '&:focus-within, &:focus, &:hover': {
        boxShadow: '0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.40)'
      },
      '&:active': {
        boxShadow: '0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.60)'
      }
    } : {});
  },
  variants: [/*#__PURE__*/booleanVariant('touchable', true)]
});
var CardTouchable = /*#__PURE__*/createComponent('div', {
  displayName: 'CardTouchable',
  styles: {
    bottom: 0,
    left: 0,
    opacity: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    '& > *': {
      cursor: 'inherit',
      display: 'block',
      height: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      width: '100%'
    },
    zIndex: 0
  }
});
var CardContent = /*#__PURE__*/createComponent('div', {
  displayName: 'CardContent',
  styles: {
    '& a, & button, & input, & select, & [role="button"], & [role="checkbox"], & [role="radio"], & [role="combobox"], & [role="listbox"], & [role="search"], & [role="switch"], & [role="textbox"]': {
      position: 'relative',
      zIndex: 0
    },
    width: '100%'
  }
});
var Card = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      contentProps = _ref.contentProps,
      touchable = _ref.touchable,
      touchableProps = _ref.touchableProps,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  return React.createElement(CardBase, Object.assign({
    touchable: !!touchable,
    ref: ref
  }, restProps), touchable ? React.createElement(CardTouchable, Object.assign({}, touchableProps), touchable) : null, React.createElement(CardContent, Object.assign({}, contentProps), children));
}));

var Svg = /*#__PURE__*/createComponent('svg', {
  displayName: 'Svg'
});

/**
 * This event handler prevents onChange or setChecked to be called if readOnly is enabled
 *
 * This event handler should be used in Toggle components, the ones that use onChange handler
 * to detect event.currentTarget.checked
 *
 * If onChange is not provided, setChecked is called.
 */
function wrapToggleOnChangeHandler(readOnly, onChange, setChecked) {
  return function (e) {
    // prevent onChange if readonly
    // disabled is handled automatically by the browser
    if (readOnly) {
      return;
    } // onChange is defined, the component is controlled from outside


    if (onChange) {
      onChange(e);
    } else {
      // component is controlled internally
      setChecked(e.currentTarget.checked);
    }
  };
}

var _excluded$f = ["$$variants", "checked", "defaultChecked", "disabled", "hiddenLabel", "invalid", "label", "labelProps", "labelTextProps", "onBlur", "onFocus", "onChange", "parentStyles", "readOnly", "styles", "toggler"];
var CheckboxControl = /*#__PURE__*/createComponent('input', {
  displayName: 'CheckboxControl',
  styles: /*#__PURE__*/_extends({}, visuallyHiddenStyles)
});
var CheckboxLabel = /*#__PURE__*/createComponent('label', {
  displayName: 'CheckboxLabel',
  styles: /*#__PURE__*/_extends({
    alignItems: 'flex-start',
    cursor: 'pointer',
    display: 'flex',
    flex: '1',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    m: 0,
    outline: 'none',
    p: 0,
    position: 'relative',
    userSelect: 'none'
  }, /*#__PURE__*/booleanVariantStyles('disabled', {
    on: disabledControlStyles
  }), /*#__PURE__*/booleanVariantStyles('readOnly', {
    on: {
      cursor: 'default'
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('disabled', true), /*#__PURE__*/booleanVariant('readOnly', true)]
});
var CheckboxLabelText = /*#__PURE__*/createComponent('span', {
  displayName: 'CheckboxLabelText',
  styles: /*#__PURE__*/_extends({
    fontSize: 'inherit',
    lineHeight: 'inherit'
  }, /*#__PURE__*/booleanVariantStyles('hidden', {
    on: visuallyHiddenStyles
  })),
  variants: [visuallyHiddenBooleanVariant]
});
var CheckboxToggler = /*#__PURE__*/createComponent(Flex, {
  displayName: 'CheckboxToggler',
  defaultProps: {
    'aria-hidden': true,
    children: /*#__PURE__*/React.createElement(Svg, {
      viewBox: "0 0 24 24",
      styles: {
        width: '1em',
        height: '1em',
        stroke: 'color(shades tint(10%))',
        strokeWidth: '2px',
        fill: 'none'
      }
    }, /*#__PURE__*/React.createElement("polyline", {
      points: "20 6 9 17 4 12"
    }))
  },
  styles: /*#__PURE__*/_extends({
    backgroundColor: 'color(shades tint(10%))',
    alignSelf: 'center',
    transition: 'all 150ms',
    borderColor: 'accent',
    borderRadius: '3px',
    borderStyle: 'solid',
    borderWidth: '2px',
    mr: 1
  }, /*#__PURE__*/booleanVariantStyles('checked', {
    on: {
      backgroundColor: 'primary',
      color: 'primaryText',
      borderColor: 'primary',
      '& > svg': {
        visibility: 'visible'
      }
    },
    off: {
      '& > svg': {
        visibility: 'hidden'
      }
    }
  }), /*#__PURE__*/booleanVariantStyles('invalid', {
    on: /*#__PURE__*/_extends({
      borderColor: 'danger'
    }, /*#__PURE__*/booleanVariantStyles('focused', {
      on: {
        boxShadow: /*#__PURE__*/createControlFocusShadow('danger')
      }
    })),
    off: /*#__PURE__*/booleanVariantStyles('focused', {
      on: {
        boxShadow: /*#__PURE__*/createControlFocusShadow()
      }
    })
  })),
  variants: [/*#__PURE__*/booleanVariant('checked', true), /*#__PURE__*/booleanVariant('disabled', true), /*#__PURE__*/booleanVariant('invalid', true), /*#__PURE__*/booleanVariant('focused', true), /*#__PURE__*/booleanVariant('readOnly', true)]
});
var DefaultCheckboxToggler = /*#__PURE__*/memo(function (props) {
  return React.createElement(CheckboxToggler, Object.assign({}, props));
});
var Checkbox = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Checkbox(_ref, ref) {
  var _ref2;

  var $$variants = _ref.$$variants,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      _ref$hiddenLabel = _ref.hiddenLabel,
      hiddenLabel = _ref$hiddenLabel === void 0 ? false : _ref$hiddenLabel,
      invalid = _ref.invalid,
      label = _ref.label,
      labelProps = _ref.labelProps,
      labelTextProps = _ref.labelTextProps,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      parentStyles = _ref.parentStyles,
      readOnly = _ref.readOnly,
      styles = _ref.styles,
      _ref$toggler = _ref.toggler,
      Toggler = _ref$toggler === void 0 ? DefaultCheckboxToggler : _ref$toggler,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  var _useState = useState(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var _useState2 = useState((_ref2 = checked != null ? checked : defaultChecked) != null ? _ref2 : false),
      innerChecked = _useState2[0],
      setInnerChecked = _useState2[1];

  var onInnerBlur = useHandlerRef(function () {
    return setFocused(false);
  });
  var onInnerFocus = useHandlerRef(function () {
    return setFocused(true);
  });
  var onBlurHandler = useComposedCallbackCreator(onBlur, onInnerBlur);
  var onFocusHandler = useComposedCallbackCreator(onFocus, onInnerFocus);
  var onChangeHandler = useStaticCallbackCreator(wrapToggleOnChangeHandler, [readOnly, onChange, setInnerChecked]); // if onChange is provided then the component is controlled

  var isChecked = checked != null ? checked : innerChecked;
  return React.createElement(CheckboxLabel, Object.assign({}, labelProps, {
    disabled: disabled,
    readOnly: readOnly,
    parentStyles: parentStyles,
    styles: styles,
    "$$variants": $$variants
  }), React.createElement(CheckboxControl, Object.assign({}, rest, {
    checked: isChecked,
    "aria-invalid": invalid,
    disabled: disabled,
    onBlur: onBlurHandler,
    onChange: onChangeHandler,
    onFocus: onFocusHandler,
    ref: ref,
    readOnly: readOnly,
    type: "checkbox"
  })), React.createElement(Toggler, {
    checked: isChecked,
    disabled: disabled,
    focused: focused,
    invalid: invalid,
    readOnly: readOnly
  }), "\u200B ", React.createElement(CheckboxLabelText, Object.assign({}, labelTextProps, {
    hidden: hiddenLabel
  }), label));
})));

var _excluded$g = ["children", "labelProps", "onClick", "onDelete", "renderDeleter", "small"];
var variantStyles$3 = {
  danger: {
    backgroundColor: 'danger',
    color: 'dangerText'
  },
  info: {
    backgroundColor: 'info',
    color: 'infoText'
  },
  primary: {
    backgroundColor: 'primary',
    color: 'primaryText'
  },
  success: {
    backgroundColor: 'success',
    color: 'successText'
  },
  warning: {
    backgroundColor: 'warning',
    color: 'warningText'
  },
  "default": {
    backgroundColor: 'neutral',
    color: 'neutralText'
  }
};
var outlinedVariantStyles$1 = {
  success: {
    borderColor: 'success',
    color: 'success'
  },
  danger: {
    borderColor: 'danger',
    color: 'danger'
  },
  info: {
    borderColor: 'info',
    color: 'info'
  },
  warning: {
    borderColor: 'warning',
    color: 'warning'
  },
  primary: {
    borderColor: 'primary',
    color: 'primary'
  },
  "default": {
    borderStyle: 'solid',
    color: 'shadesText'
  }
};
var ChipBase = /*#__PURE__*/createComponent('div', {
  displayName: 'Chip',
  styles: /*#__PURE__*/_extends({
    borderRadius: '16px',
    display: 'inline-flex',
    fontFamily: 'heading',
    fontSize: -1,
    lineHeight: -1,
    position: 'relative',
    outline: 'none',
    '&[data-clickable="true"]': {
      cursor: 'pointer'
    },
    '&:focus, &[aria-selected="true"]': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow()
    },
    transition: 'all 150ms'
  }, /*#__PURE__*/booleanVariantStyles('outlined', {
    on: /*#__PURE__*/_extends({
      backgroundColor: 'transparent',
      borderColor: 'accent',
      borderWidth: 1
    }, /*#__PURE__*/variantStyles('variant', outlinedVariantStyles$1)),
    off: /*#__PURE__*/variantStyles('variant', variantStyles$3)
  })),
  variants: [/*#__PURE__*/booleanVariant('outlined', true), /*#__PURE__*/variant('variant', true)]
});
var ChipLabel = /*#__PURE__*/createComponent('span', {
  displayName: 'ChipLabel',
  styles: /*#__PURE__*/_extends({
    alignSelf: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    px: 1.5,
    py: 0.5,
    lineHeight: '1.2rem'
  }, /*#__PURE__*/booleanVariantStyles('size', {
    on: {
      px: 1
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('small', false)]
});
var ChipDeleteButton = /*#__PURE__*/createComponent(CloseButton, {
  displayName: 'ChipDeleteButton',
  styles: {
    mr: 1,
    ml: -0.5,
    my: 0.5,
    p: 0.5
  }
});

var defaultChipDeleteRenderer = function defaultChipDeleteRenderer(props) {
  return React.createElement(ChipDeleteButton, Object.assign({}, props));
};

var Chip = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/memo( /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      labelProps = _ref.labelProps,
      onClick = _ref.onClick,
      onDelete = _ref.onDelete,
      _ref$renderDeleter = _ref.renderDeleter,
      renderDeleter = _ref$renderDeleter === void 0 ? defaultChipDeleteRenderer : _ref$renderDeleter,
      small = _ref.small,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  var onChipClick = useCallback(function (e) {
    if (onClick) {
      onClick(e);
    }
  }, [onClick]);
  var onDeleteClick = useCallback(function (e) {
    // stop propagation of event to ChipBase, because we don't want to invoke onclick
    e.stopPropagation();

    if (onDelete) {
      onDelete(e);
    }
  }, [onDelete]);
  var onDeleteKeyDown = useCallback(function (e) {
    switch (e.key) {
      case 'Backspace':
      case 'Delete':
        if (onDelete) {
          e.preventDefault();
          onDelete(e);
        }

        break;

      case 'Enter':
      case ' ':
        if (onClick) {
          e.preventDefault();
          onClick(e);
        }

    }
  }, [onDelete, onClick]);
  return React.createElement(ChipBase, Object.assign({
    role: onClick ? 'button' : undefined,
    "data-clickable": onClick != null,
    onClick: onChipClick,
    onKeyDown: onDeleteKeyDown,
    tabIndex: onClick ? 0 : undefined
  }, restProps, {
    ref: ref
  }), React.createElement(ChipLabel, Object.assign({
    small: small
  }, labelProps), children), onDelete ? renderDeleter({
    onClick: onDeleteClick
  }) : null);
})));

/**
 * Code component's styles
 */

var CodeStyles = {
  backgroundColor: 'color(shades if(isDark color(shades tint(10%)) color(shades shade(10%))))',
  borderColor: 'color(shades if(isDark color(shades tint(20%)) color(shades shade(20%))))',
  borderStyle: 'solid',
  borderWidth: 1,
  borderRadius: 'controlBorderRadius',
  color: 'color(shades if(isDark color(shades tint(10%)) color(shades shade(10%))) contrast())',
  display: 'inline-block',
  fontSize: 'inherit',
  fontFamily: 'monospace',
  lineHeight: 'inherit',
  px: 1,
  whiteSpace: 'nowrap'
};
var Code = /*#__PURE__*/createComponent('code', {
  displayName: 'Code',
  styles: CodeStyles
});
/**
 * PreformattedCode component's styles
 */

var PreformattedCodeStyles = /*#__PURE__*/_extends({}, CodeStyles, {
  display: 'block',
  overflow: 'auto'
});
var PreformattedCode = /*#__PURE__*/createComponent('pre', {
  displayName: 'PreformattedCode',
  styles: PreformattedCodeStyles
});

var DataTable = /*#__PURE__*/createComponent('table', {
  displayName: 'DataTable',
  styles: {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    width: '100%',
    '& th, td': {
      verticalAlign: 'top'
    }
  }
});
var DataTableHeader = /*#__PURE__*/createComponent('thead', {
  displayName: 'DataTableHeader',
  styles: {
    '& th': {
      borderBottomStyle: 'solid',
      borderBottomColor: 'color(shades if(isDark, color(shades tint(10%)), color(shades shade(10%))))',
      borderBottomWidth: '1px'
    }
  }
});
var totalStyles = {
  backgroundColor: 'color(shades if(isDark, color(shades tint(10%)), color(shades shade(10%))))',
  color: 'shadesText',
  fontWeight: 600
};
var DataTableHeaderColumn = /*#__PURE__*/createComponent('th', {
  displayName: 'DataTableHeaderColumn',
  styles: function styles(props) {
    return _extends({
      fontWeight: 600,
      p: 2,
      textAlign: 'left'
    }, props.numeric ? {
      textAlign: 'right'
    } : {}, props.total ? totalStyles : {});
  },
  variants: [/*#__PURE__*/booleanVariant('numeric', true), /*#__PURE__*/booleanVariant('total', true)]
});
var DataTableHeaderRow = /*#__PURE__*/createComponent('tr', {
  displayName: 'DataTableHeaderRow'
});
var DataTableFooter = /*#__PURE__*/createComponent('tfoot', {
  displayName: 'DataTableFooter'
});
var DataTableFooterRow = /*#__PURE__*/createComponent('tr', {
  displayName: 'DataTableFooterRow'
});
var DataTableBody = /*#__PURE__*/createComponent('tbody', {
  displayName: 'DataTableBody'
});
var DataTableRow = /*#__PURE__*/createComponent('tr', {
  displayName: 'DataTableRow',
  styles: {
    '&:hover td': {
      color: 'shadesText',
      backgroundColor: 'color(shades if(isDark, color(shades tint(10%)), color(shades shade(10%))))'
    }
  }
});
var DataTableColumn = /*#__PURE__*/createComponent('td', {
  displayName: 'DataTableColumn',
  styles: function styles(props) {
    return _extends({
      p: 2,
      textAlign: 'left'
    }, props.numeric ? {
      textAlign: 'right'
    } : {}, props.total ? totalStyles : {});
  },
  variants: [/*#__PURE__*/booleanVariant('numeric', true), /*#__PURE__*/booleanVariant('total', true)]
});
var DataTableColumnSkeleton = /*#__PURE__*/createComponent('td', {
  displayName: 'DataTableColumnSkeleton'
});
var DataTableNumericColumnSkeleton = /*#__PURE__*/createComponent('td', {
  displayName: 'DataTableNumericColumnSkeleton'
});

var _excluded$h = ["label", "labelProps", "lineProps", "vertical"];
var DividerLine = /*#__PURE__*/createComponent('div', {
  displayName: 'DividerLine',
  styles: function styles(props) {
    return _extends({
      borderWidth: 0,
      display: 'block',
      borderColor: 'color(shades if(isDark, color(shades tint(10%)), color(shades shade(10%))))',
      borderStyle: 'solid',
      mx: 0,
      my: 0
    }, props.vertical ? {
      borderLeftWidth: '1px',
      height: '100%',
      minWidth: '1px'
    } : {
      borderBottomWidth: '1px',
      minHeight: '1px',
      width: '100%'
    });
  },
  variants: [/*#__PURE__*/booleanVariant('vertical', true)]
});
var DividerBase = /*#__PURE__*/createComponent('div', {
  displayName: 'Divider',
  styles: function styles(props) {
    return _extends({
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    }, props.vertical ? {
      flexDirection: 'column',
      height: '100%',
      maxWidth: '100%'
    } : {
      width: '100%'
    });
  },
  variants: [/*#__PURE__*/booleanVariant('vertical', true)]
});
var DividerLabel = /*#__PURE__*/createComponent(Text, {
  displayName: 'DividerLabel',
  styles: function styles(props) {
    return props.vertical ? {
      py: 1
    } : {
      px: 1
    };
  },
  variants: [/*#__PURE__*/booleanVariant('vertical', true)]
});
var Divider = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/React.memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
      labelProps = _ref.labelProps,
      lineProps = _ref.lineProps,
      vertical = _ref.vertical,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$h);

  var labelId = useUniqueId(undefined, 'divider'); // if label is provided, split horizontal line to 2 elements

  if (!label) {
    return React.createElement(DividerBase, Object.assign({}, restProps, {
      ref: ref,
      role: "separator",
      vertical: vertical
    }), React.createElement(DividerLine, Object.assign({}, lineProps, {
      vertical: vertical
    })));
  }

  return React.createElement(DividerBase, Object.assign({}, restProps, {
    "aria-labelledby": labelId,
    role: "separator",
    ref: ref,
    vertical: vertical
  }), React.createElement(DividerLine, Object.assign({}, lineProps, {
    vertical: vertical
  })), React.createElement(DividerLabel, Object.assign({}, labelProps, {
    id: labelId,
    vertical: vertical
  }), label), React.createElement(DividerLine, Object.assign({}, lineProps, {
    vertical: vertical
  })));
})));

var _excluded$i = ["children"];
var DescriptionListBase = /*#__PURE__*/createComponent('dl', {
  displayName: 'DescriptionList',
  styles: {
    display: ['block', 'flex'],
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    m: 0,
    p: 0
  }
});
var DescriptionListItemDescription = /*#__PURE__*/createComponent('dd', {
  displayName: 'DescriptionListItemDescription',
  styles: {
    display: 'block',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '51%',
    pt: [0, 2],
    pb: 2,
    m: 0
  }
});
var DescriptionListItemTerm = /*#__PURE__*/createComponent('dt', {
  displayName: 'DescriptionListItemTerm',
  styles: {
    display: 'block',
    fontWeight: 'bolder',
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: '25%',
    pt: 2,
    pb: [1, 2],
    pr: [0, 2],
    m: 0
  }
});
function DescriptionListItem(_ref) {
  var description = _ref.description,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      term = _ref.term;
  return React.createElement(React.Fragment, null, prefix, React.createElement(DescriptionListItemTerm, null, term), React.createElement(DescriptionListItemDescription, null, description), suffix);
}
var DescriptionList = /*#__PURE__*/markAsVisageComponent(function DescriptionList(_ref2) {
  var children = _ref2.children,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded$i);

  return React.createElement(DescriptionListBase, Object.assign({}, restProps), Children.map(children, function (item, i) {
    return (// eslint-disable-next-line react/no-array-index-key
      React.createElement(Fragment, {
        key: i
      }, item, i + 1 < Children.count(children) ? React.createElement(Divider, null) : null)
    );
  }));
});

var DialogBase = /*#__PURE__*/createComponent(Flex, {
  displayName: 'Dialog',
  styles: function styles(props) {
    return _extends({
      boxShadow: '0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.60)',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'shades',
      borderRadius: 'controlBorderRadius',
      position: 'relative'
    }, props.scroll === 'content' ? {
      maxHeight: ['100%', '90%']
    } : {}, {
      m: 'auto',
      overflowY: 'auto',
      p: 0
    });
  },
  variants: [/*#__PURE__*/variant('scroll', true, ['content', 'body'], 'content')]
});
var DialogCloseButton = /*#__PURE__*/createComponent(CloseButton, {
  displayName: 'DialogCloseButton',
  styles: {
    fontSize: 1,
    mx: 2,
    my: 2
  }
});
var DialogCloseButtonWrapper = /*#__PURE__*/createComponent(Flex, {
  displayName: 'DialogCloseButtonWrapper',
  styles: {
    alignItems: 'flex-start',
    position: 'absolute',
    right: 0,
    top: 0
  }
});
var DialogContent = /*#__PURE__*/createComponent(Box, {
  displayName: 'DialogContent',
  styles: {
    px: 2,
    pb: 2,
    maxHeight: '100%',
    maxWidth: '100%',
    overflowY: 'auto'
  }
});
var DialogHeading = /*#__PURE__*/createComponent(Heading, {
  displayName: 'DialogHeading',
  defaultProps: {
    level: 3
  },
  styles: {
    mt: 2
  }
});
var DialogSubHeading = /*#__PURE__*/createComponent(Text, {
  displayName: 'DialogSubHeading',
  styles: {
    mt: 2,
    mb: -2,
    color: 'color(neutral, shade(20%))',
    fontSize: -1
  }
});
var DialogHeadingWrapper = /*#__PURE__*/createComponent(Flex, {
  displayName: 'DialogHeadingWrapper',
  styles: function styles(props) {
    return {
      width: '100%',
      flexDirection: 'column',
      marginRight: props.closable ? 6 : null
    };
  },
  variants: [/*#__PURE__*/booleanVariant('closable', true)]
});
var DialogHeader = /*#__PURE__*/createComponent(Flex, {
  displayName: 'DialogHeader',
  styles: {
    flexShrink: 0,
    px: 2
  }
});
function Dialog(_ref) {
  var baseStyles = _ref.baseStyles,
      children = _ref.children,
      contentStyles = _ref.contentStyles,
      _ref$closeButtonLabel = _ref.closeButtonLabel,
      closeButtonLabel = _ref$closeButtonLabel === void 0 ? 'Close dialog' : _ref$closeButtonLabel,
      focusElementRef = _ref.focusElementRef,
      label = _ref.label,
      outerId = _ref.id,
      onClose = _ref.onClose,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'dialog' : _ref$role,
      _ref$scroll = _ref.scroll,
      scroll = _ref$scroll === void 0 ? 'content' : _ref$scroll,
      secondaryLabel = _ref.secondaryLabel;
  var id = useUniqueId(outerId, 'dialog');
  var closeButtonRef = useRef(null);
  var dialogRef = useRef(null);
  var headingId = "dialog-" + id + "-heading";
  return React.createElement(Modal, {
    contentRef: dialogRef,
    focusElementRef: focusElementRef || closeButtonRef,
    open: true,
    scrollable: scroll === 'body',
    id: id,
    onClose: onClose
  }, React.createElement(DialogBase, {
    "aria-labelledby": headingId,
    "aria-modal": true,
    ref: dialogRef,
    role: role,
    scroll: scroll,
    styles: baseStyles
  }, React.createElement(DialogHeader, null, React.createElement(DialogHeadingWrapper, {
    closable: !!onClose
  }, secondaryLabel != null ? React.createElement(DialogSubHeading, null, secondaryLabel) : null, React.createElement(DialogHeading, {
    id: headingId
  }, label)), onClose ? React.createElement(DialogCloseButtonWrapper, null, React.createElement(DialogCloseButton, {
    "aria-label": closeButtonLabel,
    onClick: onClose,
    ref: closeButtonRef
  })) : null), React.createElement(DialogContent, {
    styles: contentStyles
  }, children)));
}

var _excluded$j = ["backdrop", "children", "focusElementRef", "id", "inPortal", "onClose", "open", "relative", "side"];
var Backdrop = /*#__PURE__*/createComponent('div', {
  displayName: 'DrawerBackdrop',
  styles: {
    backgroundColor: 'hsla(0,0%,9%,.5)',
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw'
  }
});
var DrawerPosition;

(function (DrawerPosition) {
  DrawerPosition["bottom"] = "bottom";
  DrawerPosition["left"] = "left";
  DrawerPosition["right"] = "right";
  DrawerPosition["top"] = "top";
})(DrawerPosition || (DrawerPosition = {}));

var BaseDrawer = /*#__PURE__*/createComponent('div', {
  displayName: 'Drawer',
  styles: function styles(props) {
    return _extends({
      backgroundColor: 'shades',
      overflowY: 'auto'
    }, props.relative ? {
      position: 'relative'
    } : {
      position: 'fixed',
      zIndex: props.zIndex,
      boxShadow: '0 0 0 1px rgba(63,63,68,.05), 0 1px 3px 0 rgba(63,63,68,.60)',
      bottom: props.side !== 'top' ? 0 : null,
      top: props.side !== 'bottom' ? 0 : null,
      left: props.side !== 'right' ? 0 : null,
      right: props.side !== 'left' ? 0 : null,
      height: props.side !== 'left' && props.side !== 'right' ? ['90vh', '75vh', '50vh'] : null,
      width: props.side !== 'top' && props.side !== 'bottom' ? ['90vw', '75vw', '50vw'] : null
    });
  },
  variants: [/*#__PURE__*/variant('side', true), /*#__PURE__*/booleanVariant('relative', true), /*#__PURE__*/numberProp('zIndex', true)]
});

function bindOnCloseListeners$1(closeListenerManager, baseRef, open, relative, isFullscreen, onClose) {
  // if drawer is relative we can't close it
  if (relative || !open || !onClose) {
    return;
  } // if drawer is open, register close listeners


  var unregisterClickAway = closeListenerManager.registerClickAwayListener([baseRef], onClose, isFullscreen);
  var unregisterEscapeKeyUp = closeListenerManager.registerEscapeKeyUpListener(onClose);
  return function () {
    unregisterClickAway();
    unregisterEscapeKeyUp();
  };
}

var Drawer = /*#__PURE__*/markAsVisageComponent(function Drawer(_ref) {
  var _ref$backdrop = _ref.backdrop,
      backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop,
      children = _ref.children,
      focusElementRef = _ref.focusElementRef,
      outerId = _ref.id,
      _ref$inPortal = _ref.inPortal,
      inPortal = _ref$inPortal === void 0 ? false : _ref$inPortal,
      onClose = _ref.onClose,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$relative = _ref.relative,
      relative = _ref$relative === void 0 ? false : _ref$relative,
      _ref$side = _ref.side,
      side = _ref$side === void 0 ? DrawerPosition.left : _ref$side,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  var id = useUniqueId(outerId, 'drawer');
  var baseRef = useRef(null);

  var _useLayerManager = useLayerManager(),
      zIndex = _useLayerManager.zIndex;

  var closeListenerManager = useCloseListenerManager();
  useStaticOnRenderEffect(bindOnCloseListeners$1, closeListenerManager, baseRef, open, relative, // if there is a backdrop, the drawer is fullscreen
  // meaning we don't want to bubble onClose when we close outside of drawer
  backdrop, onClose);
  useAutofocusOnMount(focusElementRef, open);
  useFocusTrap(baseRef, backdrop && open ? focusElementRef : undefined);
  useStaticEffect(disableBodyScroll, baseRef, !relative && backdrop && open);

  if (relative) {
    return React.createElement(BaseDrawer, Object.assign({
      id: outerId,
      relative: relative
    }, restProps), children);
  }

  if (!open) {
    return null;
  }

  var drawer = React.createElement(React.Fragment, null, backdrop ? React.createElement(Backdrop, {
    styles: {
      zIndex: zIndex
    }
  }) : null, React.createElement(BaseDrawer, Object.assign({
    id: outerId,
    ref: baseRef,
    side: side,
    zIndex: zIndex + 1
  }, restProps), children));

  if (inPortal) {
    drawer = typeof document === 'undefined' ? null : React.createElement(Portal, {
      containerId: id
    }, drawer);
  }

  return React.createElement(LayerManager, null, drawer);
});

var FieldSetLegend = /*#__PURE__*/createComponent('legend', {
  displayName: 'FieldSetLegend',
  styles: visuallyHiddenStyles
});
var FieldSetHeading = /*#__PURE__*/createComponent(Heading, {
  displayName: 'FieldSetHeading',
  styles: {
    fontSize: 1,
    lineHeight: 1,
    fontWeight: 500,
    mt: 0,
    mb: 2
  }
});
var FieldSetBase = /*#__PURE__*/createComponent('fieldset', {
  displayName: 'FieldSet',
  styles: /*#__PURE__*/_extends({
    borderColor: 'color(shades if(isDark, color(shades tint(10%)), color(shades shade(10%))))',
    borderStyle: 'solid',
    borderWidth: 1,
    my: 1,
    p: 2,
    position: 'relative'
  }, /*#__PURE__*/booleanVariantStyles('flat', {
    off: {
      boxShadow: '0 0 0 1px color(shades shade(5%)), 0 1px 3px 0 color(shades shade(15%))'
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('flat', true)]
});
function FieldSet(_ref) {
  var baseProps = _ref.baseProps,
      children = _ref.children,
      flat = _ref.flat,
      headingProps = _ref.headingProps,
      title = _ref.title;
  return React.createElement(FieldSetBase, Object.assign({}, baseProps, {
    flat: flat
  }), React.createElement(FieldSetLegend, null, title), React.createElement(FieldSetHeading, Object.assign({
    level: 5,
    "aria-hidden": true,
    role: "presentation"
  }, headingProps), title), children);
}

var _excluded$k = ["accept", "baseProps", "controlProps", "disabled", "invalid", "label", "multiple", "onChange", "readOnly", "placeholder"];
var BaseFileInput = /*#__PURE__*/createComponent('input', {
  displayName: 'FileInputControl',
  styles: /*#__PURE__*/_extends({}, visuallyHiddenStyles, {
    '&:focus + div': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow()
    },
    '&[aria-invalid="true"]:focus + div': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('danger')
    }
  })
});
var FileInputBase = /*#__PURE__*/createComponent('div', {
  displayName: 'FileInputBase',
  styles: {
    border: 'none',
    fontSize: 0,
    lineHeight: 0,
    display: 'inline-flex',
    position: 'relative',
    maxWidth: '100%'
  }
});
var FileInputControl = /*#__PURE__*/createComponent('div', {
  displayName: 'FileInputControlBase',
  styles: function styles(props) {
    return _extends({
      '&::before': {
        // respect line height
        content: '"\\200b"'
      },
      // synthetic focus on drop
      '&[data-draggedover="true"]': {
        boxShadow: createSurfaceFocusShadow()
      },
      backgroundColor: 'color(shades tint(10%))',
      borderColor: 'color(shades shade(30%))',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: 'controlBorderRadius',
      color: 'currentColor',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      overflow: 'hidden',
      outline: 'none',
      m: 0,
      py: 1,
      px: 2,
      textOverflow: 'ellipsis',
      width: '100%',
      whiteSpace: 'nowrap',
      '&:not([data-readonly="true"])': {
        cursor: 'pointer'
      }
    }, props.disabled ? disabledControlStyles : {}, props.invalid ? invalidControlStyles : {});
  },
  variants: [disabledControlBooleanVariant, invalidControlBooleanVariant]
});

var defaultLabelFormatter = function defaultLabelFormatter(files) {
  if (files.length === 0) {
    return '';
  }

  if (files.length === 1) {
    return '1 file selected';
  }

  return files.length + " files selected";
};

var FileInput = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/React.forwardRef(function FileInput(_ref, ref) {
  var accept = _ref.accept,
      baseProps = _ref.baseProps,
      controlProps = _ref.controlProps,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? defaultLabelFormatter : _ref$label,
      multiple = _ref.multiple,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Choose a file' : _ref$placeholder,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$k);

  var _useState = useState(false),
      dragging = _useState[0],
      setDragging = _useState[1];

  var _useState2 = useState([]),
      files = _useState2[0],
      setFiles = _useState2[1];

  var previousFiles = useRef(files);
  var inputRef = useRef(null);
  var inputRefCallback = useCombinedRef(inputRef, ref); // const onDrag: DragEventHandler<HTMLDivElement> = useCallback(() => {}, []);

  var onDragEnter = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  }, []);
  var onDragOver = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'copy';
  }, []);
  var onDragLeave = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  }, []);
  var onDrop = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false); // if accept is filled, check if files are of the given types

    var acceptedMediaTypes = accept ? accept.split(',') : ['*/*'];
    var regex = new RegExp("^(" + acceptedMediaTypes.map(function (mediaType) {
      return mediaType.replace(/\//g, '\\/').replace(/\*/g, '[^\\/]+');
    }).join('|') + ")$"); // check if all files are accepted

    if (Array.from(e.dataTransfer.files).every(function (f) {
      return regex.test(f.type);
    })) {
      setFiles(Array.from(e.dataTransfer.files));
    }

    e.dataTransfer.clearData();
  }, [accept]);
  var onClick = useCallback(function () {
    if (inputRef.current) {
      // delegate click to hidden file input
      // if input is read only, just focus
      if (readOnly) {
        inputRef.current.focus();
      } else {
        inputRef.current.click();
      }
    }
  }, [readOnly]);
  var onInputChange = useCallback(function (e) {
    if (e.currentTarget.files && e.currentTarget.files.length > 0) {
      setFiles(Array.from(e.currentTarget.files));
    }
  }, []); // disables keyboard interaction if input is readonly

  var onInputKeyDown = useCallback(function (e) {
    if (readOnly && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
    }
  }, [readOnly]);

  if (previousFiles.current !== files) {
    previousFiles.current = files;

    if (onChange) {
      onChange(files);
    }
  }

  var generatedLabel = typeof label === 'function' ? label(files, placeholder) : label;
  return React.createElement(FileInputBase, Object.assign({}, baseProps), React.createElement(BaseFileInput, Object.assign({}, restProps, {
    accept: accept,
    "aria-invalid": invalid,
    "aria-readonly": readOnly,
    disabled: disabled,
    multiple: multiple,
    onKeyDown: onInputKeyDown,
    onChange: onInputChange,
    placeholder: typeof placeholder === 'string' ? placeholder : undefined,
    ref: inputRefCallback,
    readOnly: readOnly,
    type: "file"
  })), React.createElement(FileInputControl, Object.assign({}, controlProps, {
    "data-draggedover": dragging,
    "data-readonly": readOnly,
    disabled: disabled,
    invalid: invalid,
    onClick: onClick,
    onDragEnter: !readOnly ? onDragEnter : undefined,
    onDragOver: !readOnly ? onDragOver : undefined,
    onDragLeave: !readOnly ? onDragLeave : undefined,
    onDrop: !readOnly ? onDrop : undefined
  }), files.length === 0 ? placeholder : generatedLabel));
}));

var _excluded$l = ["children", "required", "requiredTitle"];
var RequirementDescription = /*#__PURE__*/createComponent('span', {
  displayName: 'LabelRequirementDescription',
  defaultStyles: visuallyHiddenStyles
});
var LabelBase = /*#__PURE__*/createComponent('label', {
  displayName: 'Label',
  styles: function styles(props) {
    return _extends({
      display: 'block',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      m: 0,
      mb: 1,
      p: 0,
      verticalAlign: 'middle'
    }, props.hidden ? visuallyHiddenStyles : {});
  },
  variants: [visuallyHiddenBooleanVariant]
});
var Label = /*#__PURE__*/markAsVisageComponent(function Label(_ref) {
  var children = _ref.children,
      required = _ref.required,
      _ref$requiredTitle = _ref.requiredTitle,
      requiredTitle = _ref$requiredTitle === void 0 ? 'Required' : _ref$requiredTitle,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$l);

  return React.createElement(LabelBase, Object.assign({}, restProps), children, required ? React.createElement(React.Fragment, null, React.createElement("span", {
    "aria-hidden": true
  }, "*"), React.createElement(RequirementDescription, null, requiredTitle)) : null);
});

var _excluded$m = ["children"];
var InlineErrorWrapper = /*#__PURE__*/createComponent('div', {
  displayName: 'InlineError',
  styles: {
    color: 'danger',
    display: 'flex',
    fontSize: 'inherit',
    lineHeight: 'inherit'
  }
});
var InlineErrorIcon = /*#__PURE__*/createComponent(SvgIcon, {
  displayName: 'InlineErrorIcon',
  styles: {
    alignSelf: 'baseline',
    mr: 1
  }
});
var InlineError = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$m);

  return React.createElement(InlineErrorWrapper, Object.assign({
    ref: ref
  }, restProps), React.createElement(InlineErrorIcon, {
    icon: ErrorIcon
  }), children);
}));

var _excluded$n = ["control", "error", "errorProps", "hiddenLabel", "id", "label", "name", "required", "wrapperProps"];
var FormFieldWrapper = /*#__PURE__*/createComponent(Box, {
  displayName: 'FormField',
  styles: {
    my: 1
  }
});
var FormField = function FormField(_ref) {
  var _ref$control = _ref.control,
      Control = _ref$control === void 0 ? TextInput : _ref$control,
      error = _ref.error,
      errorProps = _ref.errorProps,
      hiddenLabel = _ref.hiddenLabel,
      outerId = _ref.id,
      label = _ref.label,
      name = _ref.name,
      required = _ref.required,
      wrapperProps = _ref.wrapperProps,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$n);

  var idTemplate = useUniqueId$1();
  var id = useMemo(function () {
    return outerId || "field-" + idTemplate + "-" + (name || '');
  }, [outerId, idTemplate, name]);
  return React.createElement(FormFieldWrapper, Object.assign({}, wrapperProps), label ? React.createElement(Label, {
    htmlFor: id,
    required: required,
    hidden: hiddenLabel
  }, label) : null, React.createElement(Control, Object.assign({}, restProps, {
    id: id,
    invalid: !!error,
    name: name,
    required: required
  })), typeof error === 'string' && error ? React.createElement(InlineError, Object.assign({}, errorProps), error) : null);
};

var Grid = /*#__PURE__*/createComponent('div', {
  displayName: 'Grid',
  styles: {
    display: 'grid'
  }
});

var Header = /*#__PURE__*/createComponent('header', {
  displayName: 'Header',
  styles: {
    display: 'flex',
    width: '100%'
  }
});

var _excluded$o = ["icon", "iconProps", "label"];
var strokedVariantStyles = /*#__PURE__*/booleanVariantStyles('stroked', {
  on: {
    svg: {
      stroke: 'currentColor'
    }
  },
  off: {
    svg: {
      fill: 'currentColor'
    }
  }
});
var IconButtonComponent = /*#__PURE__*/createComponent('button', {
  displayName: 'IconButton',
  styles: /*#__PURE__*/_extends({
    appearance: 'none',
    border: 'none',
    backgroundColor: 'transparent',
    borderRadius: 'controlBorderRadius',
    color: 'inherit',
    cursor: 'pointer',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    m: 0,
    p: 0,
    outline: 'none',
    textDecoration: 'none'
  }, /*#__PURE__*/booleanVariantStyles('disabled', {
    on: disabledControlStyles
  }), /*#__PURE__*/booleanVariantStyles('monochromatic', {
    off: /*#__PURE__*/variantStyles('variant', {
      primary: {
        color: 'primary'
      },
      danger: {
        color: 'danger'
      },
      "default": {
        color: 'shadesText'
      }
    })
  }), strokedVariantStyles, {
    '&:hover': {
      opacity: 0.5,
      textDecoration: 'none'
    },
    '&:focus': {
      boxShadow: /*#__PURE__*/createSurfaceFocusShadow('currentColor')
    },
    // because we need to compose box shadow
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('currentColor')
    }
  }),
  variants: [/*#__PURE__*/booleanVariant('disabled', false), /*#__PURE__*/booleanVariant('monochromatic', true), /*#__PURE__*/booleanVariant('stroked', true), /*#__PURE__*/variant('variant', true)]
});
var IconButton = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      iconProps = _ref.iconProps,
      label = _ref.label,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$o);

  return React.createElement(IconButtonComponent, Object.assign({
    "aria-label": label,
    ref: ref
  }, restProps), React.createElement(SvgIcon, Object.assign({
    icon: icon
  }, iconProps)));
})));

var _excluded$p = ["alt", "aspectRatio", "containerProps", "imgProps", "height", "src", "width"];
var ImageContainer = /*#__PURE__*/createComponent('div', {
  displayName: 'ImageContainer',
  styles: {
    position: 'relative',
    minWidth: '4rem',
    maxWidth: '100%',
    overflow: 'hidden',
    '&::after': {
      content: '""',
      display: 'block',
      position: 'relative'
    }
  }
});
var Img = /*#__PURE__*/createComponent('img', {
  displayName: 'Img',
  styles: {
    margin: 'auto',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    maxHeight: '100%',
    maxWidth: '100%'
  }
});
var Image = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var alt = _ref.alt,
      aspectRatio = _ref.aspectRatio,
      containerProps = _ref.containerProps,
      imgProps = _ref.imgProps,
      height = _ref.height,
      src = _ref.src,
      width = _ref.width,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$p);

  return React.createElement(ImageContainer, Object.assign({}, restProps, containerProps, {
    styles: _extends({
      height: height,
      width: width,
      '&::after': {
        paddingBottom: typeof aspectRatio === 'number' ? 100 / aspectRatio + "%" : '100%'
      }
    }, containerProps ? containerProps.styles : {})
  }), React.createElement(Img, Object.assign({
    alt: alt,
    ref: ref,
    src: src
  }, imgProps)));
}));

var Container = /*#__PURE__*/createComponent('div', {
  displayName: 'Container',
  styles: {
    display: 'flex',
    m: '0px',
    p: '0px',
    width: '100%'
  }
});
var Column = /*#__PURE__*/createComponent('div', {
  displayName: 'Column',
  styles: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    m: '0px',
    p: '0px'
  }
});
var Row = /*#__PURE__*/createComponent('div', {
  displayName: 'Row',
  styles: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    m: '0px',
    p: '0px'
  }
});

/**
 * Link component's style sheet
 */

var LinkStyles = {
  fontFamily: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  color: 'primary',
  outline: 'none',
  textDecoration: 'none',
  '&:focus': {
    boxShadow: /*#__PURE__*/createSurfaceFocusShadow()
  },
  '&:hover': {
    textDecoration: 'underline'
  }
};
var Link = /*#__PURE__*/createComponent('a', {
  displayName: 'Link',
  styles: LinkStyles
});

var _excluded$q = ["baseProps", "indeterminate", "progressProps", "value", "valueText"];
var indeterminateAnimation = /*#__PURE__*/keyframes({
  '0%': {
    left: '-35%',
    right: '100%'
  },
  '60%': {
    left: '100%',
    right: '-90%'
  },
  '100%': {
    left: '100%',
    right: '-90%'
  }
});
var indeterminateStyles = {
  on: {
    animation: indeterminateAnimation + " 2.1s ease-in-out infinite",
    width: '35%',
    willChange: 'left, right'
  },
  off: {
    transformOrigin: 0,
    transition: 'transform .5s cubic-bezier(0,0,.42,1)',
    width: '100%'
  }
};
var ProgressBarBase = /*#__PURE__*/createComponent('div', {
  displayName: 'LoadingProgressBar',
  styles: function styles(props) {
    return _extends({
      height: 4,
      overflow: 'hidden',
      position: 'relative',
      width: '100%',
      borderRadius: 'controlBorderRadius',
      '&:before': {
        backgroundColor: 'currentColor',
        content: '""',
        opacity: 0.2,
        display: 'block',
        width: '100%',
        height: '100%'
      }
    }, props.indeterminate ? indeterminateStyles.on : indeterminateStyles.off);
  },
  variants: [/*#__PURE__*/booleanVariant('indeterminate', true)]
});
var ProgressBarProgress = /*#__PURE__*/createComponent('div', {
  displayName: 'LoadingProgressBarProgress',
  styles: function styles(props) {
    return _extends({
      backgroundColor: 'currentColor',
      height: '100%',
      left: 0,
      position: 'absolute',
      top: 0,
      maxWidth: '100%'
    }, props.indeterminate ? indeterminateStyles.on : indeterminateStyles.off);
  },
  variants: [/*#__PURE__*/booleanVariant('indeterminate', true)]
});
var Loading = /*#__PURE__*/markAsVisageComponent(function Loading(_ref) {
  var baseProps = _ref.baseProps,
      indeterminate = _ref.indeterminate,
      progressProps = _ref.progressProps,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      valueText = _ref.valueText,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$q);

  return React.createElement(ProgressBarBase, Object.assign({
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuenow": indeterminate ? undefined : value,
    "aria-valuetext": valueText,
    "aria-valuemax": 100
  }, baseProps, restProps), React.createElement(ProgressBarProgress, Object.assign({
    indeterminate: indeterminate,
    style: indeterminate ? undefined : {
      transform: "scaleX(" + value / 100 + ")"
    }
  }, progressProps)));
});

var KeyboardKeyStyles = {
  backgroundColor: 'shades',
  borderRadius: 'keyboardBorderRadius',
  boxShadow: '0 0 0 1px color(shades if(isDark color(shades tint(15%)) color(shades shade(15%)))), 0 3px 0 0 shades, 0 3px 0 1px color(shades if(isDark color(shades tint(15%)) color(shades shade(15%))))',
  color: 'shadesText',
  display: 'inline-block',
  fontFamily: 'monospace',
  fontSize: 'inherit',
  fontWeight: 400,
  lineHeight: 'inherit',
  m: 0,
  p: 0,
  px: 0.5,
  textAlign: 'center',
  textTransform: 'lowercase',
  userSelect: 'none',
  whiteSpace: 'nowrap'
};
var KeyboardKey = /*#__PURE__*/createComponent('kbd', {
  displayName: 'KeyboardKey',
  styles: KeyboardKeyStyles
});

var _excluded$r = ["children", "onDismiss", "renderDismiss", "status"];
var MessageBase = /*#__PURE__*/createComponent('div', {
  displayName: 'Message',
  styles: /*#__PURE__*/_extends({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: 0,
    p: 1,
    outline: 'none',
    position: 'relative',
    '&:focus': {
      zIndex: 1
    }
  }, /*#__PURE__*/variantStyles('status', {
    danger: /*#__PURE__*/booleanVariantStyles('inverted', {
      on: {
        color: 'danger',
        '&:focus': {
          boxShadow: /*#__PURE__*/createSurfaceFocusShadow('danger')
        }
      },
      off: {
        backgroundColor: 'danger',
        color: 'dangerText',
        '&:focus': {
          boxShadow: /*#__PURE__*/createControlFocusShadow('danger')
        }
      }
    }),
    info: /*#__PURE__*/booleanVariantStyles('inverted', {
      on: {
        color: 'info',
        '&:focus': {
          boxShadow: /*#__PURE__*/createSurfaceFocusShadow('info')
        }
      },
      off: {
        backgroundColor: 'info',
        color: 'infoText',
        '&:focus': {
          boxShadow: /*#__PURE__*/createControlFocusShadow('info')
        }
      }
    }),
    success: /*#__PURE__*/booleanVariantStyles('inverted', {
      on: {
        color: 'success',
        '&:focus': {
          boxShadow: /*#__PURE__*/createSurfaceFocusShadow('success')
        }
      },
      off: {
        backgroundColor: 'success',
        color: 'successText',
        '&:focus': {
          boxShadow: /*#__PURE__*/createControlFocusShadow('success')
        }
      }
    }),
    warning: /*#__PURE__*/booleanVariantStyles('inverted', {
      on: {
        color: 'warning',
        '&:focus': {
          boxShadow: /*#__PURE__*/createSurfaceFocusShadow('warning')
        }
      },
      off: {
        backgroundColor: 'warning',
        color: 'warningText',
        '&:focus': {
          boxShadow: /*#__PURE__*/createControlFocusShadow('warning')
        }
      }
    }),
    "default": /*#__PURE__*/booleanVariantStyles('inverted', {
      on: {
        color: 'shadesText',
        '&:focus': {
          boxShadow: /*#__PURE__*/createSurfaceFocusShadow()
        }
      },
      off: {
        backgroundColor: 'neutral',
        color: 'neutralText',
        '&:focus': {
          boxShadow: /*#__PURE__*/createControlFocusShadow('neutral')
        }
      }
    })
  })),
  variants: [/*#__PURE__*/variant('status', true), /*#__PURE__*/booleanVariant('inverted', true)]
});
var MessageDismissButton = /*#__PURE__*/createComponent(CloseButton, {
  displayName: 'MessageDismissButton',
  styles: {
    ml: 'auto',
    p: 0.5
  }
});

var defaultMessageDismissButton = function defaultMessageDismissButton(props) {
  return React.createElement(MessageDismissButton, Object.assign({}, props));
};

var Message = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      onDismiss = _ref.onDismiss,
      _ref$renderDismiss = _ref.renderDismiss,
      renderDismiss = _ref$renderDismiss === void 0 ? defaultMessageDismissButton : _ref$renderDismiss,
      status = _ref.status,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$r);

  var onDismissClick = useCallback(function (e) {
    if (onDismiss) {
      onDismiss(e);
    }
  }, [onDismiss]);
  return React.createElement(MessageBase, Object.assign({
    "aria-live": "polite",
    role: status === 'danger' || status === 'warning' ? 'alert' : 'status',
    status: status,
    tabIndex: 0,
    ref: ref
  }, restProps), children, onDismiss ? renderDismiss({
    onClick: onDismissClick
  }) : null);
}));

var PaginationNextPageButton = /*#__PURE__*/createComponent(Button, {
  displayName: 'PaginationNextPageButton',
  defaultProps: {
    children: /*#__PURE__*/React.createElement(SvgIcon, {
      "aria-hidden": true,
      icon: NextPageIcon,
      styles: {
        width: '1em',
        height: '1em'
      }
    }),
    type: 'button'
  }
});
var PaginationPreviousPageButton = /*#__PURE__*/createComponent(Button, {
  displayName: 'PaginationPreviousPageButton',
  defaultProps: {
    children: /*#__PURE__*/React.createElement(SvgIcon, {
      "aria-hidden": true,
      icon: PreviousPageIcon,
      styles: {
        width: '1em',
        height: '1em'
      }
    }),
    type: 'button'
  }
});
var Pagination = /*#__PURE__*/createComponent('nav', {
  displayName: 'Pagination',
  defaultProps: {
    'aria-label': 'pagination'
  },
  styles: {
    display: 'flex',
    justifyContent: 'flex-start'
  }
});

var _excluded$s = ["lines"];
/**
 * Paragraph component's style sheet
 */

var ParagraphStyles = {
  display: 'block',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  p: 0,
  mx: 0,
  my: 2
};
var Paragraph = /*#__PURE__*/createComponent('p', {
  displayName: 'Paragraph',
  styles: ParagraphStyles
});
var ParagraphSkeleton = /*#__PURE__*/createComponent(function (_ref) {
  var _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 3 : _ref$lines,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$s);

  return React.createElement("div", Object.assign({}, restProps), Array(lines).fill(null).map(function (_, i) {
    return (// eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: i
      }, React.createElement("div", null, "\u200B"))
    );
  }));
}, {
  displayName: 'ParagraphSkeleton',
  styles: /*#__PURE__*/_extends({}, ParagraphStyles, {
    backfaceVisibility: 'hidden',
    willChange: 'opacity',
    animation: skeletonAnimation + " .8s linear infinite alternate",
    '& > div': {
      alignItems: 'center',
      display: 'flex',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      width: '100%'
    },
    '& > div > div': {
      backgroundColor: 'currentColor',
      fontSize: 'inherit',
      lineHeight: '1em',
      width: '100%'
    },
    '& > div:before': {
      // respect line height
      content: '"\\200b"',
      fontSize: 'inherit',
      lineHeight: 'inherit'
    },
    '& > div:last-child:not(:first-child)': {
      width: '80%'
    }
  })
});

var _excluded$t = ["anchor", "content", "placementAndOrigin", "setPosition", "zIndex"],
    _excluded2$4 = ["anchor", "children", "id", "marginThreshold", "minHeight", "minWidth", "open", "placement", "scrollContainerRef"];

function isAnchorPosition$1(anchor) {
  return typeof anchor === 'object' && anchor != null && anchor.current == null;
}

function resolveAnchor$1(anchor) {
  if (anchor == null) {
    return anchor;
  }

  return isAnchorPosition$1(anchor) ? anchor : anchor.current;
}

function positionContent(open, _ref) {
  var anchor = _ref.anchor,
      content = _ref.content,
      placementAndOrigin = _ref.placementAndOrigin,
      setPosition = _ref.setPosition,
      zIndex = _ref.zIndex,
      constraints = _objectWithoutPropertiesLoose(_ref, _excluded$t);

  return function (viewport) {
    var contentEl = content.current;

    if (contentEl == null || !open) {
      return;
    }

    var resolvedAnchor = resolveAnchor$1(anchor);

    if (resolvedAnchor == null) {
      throw new Error('Anchor must be an HTMLElement or AnchorPosition');
    } // reset styles so we can compute right dimensions

    /* eslint-disable no-param-reassign */


    contentEl.style.height = 'auto';
    contentEl.style.width = 'auto';
    /* eslint-enable no-param-reassign */

    var position = computePositioningStyles(viewport, contentEl, _extends({
      anchor: resolvedAnchor,
      placementAndOrigin: placementAndOrigin
    }, constraints));
    /* eslint-disable no-param-reassign */

    contentEl.style.zIndex = "" + zIndex;
    contentEl.style.opacity = '1'; // following lines causes blurry render if fractions are computed, so we round them
    // https://stackoverflow.com/questions/6411361/webkit-based-blurry-distorted-text-post-animation-via-translate3d

    contentEl.style.transform = "translate3d(" + Math.round(position.left) + "px, " + Math.round(position.top) + "px, 0px)";
    contentEl.style.width = position.width + "px";
    contentEl.style.height = position.height + "px";
    contentEl.style.visibility = 'visible';
    /* eslint-enable no-param-reassign */

    setPosition(position);
  };
}

function cancelPositionFnOnUnmount(cancelPositionFn) {
  return function () {
    cancelPositionFn();
  };
}

var baseStyle = {
  willChange: 'transform',
  position: 'absolute',
  opacity: 0,
  overflow: 'auto',
  top: 0,
  left: 0,
  visibility: 'hidden'
};
/**
 * Popper
 *
 * Display a content placed near an element.
 *
 * This component can be used to create tooltips, etc.
 */

function Popper(_ref2) {
  var anchor = _ref2.anchor,
      children = _ref2.children,
      outerId = _ref2.id,
      _ref2$marginThreshold = _ref2.marginThreshold,
      marginThreshold = _ref2$marginThreshold === void 0 ? 16 : _ref2$marginThreshold,
      minHeight = _ref2.minHeight,
      minWidth = _ref2.minWidth,
      _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? false : _ref2$open,
      placement = _ref2.placement,
      scrollContainerRef = _ref2.scrollContainerRef,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded2$4);

  var portalId = useUniqueId(outerId, 'popper');

  var _useDesignSystem = useDesignSystem(),
      breakpoint = _useDesignSystem.breakpoint;

  var contentRef = useRef(null);
  var openRef = useRef(open);

  var _useLayerManager = useLayerManager(),
      zIndex = _useLayerManager.zIndex;

  var placementAndOrigin = useMemo(function () {
    return getResponsiveValue(breakpoint, placement);
  }, [breakpoint, placement]);

  var _useState = useState(null),
      position = _useState[0],
      setPosition = _useState[1];

  var params = useMemo(function () {
    return {
      anchor: anchor,
      content: contentRef,
      setPosition: setPosition,
      marginThreshold: marginThreshold,
      minHeight: minHeight,
      minWidth: minWidth,
      open: open,
      placementAndOrigin: placementAndOrigin,
      zIndex: zIndex
    };
  }, [anchor, contentRef, marginThreshold, minHeight, minWidth, open, placementAndOrigin, setPosition, zIndex]);
  var positionElement = useStaticCallbackCreator(positionContent, [open, params]);

  var _useDebouncedCallback = useDebouncedCallback(positionElement, 10, [params]),
      positionFn = _useDebouncedCallback[0],
      cancelPositionFn = _useDebouncedCallback[1];

  useVisualViewport(positionFn, {
    watchForChanges: open,
    scrollContainerRef: scrollContainerRef
  });
  useStaticEffect(cancelPositionFnOnUnmount, cancelPositionFn);

  if (openRef.current !== open && !open) {
    openRef.current = open;
    setPosition(null);
  }

  if (!open || typeof document === 'undefined') {
    return null;
  }

  var renderedPlacement = position ? position.placement : undefined;
  return React.createElement(Portal, {
    containerId: portalId
  }, React.createElement(LayerManager, null, React.createElement("div", Object.assign({}, restProps, {
    id: outerId,
    ref: contentRef,
    style: baseStyle
  }), typeof children === 'function' ? children({
    placement: renderedPlacement
  }) : React.cloneElement(Children.only(children), {
    'data-placement': renderedPlacement
  }))));
}

var _excluded$u = ["baseProps", "max", "progressProps", "value", "valueText"];
var HiddenProgressBar = /*#__PURE__*/createComponent('progress', {
  styles: visuallyHiddenStyles
});
var ProgressBarBase$1 = /*#__PURE__*/createComponent('div', {
  displayName: 'ProgressBar',
  styles: {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    '&:before': {
      backgroundColor: 'currentColor',
      content: '"\\200b"',
      display: 'inline-block',
      opacity: 0.2,
      width: '100%'
    }
  }
});
var ProgressBarProgress$1 = /*#__PURE__*/createComponent('div', {
  displayName: 'ProgressBarProgress',
  styles: {
    '&::before': {
      backgroundColor: 'currentColor',
      content: '"\\200b"',
      display: 'inline-block',
      lineHeight: '100%',
      width: '100%'
    },
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    maxWidth: '100%',
    willChange: 'width',
    transition: 'width .5s cubic-bezier(.64,0,.35,1)'
  }
});
var ProgressBar = /*#__PURE__*/markAsVisageComponent(function ProgressBar(_ref) {
  var baseProps = _ref.baseProps,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      progressProps = _ref.progressProps,
      value = _ref.value,
      valueText = _ref.valueText,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$u);

  return React.createElement(ProgressBarBase$1, Object.assign({}, baseProps, restProps), React.createElement(HiddenProgressBar, {
    "aria-valuetext": valueText,
    value: value,
    max: max
  }), React.createElement(ProgressBarProgress$1, Object.assign({
    style: {
      width: 100 / max * value + "%"
    }
  }, progressProps)));
});

/**
 * Blockquote component's style sheet
 */

var BlockquoteStyles = {
  fontStyle: 'italic',
  pl: 2
};
var Blockquote = /*#__PURE__*/createComponent('blockquote', {
  displayName: 'Blockquote',
  styles: BlockquoteStyles
});
/**
 * Cite component's style sheet
 */

var CiteStyles = {
  fontStyle: 'italic'
};
var Cite = /*#__PURE__*/createComponent('cite', {
  displayName: 'Cite',
  styles: CiteStyles
});
/**
 * Quote component's style sheet
 */

var QuoteStyles = {
  fontStyle: 'italic'
};
var Quote = /*#__PURE__*/createComponent('q', {
  displayName: 'Quote',
  styles: QuoteStyles
});

var _excluded$v = ["$$variants", "checked", "defaultChecked", "disabled", "hiddenLabel", "invalid", "label", "labelProps", "labelTextProps", "name", "onBlur", "onChange", "onFocus", "readOnly", "parentStyles", "styles", "toggler"];
var RadioControl = /*#__PURE__*/createComponent('input', {
  displayName: 'RadioControl',
  styles: visuallyHiddenStyles
});
var RadioLabel = /*#__PURE__*/createComponent('label', {
  displayName: 'RadioLabel',
  styles: /*#__PURE__*/_extends({
    alignItems: 'flex-start',
    cursor: 'pointer',
    display: 'flex',
    flex: '1',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    m: 0,
    outline: 'none',
    p: 0,
    position: 'relative',
    userSelect: 'none'
  }, /*#__PURE__*/booleanVariantStyles('disabled', {
    on: disabledControlStyles
  }), /*#__PURE__*/booleanVariantStyles('readOnly', {
    on: {
      cursor: 'default'
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('disabled', true), /*#__PURE__*/booleanVariant('readOnly', true)]
});
var RadioLabelText = /*#__PURE__*/createComponent('span', {
  displayName: 'RadioLabelText',
  styles: /*#__PURE__*/_extends({
    fontSize: 'inherit',
    lineHeight: 'inherit'
  }, /*#__PURE__*/booleanVariantStyles('hidden', {
    on: visuallyHiddenStyles
  })),
  variants: [visuallyHiddenBooleanVariant]
});
var RadioToggler = /*#__PURE__*/createComponent(Flex, {
  displayName: 'RadioToggler',
  defaultProps: {
    'aria-hidden': true,
    children: /*#__PURE__*/React.createElement(Svg, {
      viewBox: "0 0 24 24",
      styles: {
        width: '1em',
        height: '1em'
      }
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "6"
    }))
  },
  styles: /*#__PURE__*/_extends({
    backgroundColor: 'color(shades tint(10%))',
    alignSelf: 'center',
    transition: 'all 150ms',
    borderRadius: 999,
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: 'accent',
    mr: 1
  }, /*#__PURE__*/booleanVariantStyles('checked', {
    on: {
      backgroundColor: 'primary',
      color: 'primaryText',
      borderColor: 'primary',
      '& > svg': {
        fill: 'color(shades tint(10%))',
        visibility: 'visible'
      }
    },
    off: {
      '& > svg': {
        visibility: 'hidden'
      }
    }
  }), /*#__PURE__*/booleanVariantStyles('invalid', {
    on: /*#__PURE__*/_extends({
      borderColor: 'danger'
    }, /*#__PURE__*/booleanVariantStyles('focused', {
      on: {
        boxShadow: /*#__PURE__*/createControlFocusShadow('danger')
      }
    })),
    off: /*#__PURE__*/booleanVariantStyles('focused', {
      on: {
        boxShadow: /*#__PURE__*/createControlFocusShadow()
      }
    })
  })),
  variants: [/*#__PURE__*/booleanVariant('checked', true), /*#__PURE__*/booleanVariant('disabled', true), /*#__PURE__*/booleanVariant('invalid', true), /*#__PURE__*/booleanVariant('focused', true), /*#__PURE__*/booleanVariant('readOnly', true)]
});
var DefaultRadioToggler = /*#__PURE__*/memo(function (props) {
  return React.createElement(RadioToggler, Object.assign({}, props));
});
var Radio = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Radio(_ref, ref) {
  var _ref2;

  var $$variants = _ref.$$variants,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      _ref$hiddenLabel = _ref.hiddenLabel,
      hiddenLabel = _ref$hiddenLabel === void 0 ? false : _ref$hiddenLabel,
      invalid = _ref.invalid,
      label = _ref.label,
      labelProps = _ref.labelProps,
      labelTextProps = _ref.labelTextProps,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      readOnly = _ref.readOnly,
      parentStyles = _ref.parentStyles,
      styles = _ref.styles,
      _ref$toggler = _ref.toggler,
      Toggler = _ref$toggler === void 0 ? DefaultRadioToggler : _ref$toggler,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$v);

  var controlRef = useRef(null);
  var refCallback = useCombinedRef(controlRef, ref);

  var _useState = useState(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var _useState2 = useState((_ref2 = checked != null ? checked : defaultChecked) != null ? _ref2 : false),
      innerChecked = _useState2[0],
      setInnerChecked = _useState2[1];

  var onInnerBlur = useHandlerRef(function () {
    return setFocused(false);
  });
  var onInnerFocus = useHandlerRef(function () {
    return setFocused(true);
  });
  var onBlurHandler = useComposedCallbackCreator(onBlur, onInnerBlur);
  var onFocusHandler = useComposedCallbackCreator(onFocus, onInnerFocus);
  var onChangeHandler = useStaticCallbackCreator(wrapToggleOnChangeHandler, [readOnly, onChange, setInnerChecked]); // if checked is provided then the component is controlled

  var isChecked = checked != null ? checked : innerChecked;
  var isControlled = checked != null;
  useStaticEffect(detectRadioCheckedState, controlRef, isControlled, !!readOnly, setInnerChecked); // find out how uncontrolled components can be handled with onChange, especially radio which
  // fires only on change on a specific component, so the previous one does not react at all

  return React.createElement(RadioLabel, Object.assign({}, labelProps, {
    disabled: disabled,
    parentStyles: parentStyles,
    readOnly: readOnly,
    styles: styles,
    "$$variants": $$variants
  }), React.createElement(RadioControl, Object.assign({}, rest, {
    "aria-invalid": invalid,
    defaultChecked: defaultChecked,
    checked: checked,
    disabled: disabled,
    name: name,
    onBlur: onBlurHandler,
    onChange: onChangeHandler,
    onFocus: onFocusHandler,
    ref: refCallback,
    readOnly: readOnly,
    type: "radio"
  })), React.createElement(Toggler, {
    checked: isChecked,
    disabled: disabled,
    focused: focused,
    invalid: invalid,
    readOnly: readOnly
  }), "\u200B ", React.createElement(RadioLabelText, Object.assign({}, labelTextProps, {
    hidden: hiddenLabel
  }), label));
})));

var ScriptsStyles = {
  fontSize: '75%',
  lineHeight: '0px',
  position: 'relative',
  verticalAlign: 'baseline'
};
/**
 * Superscript component's style sheet
 */

var SuperscriptStyles = /*#__PURE__*/_extends({}, ScriptsStyles, {
  top: '-0.5em'
});
var Superscript = /*#__PURE__*/createComponent('sup', {
  displayName: 'Superscript',
  styles: SuperscriptStyles
});
/**
 * Subscript component's style sheet
 */

var SubscriptStyles = /*#__PURE__*/_extends({}, ScriptsStyles, {
  bottom: '-0.25em'
});
var Subscript = /*#__PURE__*/createComponent('sub', {
  displayName: 'Subscript',
  styles: SubscriptStyles
});

var _excluded$w = ["minHeight", "menuItem"],
    _excluded2$5 = ["focusedIndex", "id", "inputContainerRef", "listboxId", "menuProps", "open", "options", "optionToString", "onSelect"],
    _excluded3$2 = ["$$variants", "debounceDelay", "defaultValue", "disabled", "children", "id", "enhanceReducer", "menu", "onBlur", "onChange", "onFocus", "onInputValueChange", "onMouseDown", "onKeyDown", "onKeyUp", "onSelect", "onStateChange", "optionToString", "options", "parentStyles", "readOnly", "searchable", "styles", "toggler", "value", "valueToString"];

var optionId$1 = function optionId(id, index) {
  return index === -1 ? undefined : id + "-listbox-option-" + index;
};
/**
 * Creates Select menu component that can be used if you are happy
 * with default Menu
 */


function createSelectMenu(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 150 : _ref$minHeight,
      _ref$menuItem = _ref.menuItem,
      SelectMenuItem = _ref$menuItem === void 0 ? MenuItem : _ref$menuItem,
      restMenuOptions = _objectWithoutPropertiesLoose(_ref, _excluded$w);

  return createComponent(markAsVisageComponent(function (_ref2) {
    var focusedIndex = _ref2.focusedIndex,
        id = _ref2.id,
        inputContainerRef = _ref2.inputContainerRef,
        listboxId = _ref2.listboxId,
        menuProps = _ref2.menuProps,
        open = _ref2.open,
        options = _ref2.options,
        optionToString = _ref2.optionToString,
        onSelect = _ref2.onSelect,
        styleProps = _objectWithoutPropertiesLoose(_ref2, _excluded2$5);

    // ref to popover base because we can scroll only scrollable div
    var popoverRef = useRef(null);
    var onOptionClick = useHandlerRef(function (e) {
      onSelect(Number(e.currentTarget.dataset.optionIndex));
    });
    var onOptionMouseDown = useHandlerRef(function (e) {
      // prevent changing body activeElement and blur on input
      e.preventDefault();
    }); // scroll focused item into view

    useStaticEffect(scrollAriaSelectedElementToView, popoverRef, focusedIndex);
    return React.createElement(Menu, Object.assign({}, styleProps, menuProps, {
      anchor: inputContainerRef,
      disableEvents: true,
      keepAnchorWidth: true,
      id: listboxId,
      open: open,
      popoverProps: _extends({
        minHeight: minHeight
      }, menuProps == null ? void 0 : menuProps.popoverProps, {
        popoverRef: popoverRef
      }),
      role: "listbox",
      tabIndex: -1
    }), open ? options.map(function (option, index) {
      return React.createElement(SelectMenuItem, {
        "aria-selected": focusedIndex === index,
        "data-option-index": index,
        id: optionId$1(id, index),
        key: optionId$1(id, index),
        role: "option",
        onClick: onOptionClick,
        onMouseDown: onOptionMouseDown
      }, optionToString(option));
    }) : null);
  }), _extends({
    displayName: 'SelectMenu'
  }, restMenuOptions));
}
var SelectToggler = /*#__PURE__*/createComponent(function (_ref3) {
  var className = _ref3.className,
      onClick = _ref3.onClick,
      open = _ref3.open;
  return React.createElement(SvgIcon, {
    className: className,
    icon: open ? UnfoldLessIcon : UnfoldMoreIcon,
    onClick: onClick,
    role: "button",
    tabIndex: -1
  });
}, {
  displayName: 'SelectToggler'
});
var defaultMenu$1 = /*#__PURE__*/createSelectMenu();
var Select = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var $$variants = _ref4.$$variants,
      _ref4$debounceDelay = _ref4.debounceDelay,
      debounceDelay = _ref4$debounceDelay === void 0 ? 500 : _ref4$debounceDelay,
      defaultValue = _ref4.defaultValue,
      disabled = _ref4.disabled,
      outerId = _ref4.id,
      enhanceReducer = _ref4.enhanceReducer,
      _ref4$menu = _ref4.menu,
      DropdownMenu = _ref4$menu === void 0 ? defaultMenu$1 : _ref4$menu,
      onBlur = _ref4.onBlur,
      onChange = _ref4.onChange,
      onFocus = _ref4.onFocus,
      onInputValueChange = _ref4.onInputValueChange,
      onMouseDown = _ref4.onMouseDown,
      onKeyDown = _ref4.onKeyDown,
      onKeyUp = _ref4.onKeyUp,
      onStateChange = _ref4.onStateChange,
      optionToString = _ref4.optionToString,
      options = _ref4.options,
      parentStyles = _ref4.parentStyles,
      readOnly = _ref4.readOnly,
      searchable = _ref4.searchable,
      styles = _ref4.styles,
      _ref4$toggler = _ref4.toggler,
      Toggler = _ref4$toggler === void 0 ? SelectToggler : _ref4$toggler,
      value = _ref4.value,
      valueToString = _ref4.valueToString,
      restProps = _objectWithoutPropertiesLoose(_ref4, _excluded3$2);

  var id = useUniqueId(outerId, 'select');
  var listboxId = useUniqueId(null, 'listbox'); // last arrow pressed is used to automatically focus an option if automatic mode is turn on
  // and is reset to null when options are loaded

  var lastArrowPressed = useRef(null); // const menuBaseRef = useRef<HTMLDivElement>(null);

  var loadOptions = useHandlerRef(function (inputValue, dispatch) {
    if (!options) {
      return;
    } // load options sets the input as busy


    dispatch({
      type: 'SetBusy',
      isBusy: true,
      forInputValue: inputValue
    }); // and then on resolution sets options and not busy

    (Array.isArray(options) ? Promise.resolve(options) : options(inputValue)).then(function (newOptions) {
      return dispatch({
        type: 'SetOptions',
        options: newOptions,
        forInputValue: inputValue
      });
    })["finally"](function () {
      dispatch({
        type: 'SetBusy',
        isBusy: false,
        forInputValue: inputValue
      });

      if (lastArrowPressed.current === 'ArrowUp') {
        dispatch({
          type: 'SetOptionFocusToLastOption'
        });
      } else {
        dispatch({
          type: 'SetOptionFocusToFirstOption'
        });
      } // reset last arrow pressed


      lastArrowPressed.current = null;
    });
  });

  var _useDebouncedCallback = useDebouncedCallback(loadOptions, debounceDelay, [loadOptions]),
      debouncedLoadOptions = _useDebouncedCallback[0],
      cancelDebouncedLoadOptions = _useDebouncedCallback[1];

  var enhancedReducer = useHandlerRef(function (currentState, nextState) {
    // allow only to set value from outside if read only
    if (readOnly && nextState.invokedBy.type !== 'SetValue') {
      return currentState;
    } // if value changed, close the popup


    if (currentState.value !== nextState.value) {
      // eslint-disable-next-line no-param-reassign
      nextState.isOpen = false;
    } // if the action is MenuClose, reset input value if value is empty and reset options too


    if (nextState.invokedBy.type === 'MenuClose' && nextState.value == null) {
      // eslint-disable-next-line no-param-reassign
      nextState.inputValue = ''; // eslint-disable-next-line no-param-reassign

      nextState.options = [];
    }

    return enhanceReducer ? enhanceReducer(currentState, nextState) : nextState;
  });
  var enhancedOnStateChange = useHandlerRef(function (previousState, currentState, dispatch) {
    if (onStateChange) {
      onStateChange(previousState, currentState, dispatch);
    } // if input value has changed because of InputChanged action
    // load options debounced


    if (currentState.invokedBy.type === 'InputChange' && previousState.inputValue !== currentState.inputValue) {
      debouncedLoadOptions(currentState.inputValue, dispatch);
    } // if input has opened cancel debounced load options and load options directly
    // only if it was not open by InputChange action


    if (previousState.invokedBy.type !== 'InputChange' && previousState.isOpen !== currentState.isOpen && currentState.isOpen) {
      cancelDebouncedLoadOptions();

      if (currentState.options.length === 0) {
        loadOptions(currentState.inputValue, dispatch);
      }
    }
  });

  var _useSelector = useSelector({
    defaultValue: defaultValue,
    enhanceReducer: enhancedReducer,
    onChange: onChange,
    onInputValueChange: onInputValueChange,
    optionToString: optionToString,
    onStateChange: enhancedOnStateChange,
    value: value,
    valueToString: valueToString
  }),
      state = _useSelector[0],
      dispatch = _useSelector[1];

  var inputRef = useRef(null);
  var inputRefCallback = useCombinedRef(inputRef, ref);
  var inputContainerRef = useRef(null);
  var onToggleClick = useHandlerRef(function () {
    if (!readOnly || disabled) {
      dispatch({
        type: 'MenuToggle'
      });

      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  });
  var onInnerBlur = useHandlerRef(function () {
    dispatch({
      type: 'MenuClose'
    });
    dispatch({
      type: 'Blur'
    });
  });
  var onInnerFocus = useHandlerRef(function () {
    return dispatch({
      type: 'Focus'
    });
  });
  var onInputChange = useHandlerRef(function (e) {
    return dispatch({
      type: 'InputChange',
      value: e.currentTarget.value
    });
  });
  var onInnerMouseDown = useHandlerRef(function (e) {
    // react only on primary button
    if (e.button !== 0) {
      return;
    }

    if (!state.isOpen) {
      dispatch({
        type: 'MenuOpen'
      });
      dispatch({
        type: 'SetOptionFocusToFirstOption'
      });
    }
  });
  var onInnerKeyUp = useHandlerRef(function (e) {
    var key = normalizeKeyboardEventKey(e);

    if (key === 'Escape') {
      e.preventDefault(); // close menu if open, or reset the input

      if (state.isOpen) {
        dispatch({
          type: 'MenuClose'
        });
      } else {
        dispatch({
          type: 'Reset'
        });
      }
    }
  });
  var onInnerKeyDown = useHandlerRef(function (e) {
    var key = normalizeKeyboardEventKey(e);

    switch (key) {
      case 'ArrowUp':
        {
          e.preventDefault();
          lastArrowPressed.current = key;

          if (state.isOpen) {
            dispatch({
              type: 'SetOptionFocusByOffset',
              offset: -1
            });
          } else {
            dispatch({
              type: 'MenuOpen'
            });
            dispatch({
              type: 'SetOptionFocusToLastOption'
            });
          }

          break;
        }

      case 'ArrowDown':
        {
          e.preventDefault();
          lastArrowPressed.current = key;

          if (state.isOpen) {
            dispatch({
              type: 'SetOptionFocusByOffset',
              offset: 1
            });
          } else {
            dispatch({
              type: 'MenuOpen'
            });
            dispatch({
              type: 'SetOptionFocusToFirstOption'
            });
          }

          break;
        }

      case 'End':
        {
          e.preventDefault();
          dispatch({
            type: 'SetOptionFocusToLastOption'
          });
          break;
        }

      case 'Enter':
        {
          e.preventDefault();
          dispatch({
            type: 'SetCurrentFocusedOption'
          });
          break;
        }

      case 'Home':
        {
          e.preventDefault();
          dispatch({
            type: 'SetOptionFocusToFirstOption'
          });
          break;
        }

      case ' ':
        {
          if (state.isOpen && !searchable) {
            e.preventDefault();
            dispatch({
              type: 'SetCurrentFocusedOption'
            });
          }

          break;
        }
    }
  });
  var onBlurHandler = useComposedCallbackCreator(onBlur, onInnerBlur);
  var onFocusHandler = useComposedCallbackCreator(onFocus, onInnerFocus);
  var onKeyUpHandler = useComposedCallbackCreator(onKeyUp, onInnerKeyUp);
  var onKeyDownHandler = useComposedCallbackCreator(onKeyDown, onInnerKeyDown);
  var onMouseDownHandler = useComposedCallbackCreator(onMouseDown, onInnerMouseDown);
  var onOptionSelect = useHandlerRef(function (optionIndex) {
    dispatch({
      type: 'SetValueByIndex',
      index: optionIndex
    });
    dispatch({
      type: 'MenuClose'
    });
  });
  return React.createElement(React.Fragment, null, React.createElement(TextInput, Object.assign({
    autoCorrect: "off",
    autoCapitalize: "none",
    autoComplete: "new-password",
    spellCheck: false
  }, restProps, {
    "aria-activedescendant": state.isOpen ? optionId$1(id, state.focusedIndex) : undefined,
    "aria-autocomplete": "list",
    "aria-controls": listboxId,
    baseProps: _extends({}, restProps.baseProps, {
      'aria-busy': state.isBusy,
      'aria-expanded': state.isOpen,
      'aria-owns': listboxId,
      ref: inputContainerRef,
      role: 'combobox'
    }),
    disabled: disabled,
    id: id,
    readOnly: readOnly || !searchable,
    ref: inputRefCallback,
    onBlur: onBlurHandler,
    onChange: onInputChange,
    onFocus: onFocusHandler,
    onMouseDown: onMouseDownHandler,
    onKeyUp: onKeyUpHandler,
    onKeyDown: onKeyDownHandler,
    parentStyles: parentStyles,
    styles: styles,
    suffix: React.createElement(Toggler, {
      open: state.isOpen,
      onClick: onToggleClick
    }),
    "$$variants": $$variants,
    value: state.inputValue
  })), React.createElement(DropdownMenu, {
    focusedIndex: state.focusedIndex,
    inputContainerRef: inputContainerRef,
    id: id,
    listboxId: listboxId,
    onSelect: onOptionSelect,
    open: state.isOpen,
    options: state.options,
    optionToString: state.optionToString
  }));
}));

var _excluded$x = ["allowedValues", "colors", "direction", "disabled", "max", "min", "onChange", "onFinalChange", "renderThumb", "renderTrack", "readOnly", "step", "values"],
    _excluded2$6 = ["disabled", "props", "children"],
    _excluded3$3 = ["props"];
var SliderDirection = Direction;
var SliderThumb = /*#__PURE__*/createComponent(Flex, {
  displayName: 'SliderThumb',
  styles: {
    transition: 'box-shadow 150ms ease-in',
    height: ['3rem', '3rem', '1.5rem'],
    width: ['3rem', '3rem', '1.5rem'],
    borderRadius: '50%',
    backgroundColor: '#FFF',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0px 2px 6px #AAA',
    '&:focus': {
      outline: 'none',
      boxShadow: "0px 2px 6px #AAA, " + /*#__PURE__*/createControlFocusShadow('primary')
    },
    '&:focus:active': {
      boxShadow: /*#__PURE__*/createControlActiveShadow('primary')
    }
  }
});
var SliderTrack = /*#__PURE__*/createComponent(Flex, {
  displayName: 'SliderTrack',
  styles: /*#__PURE__*/_extends({
    height: '2.5rem',
    width: '100%'
  }, /*#__PURE__*/booleanVariantStyles('disabled', {
    on: {
      opacity: 0.3
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('disabled', true)]
});
var SliderTrackProgress = /*#__PURE__*/createComponent(Box, {
  displayName: 'SliderTrackProgress',
  styles: {
    height: '0.5rem',
    width: '100%',
    alignSelf: 'center',
    borderRadius: 'controlBorderRadius'
  }
});
var defaultColors = ['primary', 'color(shades if(isDark color(shades tint(10%)) color(shades shade(10%))))'];
var Slider = function Slider(_ref) {
  var allowedValues = _ref.allowedValues,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? defaultColors : _ref$colors,
      direction = _ref.direction,
      disabled = _ref.disabled,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      onChange = _ref.onChange,
      onFinalChange = _ref.onFinalChange,
      thumbRenderer = _ref.renderThumb,
      trackRenderer = _ref.renderTrack,
      readOnly = _ref.readOnly,
      step = _ref.step,
      values = _ref.values,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$x);

  var ctx = useDesignSystem();
  var background = useMemo(function () {
    return getTrackBackground({
      values: values,
      colors: colors.map(function (c) {
        return ctx.ctx.resolve('color', c, ctx.ctx);
      }),
      min: min,
      max: max,
      direction: direction
    });
  }, [ctx, colors, values, min, max, direction]);
  var onChangeHandler = useHandlerRef(function (vals) {
    if (allowedValues && !vals.every(function (it) {
      return allowedValues.includes(it);
    })) {
      return;
    }

    if (onChange) {
      onChange(vals);
    }
  });
  var onFinalChangeHandler = useHandlerRef(function (vals) {
    if (allowedValues && !vals.every(function (it) {
      return allowedValues.includes(it);
    })) {
      return;
    }

    if (onFinalChange) {
      onFinalChange(vals);
    }
  });
  var renderTrack = useHandlerRef(function (_ref2) {
    var isDisabled = _ref2.disabled,
        props = _ref2.props,
        children = _ref2.children,
        extra = _objectWithoutPropertiesLoose(_ref2, _excluded2$6);

    if (trackRenderer) {
      return trackRenderer(_extends({}, props, extra, {
        background: background,
        children: children,
        disabled: isDisabled,
        readOnly: readOnly
      }));
    }

    return React.createElement(SliderTrack //  only really disabled, because we set disabled for readOnly too
    , {
      //  only really disabled, because we set disabled for readOnly too
      disabled: isDisabled ? disabled : false,
      onMouseDown: !readOnly ? props.onMouseDown : undefined,
      onTouchStart: !readOnly ? props.onTouchStart : undefined,
      style: props.style
    }, React.createElement(SliderTrackProgress, {
      ref: props.ref,
      style: {
        background: background
      }
    }, children));
  });
  var renderThumb = useHandlerRef(function (_ref3) {
    var props = _ref3.props,
        extra = _objectWithoutPropertiesLoose(_ref3, _excluded3$3);

    if (thumbRenderer) {
      return thumbRenderer(_extends({}, props, extra, {
        disabled: disabled,
        readOnly: readOnly
      }));
    }

    return React.createElement(SliderThumb, Object.assign({
      "aria-disabled": disabled,
      "aria-readonly": readOnly
    }, props, {
      onKeyDown: !readOnly ? props.onKeyDown : undefined,
      onKeyUp: !readOnly ? props.onKeyUp : undefined,
      tabIndex: readOnly ? undefined : props.tabIndex
    }));
  });
  return React.createElement(Range, Object.assign({
    disabled: disabled || readOnly,
    direction: direction,
    values: values,
    step: step,
    min: min,
    max: max,
    onChange: onChangeHandler,
    onFinalChange: onFinalChangeHandler
  }, restProps, {
    renderTrack: renderTrack,
    renderThumb: renderThumb
  }));
};

var _excluded$y = ["baseProps", "defaultValue", "disabled", "label", "min", "max", "nextButtonProps", "onChange", "readOnly", "renderValue", "previousButtonProps", "value", "valueText", "values"];
var SpinButtonBase = /*#__PURE__*/createComponent('div', {
  displayName: 'SpinButtonBase',
  styles: /*#__PURE__*/_extends({
    display: 'inline-flex',
    flexDirection: 'column'
  }, /*#__PURE__*/booleanVariantStyles('disabled', {
    on: {
      opacity: 0.3
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('disabled', true)]
});
var SpinButtonButton = /*#__PURE__*/createComponent('button', {
  displayName: 'SpinButtonButton',
  defaultProps: {
    tabIndex: -1,
    type: 'button'
  },
  styles: {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: 'inherit',
    cursor: 'pointer',
    outline: 'none',
    m: 0,
    p: 0
  }
});
var SpinButtonOtherValue = /*#__PURE__*/createComponent('div', {
  displayName: 'SpinButtonOtherValue',
  defaultProps: {
    'aria-hidden': true
  },
  styles: {
    p: 1,
    opacity: 0.7
  }
});
var SpinButtonValue = /*#__PURE__*/createComponent('div', {
  displayName: 'SpinButtonValue',
  styles: {
    fontWeight: 600,
    outline: 'none',
    p: 1,
    '&:focus': {
      boxShadow: /*#__PURE__*/createControlFocusShadow()
    }
  }
});
var SpinButtonExpander = /*#__PURE__*/createComponent('div', {
  defaultProps: {
    'aria-hidden': true
  },
  styles: {
    overflow: 'hidden',
    height: 0,
    fontWeight: 600,
    maxHeight: 0,
    m: 0,
    py: 0,
    px: 1
  }
});

function defaultRenderValue(_ref) {
  var value = _ref.value;
  return React.createElement("div", {
    style: {
      textAlign: 'center',
      width: '100%'
    }
  }, value);
}

function mouseDownHandlerCreator(selectedIndex, lastIndex, onChange, shouldIncrement) {
  if (shouldIncrement === void 0) {
    shouldIncrement = true;
  }

  return function (e) {
    // only main button
    if (e.button !== 0) {
      return;
    }

    onChange(getNextIndexFromCycle(selectedIndex, shouldIncrement ? 1 : -1, lastIndex));
  };
}

var SpinButton = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var baseProps = _ref2.baseProps,
      defaultValue = _ref2.defaultValue,
      disabled = _ref2.disabled,
      label = _ref2.label,
      min = _ref2.min,
      max = _ref2.max,
      nextButtonProps = _ref2.nextButtonProps,
      onChange = _ref2.onChange,
      readOnly = _ref2.readOnly,
      _ref2$renderValue = _ref2.renderValue,
      renderValue = _ref2$renderValue === void 0 ? defaultRenderValue : _ref2$renderValue,
      previousButtonProps = _ref2.previousButtonProps,
      value = _ref2.value,
      valueText = _ref2.valueText,
      _ref2$values = _ref2.values,
      values = _ref2$values === void 0 ? [] : _ref2$values,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded$y);

  // component is controlled only if value is not null / undefined
  var isControlled = value != null;

  var _useState = useState(function () {
    return Math.max(values.indexOf(value != null ? value : defaultValue), 0);
  }),
      selectedIndex = _useState[0],
      setSelectedIndex = _useState[1];

  var currentIndex = isControlled ? Math.max(values.indexOf(value != null ? value : defaultValue), 0) : selectedIndex;
  var currentValue = values[currentIndex];
  var valuesLengthRef = useRef(values.length);
  var valueTextFn = useMemo(function () {
    if (typeof valueText === 'function') {
      return valueText;
    }

    return function (val) {
      if (valueText) {
        return valueText;
      }

      var currentValueType = typeof val;

      if (currentValueType === 'number' || currentValueType === 'string') {
        return val.toString();
      }

      return undefined;
    };
  }, [valueText]);
  var valueElementRef = useRef();
  var valueElementRefCallback = useCombinedRef(valueElementRef, ref);
  var handleChange = useHandlerRef(function (index) {
    if (!isControlled) {
      setSelectedIndex(index);
    } else if (onChange) {
      onChange(values[index]);
    }
  });
  var onIncrementMouseDown = useStaticCallbackCreator(mouseDownHandlerCreator, [currentIndex, values.length - 1, handleChange, true]);
  var onDecrementMouseDown = useStaticCallbackCreator(mouseDownHandlerCreator, [currentIndex, values.length - 1, handleChange, false]);
  var onKeyDown = useHandlerRef(function (e) {
    switch (e.key) {
      case 'ArrowDown':
        {
          e.preventDefault();
          handleChange(getNextIndexFromCycle(currentIndex, 1, values.length - 1));
          break;
        }

      case 'ArrowUp':
        {
          e.preventDefault();
          handleChange(getNextIndexFromCycle(currentIndex, -1, values.length - 1));
          break;
        }

      case 'PageUp':
        {
          e.preventDefault();
          handleChange(getNextIndexFromCycle(currentIndex, -5, values.length - 1));
          break;
        }

      case 'PageDown':
        {
          e.preventDefault();
          handleChange(getNextIndexFromCycle(currentIndex, 5, values.length - 1));
          break;
        }

      case 'Home':
        {
          e.preventDefault();
          handleChange(0);
          break;
        }

      case 'End':
        {
          e.preventDefault();
          handleChange(values.length - 1);
          break;
        }
    }
  }); // if values length changes, reset value but only if uncontrolled

  if (values.length !== valuesLengthRef.current) {
    valuesLengthRef.current = values.length;

    if (!isControlled) {
      // reset to initial if selected index is out of bounds
      if (selectedIndex < 0 || selectedIndex > valuesLengthRef.current - 1) {
        setSelectedIndex(0);
      }
    }
  }

  return React.createElement(SpinButtonBase, Object.assign({}, baseProps, {
    disabled: disabled
  }), React.createElement(SpinButtonExpander, null, values.map(function (val, i) {
    return React.createElement("div", {
      key: i
    }, renderValue({
      value: val
    }));
  })), React.createElement(SpinButtonButton, Object.assign({
    "aria-label": "Previous value"
  }, previousButtonProps, {
    disabled: disabled || readOnly,
    onMouseDown: onDecrementMouseDown
  }), React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M18 15l-6-6-6 6"
  }))), React.createElement(SpinButtonOtherValue, null, renderValue({
    value: values[getNextIndexFromCycle(currentIndex, -1, values.length - 1)]
  })), React.createElement(SpinButtonValue, Object.assign({}, restProps, {
    "aria-disabled": disabled,
    "aria-label": label,
    "aria-valuemin": min != null ? min : 0,
    "aria-valuemax": max != null ? max : values.length - 1,
    "aria-valuenow": currentIndex,
    "aria-valuetext": valueTextFn(currentValue),
    "aria-readonly": readOnly,
    onChange: onChange,
    onKeyDown: disabled || readOnly ? undefined : onKeyDown,
    ref: valueElementRefCallback,
    role: "spinbutton",
    tabIndex: disabled ? undefined : 0
  }), renderValue({
    value: currentValue
  })), React.createElement(SpinButtonOtherValue, null, renderValue({
    value: values[getNextIndexFromCycle(currentIndex, 1, values.length - 1)]
  })), React.createElement(SpinButtonButton, Object.assign({
    "aria-label": "Next value"
  }, nextButtonProps, {
    disabled: disabled || readOnly,
    onMouseDown: onIncrementMouseDown
  }), React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M6 9l6 6 6-6"
  }))));
})));

var circleDashAnimation = /*#__PURE__*/keyframes({
  '0%': {
    strokeDasharray: '1, 200',
    strokeDashoffset: 0
  },
  '50%': {
    strokeDasharray: '89, 200',
    strokeDashoffset: -35
  },
  '100%': {
    strokeDasharray: '89, 200',
    strokeDashoffset: -124
  }
});
var Spinner = /*#__PURE__*/createComponent('div', {
  displayName: 'SpinnerSvgBase',
  defaultProps: {
    children: /*#__PURE__*/React.createElement(SpinnerIcon, null),
    role: 'status'
  },
  styles: {
    alignItems: 'center',
    display: 'inline-flex',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    '&::before': {
      // respect line height
      content: '"\\200b"'
    },
    '& svg': {
      height: '1em',
      transformOrigin: 'center center',
      verticalAlign: 'middle'
    },
    '& circle': {
      animation: circleDashAnimation + " 1.5s ease-in-out infinite",
      strokeDasharray: '150, 200',
      strokeDashoffset: -10,
      strokeLinecap: 'round'
    }
  }
});

var _excluded$z = ["children", "selected", "label", "onClick", "onKeyDown"],
    _excluded2$7 = ["children", "id", "selected", "tabListProps"];
var TabsWrapper = /*#__PURE__*/createComponent(Flex, {
  displayName: 'Tabs',
  styles: {
    flexDirection: 'column',
    width: '100%'
  }
});
var TabList = /*#__PURE__*/createComponent('div', {
  displayName: 'TabList',
  styles: {
    borderBottomWidth: '1px',
    borderBottomColor: 'color(shades if(isDark, color(shades tint(10%)), color(shades shade(10%))))',
    borderBottomStyle: 'solid',
    boxShadow: 'none',
    display: 'flex',
    flexShrink: 0,
    m: 0,
    mb: 1,
    overflowX: 'auto',
    p: 0,
    width: '100%',
    // hide scrollbar
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  }
});
var TabNavigationButton = /*#__PURE__*/createComponent('button', {
  displayName: 'TabNavigationButton',
  styles: {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: 0,
    borderBottomWidth: 2,
    fontFamily: 'body',
    color: 'shadesText',
    cursor: 'pointer',
    flexShrink: 0,
    fontSize: 1,
    lineHeight: 1,
    outline: 'none',
    py: 1,
    pl: 0,
    pr: 2,
    m: 0,
    mr: 1,
    textDecoration: 'none',
    transition: 'border-color 150ms ease-out',
    willChange: 'border-color',
    '&[aria-selected="true"]': {
      color: 'primary',
      borderBottomColor: 'primary',
      fontWeight: 'bold'
    },
    '&:focus': {
      borderBottomColor: 'shadesText'
    },
    '&[disabled]': {
      cursor: 'default',
      opacity: 0.3
    }
  }
});
function Tab(_ref) {
  var children = _ref.children,
      selected = _ref.selected,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$z);

  return React.createElement(Box, Object.assign({}, restProps), typeof children === 'function' ? selected ? children() : null : children);
}
function Tabs(_ref2) {
  var children = _ref2.children,
      outerId = _ref2.id,
      _ref2$selected = _ref2.selected,
      selected = _ref2$selected === void 0 ? 0 : _ref2$selected,
      tabListProps = _ref2.tabListProps,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded2$7);

  var id = useUniqueId(outerId, 'tabs');
  var childrenArray = Children.toArray(children);
  var tabsLabel = childrenArray.map(function (c) {
    return c.props.label;
  });
  var selectedRef = useRef(selected);
  var focusedTabRef = useRef(null);

  var _useState = useState(selected),
      selectedTab = _useState[0],
      selectTab = _useState[1];

  var onClick = useHandlerRef(function (e) {
    var index = Number(e.currentTarget.dataset.index);

    if (e.currentTarget.getAttribute('aria-disabled') === 'true') {
      return;
    }

    if (childrenArray[index].props.onClick) {
      e.persist();
      childrenArray[index].props.onClick(e);
    }

    if (e.defaultPrevented) {
      return;
    }

    e.preventDefault();
    selectTab(index);
  });
  var onTabFocus = useCallback(function (e) {
    focusedTabRef.current = e.currentTarget;
  }, []);
  var onKeyDown = useHandlerRef(function (e) {
    var index = Number(e.currentTarget.dataset.index);

    if (e.currentTarget.disabled) {
      return;
    }

    switch (e.key) {
      case ' ':
      case 'Enter':
        {
          if (childrenArray[index].props.onKeyDown) {
            childrenArray[index].props.onKeyDown(e);
          }

          if (e.defaultPrevented) {
            return;
          }

          e.preventDefault();
          selectTab(index);
          break;
        }

      case 'ArrowLeft':
      case 'ArrowRight':
        {
          e.preventDefault();
          var tab = focusedTabRef.current[e.key === 'ArrowLeft' ? 'previousElementSibling' : 'nextElementSibling'];

          do {
            if (tab) {
              if (tab.disabled) {
                // go to next sibling
                tab = tab[e.key === 'ArrowLeft' ? 'previousElementSibling' : 'nextElementSibling'];
              } else {
                break;
              }
            } else {
              // there is no next tab, find the first children of a parent
              tab = focusedTabRef.current.parentElement[e.key === 'ArrowLeft' ? 'lastElementChild' : 'firstElementChild'];
            }
          } while (true);

          tab.focus();
          break;
        }

      case 'End':
      case 'Home':
        {
          e.preventDefault();
          var _tab = focusedTabRef.current.parentElement[e.key === 'End' ? 'lastElementChild' : 'firstElementChild'];

          do {
            if (_tab) {
              if (_tab.disabled) {
                _tab = _tab[e.key === 'End' ? 'previousElementSibling' : 'nextElementSibling'];
              } else {
                break;
              }
            } else {
              _tab = focusedTabRef.current.parentElement.firstElementChild;
            }
          } while (true);

          _tab.focus();

          break;
        }
    }
  });

  if (selectedRef.current !== selected) {
    selectedRef.current = selected;
    selectTab(selected);
  }

  return React.createElement(TabsWrapper, Object.assign({}, restProps), React.createElement(TabList, Object.assign({
    role: "tablist"
  }, tabListProps), tabsLabel.map(function (tabLabel, i) {
    var isSelected = selectedTab === i;
    var isDisabled = !!childrenArray[i].props.disabled;
    return React.createElement(TabNavigationButton, {
      id: id + "-tab-label-" + i,
      "aria-controls": id + "-tab-panel-" + i,
      "aria-selected": isSelected,
      disabled: isDisabled,
      "data-index": i,
      key: i,
      onClick: onClick,
      onFocus: onTabFocus,
      onKeyDown: onKeyDown,
      role: "tab",
      tabIndex: isSelected ? 0 : -1,
      type: "button"
    }, tabLabel);
  })), childrenArray.map(function (tab, i) {
    return cloneElement(tab, {
      'aria-labelledby': id + "-tab-label-" + i,
      id: id + "-tab-panel-" + i,
      hidden: selectedTab !== i,
      role: 'tabpanel',
      selected: selectedTab === i,
      tabIndex: 0
    });
  }));
}

var _excluded$A = ["autoResize", "defaultValue", "value"];
var TextAreaBaseControl = /*#__PURE__*/createComponent('textarea', {
  displayName: 'TextArea',
  styles: /*#__PURE__*/_extends({}, TextInputBaseStyles, {
    m: 0,
    resize: 'none',
    p: 1,
    width: '100%',
    '&[disabled]': disabledControlStyles
  }, /*#__PURE__*/booleanVariantStyles('invalid', {
    on: invalidControlStyles
  }), {
    '::placeholder': {
      color: 'color(shadesText alpha(0.3))'
    }
  }),
  variants: [disabledControlBooleanVariant, invalidControlBooleanVariant]
});

var recomputeTextAreaHeight = function recomputeTextAreaHeight(textArea) {
  /* eslint-disable no-param-reassign */
  textArea.style.height = 'auto';
  textArea.style.height = textArea.scrollHeight + "px";
  /* eslint-enable no-param-reassign */
};

var TextArea = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _restProps$invalid;

  var autoResize = _ref.autoResize,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$A);

  var textAreaRef = useRef(null);
  var textAreaRefCallback = useCombinedRef(textAreaRef, ref);
  useEffect(function () {
    var textArea = textAreaRef.current;

    if (!autoResize || textArea == null) {
      return;
    }

    var listener = function listener(e) {
      if (e.currentTarget instanceof HTMLTextAreaElement) {
        recomputeTextAreaHeight(e.currentTarget);
      }
    };

    textArea.addEventListener('input', listener);
    return function () {
      textArea.removeEventListener('input', listener);
    };
  }, [autoResize]);
  useEffect(function () {
    var textArea = textAreaRef.current;

    if (autoResize && textArea) {
      recomputeTextAreaHeight(textArea);
    }
  }, [autoResize, defaultValue, value]);
  return React.createElement(TextAreaBaseControl, Object.assign({
    "aria-invalid": (_restProps$invalid = restProps.invalid) != null ? _restProps$invalid : undefined,
    ref: textAreaRefCallback,
    defaultValue: defaultValue,
    value: value
  }, restProps));
}));
TextArea.displayName = 'TextArea';

var _excluded$B = ["children", "duration", "onDismiss"];
var defaultState = {
  index: -1,
  toasts: []
};

function toastsReducer(state, action) {
  switch (action.type) {
    case 'MOUNT':
      {
        var index = state.index + 1;
        return {
          index: index,
          toasts: [].concat(state.toasts, [{
            key: index,
            toast: action.toast
          }])
        };
      }

    case 'UNMOUNT':
      {
        return _extends({}, state, {
          toasts: state.toasts.filter(function (t) {
            return t.toast !== action.toast;
          })
        });
      }

    default:
      return state;
  }
}

var ToastManager = /*#__PURE__*/createComponent(function (props) {
  var _useReducer = useReducer(toastsReducer, defaultState),
      toasts = _useReducer[0],
      dispatch = _useReducer[1];

  var toastEventEmitter = useEventEmitter();
  useEffect(function () {
    var unbindMount = toastEventEmitter.on('MOUNT', function (toast) {
      return dispatch({
        type: 'MOUNT',
        toast: toast
      });
    });
    var unbindUnmount = toastEventEmitter.on('UNMOUNT', function (toast) {
      return dispatch({
        type: 'UNMOUNT',
        toast: toast
      });
    });
    return function () {
      unbindMount();
      unbindUnmount();
    };
  }, [toastEventEmitter]);
  return React.createElement("div", Object.assign({
    "aria-live": "polite",
    "data-toastmanager": true
  }, props), toasts.toasts.map(function (toast, index) {
    return cloneElement(toast.toast, {
      key: toast.key,
      style: {
        transform: "translateY(-" + (index + 1) * 80 + "px)"
      }
    });
  }));
}, {
  displayName: 'ToastManager',
  styles: {
    justifyContent: 'center',
    display: 'flex',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 600
  }
});
var toastVariants = {
  danger: {
    backgroundColor: 'danger',
    color: 'dangerText'
  },
  info: {
    backgroundColor: 'info',
    color: 'infoText'
  },
  primary: {
    backgroundColor: 'primary',
    color: 'primaryText'
  },
  success: {
    backgroundColor: 'success',
    color: 'successText'
  },
  warning: {
    backgroundColor: 'warning',
    color: 'warningText'
  },
  "default": {
    backgroundColor: 'neutral',
    color: 'neutralText'
  }
};
var Toast = /*#__PURE__*/createComponent(function (_ref) {
  var children = _ref.children,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 5000 : _ref$duration,
      onDismiss = _ref.onDismiss,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$B);

  var onDismissRef = useRef(null);
  var expirationTimeout = useRef(null);
  var toastEventEmitter = useEventEmitter(); // override onDismiss every time, we don't want to update toast after initial render

  onDismissRef.current = onDismiss; // we want this effect to be called only on mount

  /* eslint-disable react-hooks/exhaustive-deps */

  useEffect(function () {
    var dismiss = function dismiss() {
      if (onDismissRef.current) {
        onDismissRef.current();
      }
    };

    var time = Date.now();

    var onMouseOver = function onMouseOver() {
      window.clearTimeout(expirationTimeout.current);
    };

    var onMouseOut = function onMouseOut() {
      // resume timeout
      var remainingTime = duration - (Date.now() - time);

      if (remainingTime > 0) {
        expirationTimeout.current = window.setTimeout(dismiss, remainingTime);
      } else {
        dismiss();
      }
    };

    var toast = React.createElement("div", Object.assign({}, restProps, {
      onFocus: onMouseOver,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      onBlur: onMouseOut
    }), children, React.createElement(CloseButton, {
      styles: {
        ml: 'auto'
      },
      onClick: dismiss
    }));
    toastEventEmitter.emit('MOUNT', toast);
    expirationTimeout.current = window.setTimeout(dismiss, duration);
    return function () {
      clearTimeout(expirationTimeout.current);
      toastEventEmitter.emit('UNMOUNT', toast);
    };
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  return null;
}, {
  displayName: 'Toast',
  styles: function styles(props) {
    return _extends({
      alignItems: 'center',
      boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 15px 0px rgba(0,0,0,0.12)',
      display: 'inline-flex',
      lineHeight: 0,
      position: 'absolute',
      transition: 'transform .4s ease, opacity .4s ease',
      willChange: 'transform, opacity',
      fontSize: 0,
      minWidth: '240px',
      pl: 2,
      pr: 1,
      py: 1
    }, toastVariants[props.variant || 'default'] || toastVariants["default"]);
  },
  variants: [/*#__PURE__*/variant('variant', true)]
});

var _excluded$C = ["$$variants", "defaultChecked", "disabled", "checked", "hiddenLabel", "invalid", "label", "labelProps", "labelTextProps", "leftContent", "rightContent", "onBlur", "onChange", "onFocus", "readOnly", "parentStyles", "styles", "value"];
var ToggleContainer = /*#__PURE__*/createComponent('div', {
  displayName: 'ToggleContainer',
  styles: /*#__PURE__*/_extends({
    overflow: 'hidden',
    borderRadius: 999,
    width: 'auto',
    display: 'inline-flex',
    height: '1.5em',
    minWidth: '2.75em',
    fontSize: '16px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    outline: 'none',
    userSelect: 'none',
    my: 0.5,
    backgroundColor: 'color(shades if(isDark color(shades tint(10%)) color(shades shade(10%))))',
    transitionProperty: 'all',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease-out',
    '& > div::after': {
      content: '""',
      verticalAlign: 'middle',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '1.25em',
      height: '1.25em',
      position: 'absolute',
      borderRadius: '50%',
      backgroundColor: 'white',
      transitionProperty: 'transform, color',
      transitionDuration: '0.1s',
      transitionTimingFunction: 'ease-out'
    },
    '& > div::before': {
      content: 'attr(data-label-content)',
      position: 'absolute',
      mx: 1,
      fontSize: '0.75em',
      textAlign: 'center',
      color: 'accentText',
      top: '50%',
      transform: 'translate(-50%,-50%)',
      whiteSpace: 'nowrap',
      left: '50%'
    }
  }, /*#__PURE__*/booleanVariantStyles('checked', {
    on: {
      backgroundColor: 'primary',
      '& > div': {
        transform: 'translateX(100%) translateX(-1.25em)'
      },
      '& > div::before': {
        left: '-50%'
      }
    }
  }), /*#__PURE__*/booleanVariantStyles('focused', {
    on: /*#__PURE__*/_extends({
      boxShadow: /*#__PURE__*/createControlFocusShadow()
    }, /*#__PURE__*/booleanVariantStyles('invalid', {
      on: {
        boxShadow: /*#__PURE__*/createControlFocusShadow('danger')
      }
    }))
  }), /*#__PURE__*/booleanVariantStyles('invalid', {
    on: {
      borderColor: 'danger'
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('checked', true), /*#__PURE__*/booleanVariant('focused', true), /*#__PURE__*/booleanVariant('invalid', true)]
});
var ToggleControl = /*#__PURE__*/createComponent('input', {
  displayName: 'ToggleControl',
  styles: visuallyHiddenStyles
});
var Toggler = /*#__PURE__*/createComponent('div', {
  displayName: 'ToggleToggler',
  styles: {
    fontSize: 'inherit',
    display: 'inline-block',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    position: 'relative',
    transitionProperty: 'transform, color',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease-out'
  }
});
var ToggleLabelText = /*#__PURE__*/createComponent('span', {
  displayName: 'ToggleLabelText',
  styles: /*#__PURE__*/_extends({
    fontSize: 'inherit',
    lineHeight: 'inherit',
    position: 'relative',
    outline: 'none',
    userSelect: 'none',
    mx: 1
  }, /*#__PURE__*/booleanVariantStyles('hidden', {
    on: visuallyHiddenStyles
  })),
  variants: [visuallyHiddenBooleanVariant]
});
var ToggleLabel = /*#__PURE__*/createComponent('label', {
  displayName: 'ToggleLabel',
  styles: /*#__PURE__*/_extends({
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex'
  }, /*#__PURE__*/booleanVariantStyles('disabled', {
    on: disabledControlStyles
  }), /*#__PURE__*/booleanVariantStyles('readOnly', {
    on: {
      cursor: 'default'
    }
  })),
  variants: [/*#__PURE__*/booleanVariant('disabled', true), /*#__PURE__*/booleanVariant('readOnly', true)]
});
var Toggle = /*#__PURE__*/markAsVisageComponent( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Toggle(_ref, ref) {
  var _ref2;

  var $$variants = _ref.$$variants,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      checked = _ref.checked,
      _ref$hiddenLabel = _ref.hiddenLabel,
      hiddenLabel = _ref$hiddenLabel === void 0 ? false : _ref$hiddenLabel,
      invalid = _ref.invalid,
      label = _ref.label,
      labelProps = _ref.labelProps,
      labelTextProps = _ref.labelTextProps,
      leftContent = _ref.leftContent,
      rightContent = _ref.rightContent,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      readOnly = _ref.readOnly,
      parentStyles = _ref.parentStyles,
      styles = _ref.styles,
      value = _ref.value,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$C);

  var _useState = useState(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var _useState2 = useState((_ref2 = checked != null ? checked : defaultChecked) != null ? _ref2 : false),
      inputChecked = _useState2[0],
      setInputChecked = _useState2[1];

  var onInnerBlur = useHandlerRef(function () {
    return setFocused(false);
  });
  var onInnerFocus = useHandlerRef(function () {
    return setFocused(true);
  });
  var onBlurHandler = useComposedCallbackCreator(onBlur, onInnerBlur);
  var onFocusHandler = useComposedCallbackCreator(onFocus, onInnerFocus);
  var onChangeHandler = useStaticCallbackCreator(wrapToggleOnChangeHandler, [readOnly, onChange, setInputChecked]); // if onChange is provided then the component is controlled

  var isChecked = checked != null ? checked : inputChecked;
  return React.createElement(ToggleLabel, Object.assign({}, labelProps, {
    disabled: disabled,
    readOnly: readOnly
  }), React.createElement(ToggleControl, Object.assign({}, rest, {
    "aria-invalid": invalid,
    checked: isChecked,
    disabled: disabled,
    onBlur: onBlurHandler,
    onChange: onChangeHandler,
    onFocus: onFocusHandler,
    ref: ref,
    readOnly: readOnly,
    value: value,
    type: "checkbox"
  })), React.createElement(ToggleContainer, {
    checked: isChecked,
    focused: focused,
    invalid: invalid,
    parentStyles: parentStyles,
    styles: styles,
    "$$variants": $$variants
  }, React.createElement(Toggler, {
    "data-label-content": isChecked ? rightContent : leftContent
  })), React.createElement(ToggleLabelText, Object.assign({}, labelTextProps, {
    hidden: hiddenLabel
  }), label));
})));

var TooltipComponent = /*#__PURE__*/createComponent('div', {
  displayName: 'Tooltip',
  styles: /*#__PURE__*/_extends({
    backgroundColor: "color(shadesText alpha(80%))",
    borderColor: 'color(shades if(isDark, color(shades tint(10%)), color(shades shade(10%))))',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 'controlBorderRadius',
    color: 'shades',
    fontSize: -1,
    lineHeight: '1rem',
    textAlign: 'center',
    m: 0.5,
    p: 0.5
  }, /*#__PURE__*/variantStyles('status', {
    danger: {
      backgroundColor: 'danger',
      color: 'dangerText'
    },
    info: {
      backgroundColor: 'info',
      color: 'infoText'
    },
    success: {
      backgroundColor: 'success',
      color: 'successText'
    },
    warning: {
      backgroundColor: 'warning',
      color: 'warningText'
    },
    "default": {
      backgroundColor: 'color(shadesText alpha(80%)',
      color: 'shades'
    }
  })),
  variants: [/*#__PURE__*/variant('status', true)]
});

function bindEscapeKeyDownHandlers(onKeyDownHandler) {
  if (typeof document !== 'undefined') {
    document.addEventListener('keyup', onKeyDownHandler);
    return function () {
      document.removeEventListener('keyup', onKeyDownHandler);
    };
  }
}

function cancelDebouncedVisibilityChangeOnUnmount(cancelDebouncedVisibleChanger) {
  return function () {
    return cancelDebouncedVisibleChanger();
  };
}

var tooltipPlacements = [[{
  placement: Placement.topCenter,
  horizontal: 'center',
  vertical: 'bottom'
}, {
  placement: Placement.centerLeft,
  horizontal: 'right',
  vertical: 'center'
}, {
  placement: Placement.bottomCenter,
  horizontal: 'center',
  vertical: 'top'
}, {
  placement: Placement.centerRight,
  horizontal: 'left',
  vertical: 'center'
}]];
/**
 * Tooltip component
 *
 * Simple popup that shows extra information if an element received keyboard focus
 * mouse hovers over it.
 *
 * https://www.w3.org/TR/wai-aria-practices-1.1/#tooltip
 *
 */

function Tooltip(_ref) {
  var children = _ref.children,
      content = _ref.content,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 500 : _ref$delay,
      outerId = _ref.id,
      status = _ref.status;
  var id = useUniqueId(outerId, 'tooltip');

  var _useState = useState(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var anchorRef = useRef(null);

  var _useDebouncedCallback = useDebouncedCallback(function (isVisible) {
    setVisible(isVisible);
  }, delay, [setVisible]),
      debouncedVisibleChanger = _useDebouncedCallback[0],
      cancelDebouncedVisibleChanger = _useDebouncedCallback[1];

  var onKeyDownHandler = useCallback(function (e) {
    if (e.key === 'Escape' && visible) {
      // should we add prevent default? For example if you have Dialog and there is a close button
      // with tooltip, then when you press escape it will not only close the tooltip but the dialog too
      // I think thats correct
      cancelDebouncedVisibleChanger();
      setVisible(false);
    }
  }, [cancelDebouncedVisibleChanger, visible, setVisible]);
  var onBlur = useCallback(function () {
    setVisible(false);
    cancelDebouncedVisibleChanger();
  }, [cancelDebouncedVisibleChanger]);
  var onFocus = useCallback(function () {
    debouncedVisibleChanger(true);
  }, [debouncedVisibleChanger]);
  useStaticEffect(cancelDebouncedVisibilityChangeOnUnmount, cancelDebouncedVisibleChanger);
  useStaticEffect(bindEscapeKeyDownHandlers, onKeyDownHandler);
  return React.createElement(React.Fragment, null, React.cloneElement(Children.only(children), {
    'aria-describedby': id,
    ref: anchorRef,
    onBlur: onBlur,
    onFocus: onFocus,
    onMouseLeave: onBlur,
    onMouseEnter: onFocus
  }), React.createElement(Popper, {
    anchor: anchorRef,
    "aria-hidden": !visible,
    id: id,
    open: visible,
    minHeight: 50,
    minWidth: 100,
    placement: tooltipPlacements,
    role: "tooltip"
  }, function () {
    return React.createElement(TooltipComponent, {
      status: status
    }, content);
  }));
}

/**
 * Allows to apply visage style sheet to global styles
 */

function GlobalStyles(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles;
  var ctx = useDesignSystem();
  var globalStyles = useMemo(function () {
    return ctx.resolveStyleSheets([styles]);
  }, [ctx, styles]);
  return React.createElement(Global, {
    styles: globalStyles
  });
}

var globalComponentStyles = {
  body: {
    backgroundColor: 'shades'
  },
  html: {
    backgroundColor: 'shades',
    color: 'shadesText',
    fontFamily: 'body',
    fontSize: 0,
    lineHeight: 0
  },
  // typography (keep in sync with Visage counterparts)
  a: /*#__PURE__*/_extends({}, LinkStyles, {
    face: 'Link'
  }),
  blockquote: /*#__PURE__*/_extends({}, BlockquoteStyles, {
    face: 'Blockquote'
  }),
  cite: /*#__PURE__*/_extends({}, CiteStyles, {
    face: 'Cite'
  }),
  code: /*#__PURE__*/_extends({}, CodeStyles, {
    face: 'Code'
  }),
  i: /*#__PURE__*/_extends({}, EmphasizedTextStyles, {
    face: 'EmphasizedText'
  }),
  em: /*#__PURE__*/_extends({}, EmphasizedTextStyles, {
    face: 'EmphasizedText'
  }),
  h1: /*#__PURE__*/_extends({}, HeadingStyles.h1, {
    face: 'h1'
  }),
  h2: /*#__PURE__*/_extends({}, HeadingStyles.h2, {
    face: 'h2'
  }),
  h3: /*#__PURE__*/_extends({}, HeadingStyles.h3, {
    face: 'h3'
  }),
  h4: /*#__PURE__*/_extends({}, HeadingStyles.h4, {
    face: 'h4'
  }),
  h5: /*#__PURE__*/_extends({}, HeadingStyles.h5, {
    face: 'h5'
  }),
  h6: /*#__PURE__*/_extends({}, HeadingStyles.h6, {
    face: 'h6'
  }),
  kbd: /*#__PURE__*/_extends({}, KeyboardKeyStyles, {
    face: 'KeyboardKey'
  }),
  p: /*#__PURE__*/_extends({}, ParagraphStyles, {
    face: 'Paragraph'
  }),
  pre: /*#__PURE__*/_extends({}, PreformattedCodeStyles, {
    face: 'PreformattedCode'
  }),
  samp: /*#__PURE__*/_extends({}, CodeStyles, {
    face: 'Code'
  }),
  small: /*#__PURE__*/_extends({}, SmallTextStyles, {
    face: 'SmallText'
  }),
  span: /*#__PURE__*/_extends({}, TextStyles, {
    face: 'Text'
  }),
  b: /*#__PURE__*/_extends({}, StrongTextStyles, {
    face: 'StrongText'
  }),
  strong: /*#__PURE__*/_extends({}, StrongTextStyles, {
    face: 'StrongText'
  }),
  sup: /*#__PURE__*/_extends({}, SuperscriptStyles, {
    face: 'Superscript'
  }),
  sub: /*#__PURE__*/_extends({}, SubscriptStyles, {
    face: 'Subscript'
  })
};
var globalStyles = {
  '*': {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility'
  },
  '*, *::before, *::after': {
    boxSizing: 'inherit'
  },
  body: {
    margin: 0,
    width: '100%',
    maxWidth: 'none',
    face: 'body'
  },
  html: {
    boxSizing: 'border-box',
    margin: 0,
    width: '100%',
    maxWidth: 'none',
    // https://github.com/matejlatin/Gutenberg/blob/master/src/style/layout/_base.scss#L22
    msTextSizeAdjust: '100%',
    webkitTextSizeAdjust: '100%',
    textSizeAdjust: '100%',
    face: 'html'
  }
};
/**
 * Visage's global reset
 */

function GlobalReset() {
  return React.createElement(GlobalStyles, {
    styles: globalStyles
  });
}

/**
 * Creates emotion style generator
 *
 * Be careful, this style generator doesn't generate media queries, responsivity is handled using
 * breakpoint argument.
 */

function createEmotionStyleGenerator() {
  return function (styleSheets, ctx) {
    // iterate through style sheet and map pseudos properly
    var resolvedStyleSheet = resolveStyleSheets(styleSheets, ctx);
    return {
      className: css(resolvedStyleSheet)
    };
  };
}

// tslint:disable:only-arrow-functions
// tslint:disable:object-literal-shorthand
// tslint:disable:trailing-comma
// tslint:disable:object-literal-sort-keys
// tslint:disable:one-variable-per-declaration
// tslint:disable:max-line-length
// tslint:disable:no-consecutive-blank-lines
// tslint:disable:align
var SyntaxError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(SyntaxError, _Error);

  function SyntaxError(message, expected, found, location) {
    var _this;

    _this = _Error.call(this) || this;
    _this.message = message;
    _this.expected = expected;
    _this.found = found;
    _this.location = location;
    _this.name = 'SyntaxError';

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_assertThisInitialized(_this), SyntaxError);
    }

    return _this;
  }

  SyntaxError.buildMessage = function buildMessage(expected, found) {
    function hex(ch) {
      return ch.charCodeAt(0).toString(16).toUpperCase();
    }

    function literalEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return "\\x0" + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return "\\x" + hex(ch);
      });
    }

    function classEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return "\\x0" + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return "\\x" + hex(ch);
      });
    }

    function describeExpectation(expectation) {
      switch (expectation.type) {
        case 'literal':
          return "\"" + literalEscape(expectation.text) + "\"";

        case 'class':
          var escapedParts = expectation.parts.map(function (part) {
            return Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part);
          });
          return "[" + (expectation.inverted ? '^' : '') + escapedParts + "]";

        case 'any':
          return 'any character';

        case 'end':
          return 'end of input';

        case 'other':
          return expectation.description;
      }
    }

    function describeExpected(expected1) {
      var descriptions = expected1.map(describeExpectation);
      var i;
      var j;
      descriptions.sort();

      if (descriptions.length > 0) {
        for (i = 1, j = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }

        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(', ') + ", or " + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found1) {
      return found1 ? "\"" + literalEscape(found1) + "\"" : 'end of input';
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  };

  return SyntaxError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function peg$parse(input, options) {
  options = options !== undefined ? options : {};
  var peg$FAILED = {};
  var peg$startRuleIndices = {
    start: 0
  };
  var peg$startRuleIndex = 0;
  var peg$consts = ['none', peg$literalExpectation('none', false), 'initial', peg$literalExpectation('initial', false), 'inherit', peg$literalExpectation('inherit', false), 'unset', peg$literalExpectation('unset', false), function (bss) {
    return bss;
  }, 'inset', peg$literalExpectation('inset', false), function (col) {
    return {
      color: col
    };
  }, 'rgb', peg$literalExpectation('rgb', false), 'hsl', peg$literalExpectation('hsl', false), 'a', peg$literalExpectation('a', false), '(', peg$literalExpectation('(', false), ')', peg$literalExpectation(')', false), 'color(', peg$literalExpectation('color(', false), '#', peg$literalExpectation('#', false), /^[a-zA-Z]/, peg$classExpectation([['a', 'z'], ['A', 'Z']], false, false), '.', peg$literalExpectation('.', false), '-', peg$literalExpectation('-', false), /^[0-9]/, peg$classExpectation([['0', '9']], false, false), /^[a-z]/, peg$classExpectation([['a', 'z']], false, false), '+', peg$literalExpectation('+', false), 'if(', peg$literalExpectation('if(', false), 'ifDark', peg$literalExpectation('ifDark', false), 'ifLight', peg$literalExpectation('ifLight', false), 'blenda', peg$literalExpectation('blenda', false), 'blend', peg$literalExpectation('blend', false), /^[0-9a-fA-F]/, peg$classExpectation([['0', '9'], ['a', 'f'], ['A', 'F']], false, false), '%', peg$literalExpectation('%', false), peg$otherExpectation('whitespace'), /^[ \t\n\r,]/, peg$classExpectation([' ', '\t', '\n', '\r', ','], false, false)];
  var peg$bytecode = [peg$decode('2 ""6 7!.` &2"""6"7#.T &2$""6$7%.H &2&""6&7\'.< &%$;!/&#0#*;!&&&#/\' 8!:(!! )'), peg$decode(';".) &;#.# &;$'), peg$decode("%;3/\x96#2)\"\"6)7*.\" &\"/\x82$;3/y$;*/p$;3/g$;*/^$;3/U$;*/L$;3/C$;*/:$;3/1$;%/($8,:+,! )(,'#(+'#(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#"), peg$decode("%;3/\x84#2)\"\"6)7*.\" &\"/p$;3/g$;*/^$;3/U$;*/L$;3/C$;*/:$;3/1$;%/($8*:+*! )(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#"), peg$decode("%;3/r#2)\"\"6)7*.\" &\"/^$;3/U$;*/L$;3/C$;*/:$;3/1$;%/($8(:+(! )(('#(''#(&'#(%'#($'#(#'#(\"'#&'#"), peg$decode('%;\'./ &;&.) &;(.# &;)/"!&,)'), peg$decode('%2,""6,7-.) &2.""6.7//\xAB#20""6071." &"/\x97$22""6273/\x88$;3/\x7F$;2/v$;3/m$;2/d$;3/[$;2/R$;3/I$;0." &"/;$;3/2$24""6475/#$+-)(-\'#(,\'#(+\'#(*\'#()\'#((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#'), peg$decode("%26\"\"6677/f#;3/]$;%/T$;3/K$$;+0#*;+&/;$;3/2$24\"\"6475/#$+')(''#(&'#(%'#($'#(#'#(\"'#&'#"), peg$decode("%28\"\"6879/\x85#%;//P#;//G$;//>$;//5$;//,$;//#$+&)(&'#(%'#($'#(#'#(\"'#&'#.? &%;//5#;//,$;//#$+#)(#'#(\"'#&'#/#$+\")(\"'#&'#"), peg$decode('%%$4:""5!7;/,#0)*4:""5!7;&&&#/w#%2<""6<7=/Y#2>""6>7?." &"/E$$4@""5!7A/,#0)*4@""5!7A&&&#/#$+#)(#\'#("\'#&\'#." &"/#$+")("\'#&\'#/"!&,)'), peg$decode('%%2>""6>7?." &"/,#;0/#$+")("\'#&\'#.U &%2<""6<7=/E#$4@""5!7A/,#0)*4@""5!7A&&&#/#$+")("\'#&\'#/?#$4:""5!7;0)*4:""5!7;&/#$+")("\'#&\'#'), peg$decode("%;3/A#;-.) &;..# &;,/,$;3/#$+#)(#'#(\"'#&'#"), peg$decode('%$4B""5!7C/,#0)*4B""5!7C&&&#/\x8A#22""6273/{$;3/r$2D""6D7E.) &2>""6>7?." &"/R$;3/I$;2." &"/;$;3/2$24""6475/#$+()((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#'), peg$decode("%2F\"\"6F7G/\xB3#;3/\xAA$$4:\"\"5!7;/,#0)*4:\"\"5!7;&&&#/\x88$;3/\x7F$;'./ &;&.) &;(.# &;)/d$;3/[$;'./ &;&.) &;(.# &;).\" &\"/;$;3/2$24\"\"6475/#$+))()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#"), peg$decode('%2H""6H7I.A &2J""6J7K.5 &2L""6L7M.) &2N""6N7O/\x85#22""6273/v$;3/m$;\'./ &;&.) &;(.# &;)/R$;3/I$;1." &"/;$;3/2$24""6475/#$+()((\'#(\'\'#(&\'#(%\'#($\'#(#\'#("\'#&\'#'), peg$decode('4P""5!7Q'), peg$decode('%$4@""5!7A/,#0)*4@""5!7A&&&#/c#%2<""6<7=/E#$4@""5!7A/,#0)*4@""5!7A&&&#/#$+")("\'#&\'#." &"/#$+")("\'#&\'#'), peg$decode('%;0/2#2R""6R7S/#$+")("\'#&\'#'), peg$decode(';1.# &;0'), peg$decode('<$4U""5!7V0)*4U""5!7V&=." 7T')];
  var peg$currPos = 0;
  var peg$posDetailsCache = [{
    line: 1,
    column: 1
  }];
  var peg$maxFailPos = 0;
  var peg$maxFailExpected = [];
  var peg$silentFails = 0;
  var peg$result;

  if (options.startRule !== undefined) {
    if (!(options.startRule in peg$startRuleIndices)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleIndex = peg$startRuleIndices[options.startRule];
  }

  function peg$literalExpectation(text1, ignoreCase) {
    return {
      type: 'literal',
      text: text1,
      ignoreCase: ignoreCase
    };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return {
      type: 'class',
      parts: parts,
      inverted: inverted,
      ignoreCase: ignoreCase
    };
  }

  function peg$endExpectation() {
    return {
      type: 'end'
    };
  }

  function peg$otherExpectation(description) {
    return {
      type: 'other',
      description: description
    };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos];
    var p;

    if (details) {
      return details;
    }

    p = pos - 1;

    while (!peg$posDetailsCache[p]) {
      p--;
    }

    details = peg$posDetailsCache[p];
    details = {
      line: details.line,
      column: details.column
    };

    while (p < pos) {
      if (input.charCodeAt(p) === 10) {
        details.line++;
        details.column = 1;
      } else {
        details.column++;
      }

      p++;
    }

    peg$posDetailsCache[pos] = details;
    return details;
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos);
    var endPosDetails = peg$computePosDetails(endPos);
    return {
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected1) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected1);
  }

  function peg$buildStructuredError(expected1, found, location1) {
    return new SyntaxError(SyntaxError.buildMessage(expected1, found), expected1, found, location1);
  }

  function peg$decode(s) {
    return s.split('').map(function (ch) {
      return ch.charCodeAt(0) - 32;
    });
  }

  function peg$parseRule(index) {
    var bc = peg$bytecode[index];
    var ip = 0;
    var ips = [];
    var end = bc.length;
    var ends = [];
    var stack = [];
    var params;

    while (true) {
      while (ip < end) {
        switch (bc[ip]) {
          case 0:
            stack.push(peg$consts[bc[ip + 1]]);
            ip += 2;
            break;

          case 1:
            stack.push(undefined);
            ip++;
            break;

          case 2:
            stack.push(null);
            ip++;
            break;

          case 3:
            stack.push(peg$FAILED);
            ip++;
            break;

          case 4:
            stack.push([]);
            ip++;
            break;

          case 5:
            stack.push(peg$currPos);
            ip++;
            break;

          case 6:
            stack.pop();
            ip++;
            break;

          case 7:
            peg$currPos = stack.pop();
            ip++;
            break;

          case 8:
            stack.length -= bc[ip + 1];
            ip += 2;
            break;

          case 9:
            stack.splice(-2, 1);
            ip++;
            break;

          case 10:
            stack[stack.length - 2].push(stack.pop());
            ip++;
            break;

          case 11:
            stack.push(stack.splice(stack.length - bc[ip + 1], bc[ip + 1]));
            ip += 2;
            break;

          case 12:
            stack.push(input.substring(stack.pop(), peg$currPos));
            ip++;
            break;

          case 13:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

            if (stack[stack.length - 1]) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }

            break;

          case 14:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

            if (stack[stack.length - 1] === peg$FAILED) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }

            break;

          case 15:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

            if (stack[stack.length - 1] !== peg$FAILED) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }

            break;

          case 16:
            if (stack[stack.length - 1] !== peg$FAILED) {
              ends.push(end);
              ips.push(ip);
              end = ip + 2 + bc[ip + 1];
              ip += 2;
            } else {
              ip += 2 + bc[ip + 1];
            }

            break;

          case 17:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

            if (input.length > peg$currPos) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }

            break;

          case 18:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

            if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length) === peg$consts[bc[ip + 1]]) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }

            break;

          case 19:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

            if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length).toLowerCase() === peg$consts[bc[ip + 1]]) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }

            break;

          case 20:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

            if (peg$consts[bc[ip + 1]].test(input.charAt(peg$currPos))) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }

            break;

          case 21:
            stack.push(input.substr(peg$currPos, bc[ip + 1]));
            peg$currPos += bc[ip + 1];
            ip += 2;
            break;

          case 22:
            stack.push(peg$consts[bc[ip + 1]]);
            peg$currPos += peg$consts[bc[ip + 1]].length;
            ip += 2;
            break;

          case 23:
            stack.push(peg$FAILED);

            if (peg$silentFails === 0) {
              peg$fail(peg$consts[bc[ip + 1]]);
            }

            ip += 2;
            break;

          case 24:
            ip += 2;
            break;

          case 25:
            ip++;
            break;

          case 26:
            params = bc.slice(ip + 4, ip + 4 + bc[ip + 3]).map(function (p) {
              return stack[stack.length - 1 - p];
            });
            stack.splice(stack.length - bc[ip + 2], bc[ip + 2], peg$consts[bc[ip + 1]].apply(null, params));
            ip += 4 + bc[ip + 3];
            break;

          case 27:
            stack.push(peg$parseRule(bc[ip + 1]));
            ip += 2;
            break;

          case 28:
            peg$silentFails++;
            ip++;
            break;

          case 29:
            peg$silentFails--;
            ip++;
            break;

          default:
            throw new Error("Invalid opcode: " + bc[ip] + ".");
        }
      }

      if (ends.length > 0) {
        end = ends.pop();
        ip = ips.pop();
      } else {
        break;
      }
    }

    return stack[0];
  }

  peg$result = peg$parseRule(peg$startRuleIndex);

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  }

  if (peg$result !== peg$FAILED && peg$currPos < input.length) {
    peg$fail(peg$endExpectation());
  }

  throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
}

var parse = peg$parse;

/**
 * Resolves box shadow agains theme and then tries to resolve colors against theme
 */

var boxShadow = function resolveBoxShadow(propName, value, ctx) {
  // first try to resolvea against theme
  // and then apply colors
  var themeKeyValue = ctx.resolvers.themeKey(propName, value, ctx);

  if (!ctx.resolvers.color) {
    throw new Error('Color resolver is missing');
  }

  if (typeof themeKeyValue === 'string') {
    try {
      var result = parse(themeKeyValue);

      if (Array.isArray(result)) {
        // parser, try to map colors
        return result.reduce(function (finalBoxShadow, _ref) {
          var color = _ref.color;
          return finalBoxShadow.replace(color, ctx.resolvers.color('color', color, ctx));
        }, themeKeyValue);
      }
    } catch (e) {// do nothing, returns as is
    }
  }

  return themeKeyValue;
};
/**
 * Resolver responsible for calculating sizes based on base grid size
 * and multiplier
 */

var gridSize = function gridSize(propName, value, _ref2) {
  var theme = _ref2.theme;
  var numericValue = Number(value);

  if (!Number.isNaN(numericValue)) {
    return theme.baseGridSize * numericValue;
  }

  return value;
};

var index = {
  __proto__: null,
  boxShadow: boxShadow,
  gridSize: gridSize
};

var stylers = {
  boxShadow: {
    resolver: 'boxShadow'
  },
  m: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['margin']
  },
  margin: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  my: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['marginTop', 'marginBottom']
  },
  mx: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['marginLeft', 'marginRight']
  },
  mb: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['marginBottom']
  },
  marginBottom: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  marginLeft: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  marginRight: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  marginTop: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  ml: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['marginLeft']
  },
  mr: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['marginRight']
  },
  mt: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['marginTop']
  },
  p: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['padding']
  },
  padding: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  py: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['paddingTop', 'paddingBottom']
  },
  px: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['paddingLeft', 'paddingRight']
  },
  paddingBottom: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  paddingLeft: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  paddingRight: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  paddingTop: {
    format: 'sizeUnit',
    resolver: 'gridSize'
  },
  pb: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['paddingBottom']
  },
  pl: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['paddingLeft']
  },
  pr: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['paddingRight']
  },
  pt: {
    format: 'sizeUnit',
    resolver: 'gridSize',
    outputProps: ['paddingTop']
  },
  height: {
    format: 'sizeUnit'
  },
  width: {
    format: 'sizeUnit'
  }
};

/**
 * Creates N-point font scale theme
 */

function createNPointFontScaleTheme(settings) {
  return createTheme({
    resolvers: {
      boxShadow: boxShadow,
      gridSize: gridSize,
      scaleSize: function scaleSize(propName, value, ctx) {
        var numericValue = Number(value);

        if (!Number.isNaN(numericValue)) {
          var val = getScaleValue(settings.fontSize, numericValue);
          return Array.isArray(val) ? getResponsiveValue(ctx.breakpoint, getScaleValue(settings.fontSize, numericValue)) : val;
        }

        return value;
      },
      scaleLineHeight: function scaleLineHeight(propName, value, ctx) {
        var numericValue = Number(value);

        if (!Number.isNaN(numericValue)) {
          var val = getScaleValue(settings.lineHeights, numericValue);
          return Array.isArray(val) ? getResponsiveValue(ctx.breakpoint, getScaleValue(settings.lineHeights, numericValue)) : val;
        }

        return value;
      }
    },
    stylers: _extends({
      fontSize: {
        format: 'px',
        resolver: 'scaleSize'
      },

      /**
       * Calculates fontSize and lineHeight for svg icons
       */
      iconSize: {
        format: 'px',
        resolver: 'scaleLineHeight',
        outputProps: ['fontSize', 'lineHeight']
      },
      lineHeight: {
        format: 'px',
        resolver: 'scaleLineHeight'
      },

      /**
       * Calculates a height based similarly to lineHeight
       */
      linedHeight: {
        format: 'px',
        resolver: 'scaleLineHeight',
        outputProps: ['height']
      },
      linedWidth: {
        format: 'px',
        resolver: 'scaleLineHeight',
        outputProps: ['width']
      }
    }, stylers),
    theme: settings
  });
}

var MOBILE_BP = "(max-width: " + 767 / 16 + "em)";
var TABLET_BP = "(min-width: " + 768 / 16 + "em) and (max-width: " + 1024 / 16 + "em)";
var DESKTOP_BP = "(min-width: " + 1025 / 16 + "em)";
var defaultBreakpoints = [MOBILE_BP, TABLET_BP, DESKTOP_BP];
var defaultStyleGenerator = /*#__PURE__*/createEmotionStyleGenerator();
var defaultTheme = /*#__PURE__*/createNPointFontScaleTheme({
  borderRadius: {
    controlBorderRadius: 6,
    keyboardBorderRadius: 3
  },
  fontSize: {
    values: [10, 12, 14, 16, 20, 24, 28, 32, 40, 48],
    offset: 2
  },
  lineHeights: {
    values: [18, 20, 22, 24, 28, 32, 36, 40, 48, 56],
    offset: 2
  },
  baseGridSize: 8,
  fontFamily: {
    body: 'Open Sans,sans-serif',
    heading: 'Nunito Sans,sans-serif'
  },
  colors: {
    neutral: 'rgb(227, 232, 238)',
    neutralText: 'color(neutral, contrast())',
    darkShades: 'rgb(27, 38, 44)',
    darkShadesText: 'color(darkShades, contrast())',
    accent: 'rgb(219, 226, 239)',
    accentText: 'color(accent, contrast())',
    shades: 'rgb(255, 255, 255)',
    shadesText: 'color(shades, contrast())',
    primary: 'rgb(31, 167, 236)',
    primaryText: 'color(primary, contrast())',
    success: 'rgb(39, 174, 96)',
    successText: 'color(success, contrast())',
    danger: 'rgb(192, 57, 43)',
    dangerText: 'color(danger, contrast())',
    info: 'rgb(41, 128, 185)',
    infoText: 'color(info, contrast())',
    warning: 'rgb(241, 196, 15)',
    warningText: 'color(warning, contrast())'
  }
});

var DesignSystem = function DesignSystem(_ref) {
  var _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? defaultBreakpoints : _ref$breakpoints,
      children = _ref.children,
      _ref$defaultZIndex = _ref.defaultZIndex,
      defaultZIndex = _ref$defaultZIndex === void 0 ? 100 : _ref$defaultZIndex,
      disableGlobalStyles = _ref.disableGlobalStyles,
      _ref$is = _ref.is,
      is = _ref$is === void 0 ? 0 : _ref$is,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? false : _ref$responsive,
      _ref$styleGenerator = _ref.styleGenerator,
      styleGenerator = _ref$styleGenerator === void 0 ? defaultStyleGenerator : _ref$styleGenerator,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? defaultTheme : _ref$theme;

  var _useState = useState(0),
      idContextValue = _useState[0];

  var toastEventEmitter = useEventEmitterInstance();

  var _useBreakpointManager = useBreakpointManager(is, breakpoints),
      breakpoint = _useBreakpointManager[0],
      setBreakpoint = _useBreakpointManager[1];

  useBreakpointDetection(responsive, breakpoints, setBreakpoint);
  return React.createElement(DesignSystem$1, {
    is: breakpoint,
    styleGenerator: styleGenerator,
    theme: theme
  }, React.createElement(CloseListenerManager, null, React.createElement(UniqueIdContextProvider, {
    id: idContextValue
  }, React.createElement(LayerManager, {
    increaseBy: defaultZIndex
  }, React.createElement(GlobalReset, null), disableGlobalStyles ? null : React.createElement(GlobalStyles, {
    styles: globalComponentStyles
  }), React.createElement(EventEmitterContext.Provider, {
    value: toastEventEmitter
  }, React.createElement(ToastManager, null), children)))));
};

function ResponsiveDesignSystem(_ref) {
  var restProps = _extends({}, _ref);

  return React.createElement(DesignSystem, Object.assign({}, restProps, {
    responsive: true
  }));
}

/**
 * Generates styles with media queries
 */

function createResponsiveEmotionStyleGenerator(
/**
 * Media queries sorted from smallest to largest device
 *
 * Please provide only conditions e.g. only screen or screen and (min-width: 40em)
 */
mediaQueries) {
  return function (styleSheets, ctx) {
    var sheet = {}; // iterate through media queries and resolve style for them

    mediaQueries.forEach(function (mediaQuery, breakpoint) {
      // @todo investigate whether to use cache here too
      sheet["@media " + mediaQuery] = resolveStyleSheets(styleSheets, _extends({}, ctx, {
        breakpoint: breakpoint
      }));
    });
    return {
      className: css(sheet)
    };
  };
}

export { Accordion, AccordionItem, AutocompleteInput, Badge, Banner, BaseListItem, BasePopover, Blockquote, BlockquoteStyles, Box, BoxSkeleton, Button, Card, CheckIcon, Checkbox, CheckboxToggler, Chip, Cite, CiteStyles, CloseButton, CloseIcon, CloseListenerManager, CloseListenerManagerContext, Code, CodeStyles, CollapseUpIcon, CollapsibleList, Column, Container, DangerIcon, DataTable, DataTableBody, DataTableColumn, DataTableColumnSkeleton, DataTableFooter, DataTableFooterRow, DataTableHeader, DataTableHeaderColumn, DataTableHeaderRow, DataTableNumericColumnSkeleton, DataTableRow, DescriptionList, DescriptionListItem, DescriptionListItemDescription, DescriptionListItemTerm, DesignSystem, Dialog, Divider, Drawer, DrawerPosition, EmphasizedText, EmphasizedTextStyles, ErrorIcon, ExpandDownIcon, FieldSet, FileInput, Flex, FormField, GlobalReset, GlobalStyles, Grid, Header, Heading, HeadingSkeleton, HeadingStyles, IconButton, Image, InfoIcon, InlineError, KeyboardKey, KeyboardKeyStyles, Label, LayerManager, LayerManagerContext, Link, LinkStyles, List, ListContainer, ListHeader, ListItem, ListItemLink, ListItemsContainer, Loading, Menu, MenuItem, Message, Modal, NeutralMessageIcon, NextPageIcon, Pagination, PaginationNextPageButton, PaginationPreviousPageButton, Paragraph, ParagraphSkeleton, ParagraphStyles, Placement, Popover, Popper, Portal, PreformattedCode, PreformattedCodeStyles, PreviousPageIcon, ProgressBar, Quote, QuoteStyles, Radio, RadioToggler, ResponsiveDesignSystem, Row, Select, SkeletonSentence, Slider, SliderDirection, SliderThumb, SliderTrack, SliderTrackProgress, SmallText, SmallTextStyles, SpinButton, Spinner, SpinnerIcon, StrongText, StrongTextStyles, Subscript, SubscriptStyles, SuccessIcon, Superscript, SuperscriptStyles, Svg, SvgIcon, Tab, Tabs, Text, TextArea, TextInput, TextInputBaseStyles, TextSkeleton, TextStyles, Toast, ToastManager, Toggle, Tooltip, UnfoldLessIcon, UnfoldMoreIcon, WarningIcon, booleanVariant, booleanVariantStyles, createAutocompleteInputMenu, createControlActiveShadow, createControlFocusShadow, createControlHoverShadow, createEmotionStyleGenerator, createNPointFontScaleTheme, createResponsiveEmotionStyleGenerator, createSelectMenu, createSurfaceFocusShadow, createTheme, defaultBreakpoints, index as defaultResolvers, defaultStyleGenerator, stylers as defaultStylers, defaultTheme, globalComponentStyles, numberProp, useAutofocusOnMount, useBreakpointDetection, useCloseListenerManager, useCombinedRef, useComposedCallbackCreator, useDebouncedCallback, useFocusTrap, useFocusTrapCallback, useHandlerRef, useLayerManager, useOnRenderEffect, useStaticEffect, useStaticOnRenderEffect, useUniqueId, variant, variantStyles };
//# sourceMappingURL=byteclaw.visage.esm.js.map
